``
<template>
  <div style="width: 100%; height: calc(100% - 75px); margin: 0 !important">
    <sh-page theme="light">
      <!-- <recomendations-modal
        ref="childRecomendationsModal"
        v-if="reccomendations.length"
      ></recomendations-modal> -->
      <recommendation-assignments
        ref="childRecomendationsModal"
        :selecteddivision="selecteddivision"
        :travel_time_map="travel_time_map"
        :zone_travel_time_map="zone_travel_time_map"
        v-if="reccomendations.length"
      ></recommendation-assignments>
      <recommendation-rejected
        :selecteddivision="selecteddivision"
        v-if="reccomendations.length"
      ></recommendation-rejected>
      <training-recommendation>
        v-if="trainingReccomendations.length"
      </training-recommendation>

      <sh-nav-bar slot="nav">
        <sh-tabs>
          <sh-tab-item
            v-for="(item, index) in navBarTrabs"
            :label="item.name"
            :key="index"
            :active="item.current"
            @click="changeNavBarTab(item)"
          ></sh-tab-item
        ></sh-tabs>
        <sh-dropdown
          style="width: 430px"
          slot="functions"
          label="Search (by CSE name or Id / FL Ship To name or Id)"
          :value="selectedFlCse"
          editable="true"
        >
          <sh-menu-item
            v-for="(item, index) in flsCsesNames"
            :key="index"
            :label="item.name"
            :active="item.name == selectedFlCse"
            @click.prevent="searchItemByNameDrop"
            @keyup.enter="searchItemByNameDrop"
          >
          </sh-menu-item>
        </sh-dropdown>

        <sh-button
          slot="functions"
          label="Back to Area Selection"
          icon="reset"
          color="secondary"
          tooltip="left"
          @click="goToFirstPage"
        ></sh-button>
      </sh-nav-bar>

      <sh-pane
        v-if="displayReccomendModal"
        slot="left"
        behavior="collapse"
        :size="collapseRecPane"
      >
        <div
          v-if="activeNavBarTabName == 'Assignments'"
          style="display: flex; height: 100%"
        >
          <div
            style="
              display: grid;
              place-items: start center;
              flex: 0 0 15%;
              height: 100%;
            "
          >
            <sh-tabs
              style="
                transform: rotate(-90deg) translateX(-50%);
                width: fit-content;
              "
              condensed="true"
            >
              <sh-tab-item
                v-for="(item, index) in paneTabs"
                :label="item.name + totalItemsInCategory(item.name)"
                :key="index"
                :active="item.current"
                :disabled="item.disabled"
                @click="changePaneTab(item)"
              ></sh-tab-item>
            </sh-tabs>
          </div>
          <div style="flex: 0 0 85%; height: 100%; padding-left: 8px">
            <div
              v-if="activePaneTabName == 'History'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">History</sh-text>
              <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Pending')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Pending") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Pending')"
                  :key="'actmenukeyPend' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>

                      <sh-text v-if="it.status == 'Pending'"
                        >Pending since: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        v-if="
                          it.status == 'Pending' &&
                          it.is_user_provided_assignment !== 1
                        "
                        @click="
                          resetPendingActionHist({
                            actHist: it,
                            area: area,
                            selecteddivision: selecteddivision,
                          })
                        "
                        label="Reset"
                        icon="reset"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                      <sh-button
                        v-if="
                          it.status == 'Pending' &&
                          it.is_user_provided_assignment == 1
                        "
                        @click="
                          deletePendingActionHist({
                            actHist: it,
                            area: area,
                            selecteddivision: selecteddivision,
                          })
                        "
                        label="Delete"
                        icon="delete"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
              <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Exported')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Exported") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Exported')"
                  :key="'actmenukeyExp' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>
                      <sh-text v-if="it.status == 'Exported'"
                        >Sent to DMG on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
              <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Implemented')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
                ><div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Implemented") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Implemented')"
                  :key="'actmenukeyImpl' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>

                      <sh-text v-if="it.status == 'Implemented'"
                        >Implemented on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
            </div>

            <div
              v-if="activePaneTabName == 'Recommendations'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">Recommendations</sh-text>
              <sh-wrapper
                direction="row"
                spacing="s"
                style="margin-bottom: 5px"
              >
                <sh-icon
                  icon="refresh"
                  size="m"
                  id="refresh-icon"
                  button
                  @click="callGetRecommend"
                ></sh-icon>
                <sh-tooltip
                  label="Refresh"
                  target="refresh-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="filter"
                  size="m"
                  id="filter-icon"
                  :color="filterButtonColor"
                  button
                  @click="toggleFilter"
                >
                </sh-icon>
                <sh-tooltip
                  label="Filter"
                  target="filter-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="download"
                  size="m"
                  id="export-icon"
                  button
                  @click="exportPendingRecommend"
                >
                </sh-icon>
                <sh-tooltip
                  label="Download"
                  target="export-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
              </sh-wrapper>
              <!-- <sh-divider></sh-divider> -->
              <sh-text
                v-if="filteredRecommendGroupedByCSE_recommended.size === 0"
                >No recommendation available</sh-text
              >

              <sh-menu-item
                v-for="(
                  item, index
                ) in filteredRecommendGroupedByCSE_recommended"
                :key="'csemenu' + index"
                label=""
                :active="item[0] === selectedCSEidRecList"
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="clickCSEName({ e: $event, elem: item })"
                expanded="true"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getCSEName(item[0]) }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in item[1]"
                  :key="'menukey' + index + '_' + idx"
                  label=" "
                  label-rows="2"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="
                    clickItemCSEMenu({
                      e: $event,
                      elem: item,
                      it: it,
                      idx: idx,
                    })
                  "
                >
                  <div slot="functions" class="recItemMenu">
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >

                    <sh-text v-if="it.status !== 'Review'"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text v-if="it.status !== 'Review'"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >Status: {{ getReviewDescription(it.status) }}</sh-text
                    >
                    <sh-wrapper
                      direction="row"
                      spacing="s"
                      style="flex-wrap: nowrap"
                    >
                      <sh-text v-if="it.status !== 'Review'"
                        >Status: {{ getReviewDescription(it.status) }}
                      </sh-text>
                      <sh-icon
                        v-if="showWarningIconCSEmenu(index, idx)"
                        icon="warning-triangle"
                        size="s"
                        :id="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                      ></sh-icon>
                      <sh-tooltip
                        style="word-break: keep-all"
                        v-if="showWarningIconCSEmenu(index, idx)"
                        :label="getIconLabelCSEmenu(index, idx)"
                        :target="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                        placement="right"
                        variation="short"
                      ></sh-tooltip>
                    </sh-wrapper>
                  </div>
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.summary }}</sh-text>
                      <!-- <sh-text>{{ it.description }}</sh-text> -->
                      <sh-text v-if="it.status === 'Review'"
                        >Posted on:
                        {{ getLocalTime(it.time_recommended) }}</sh-text
                      >
                      <sh-text v-if="it.status !== 'Review'"
                        >Modified on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        @click="openEditModalCSEmenu(it)"
                        label="Edit"
                        icon="edit"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
            </div>
            <div
              v-if="activePaneTabName == 'Installation FLs'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">Installation FLs</sh-text>
              <sh-wrapper
                direction="row"
                spacing="s"
                style="margin-bottom: 5px"
              >
                <sh-icon
                  icon="refresh"
                  size="m"
                  id="refresh-icon"
                  button
                  @click="callGetRecommend"
                ></sh-icon>
                <sh-tooltip
                  label="Refresh"
                  target="refresh-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="filter"
                  size="m"
                  id="filter-icon"
                  :color="filterButtonColor"
                  button
                  @click="toggleFilter"
                >
                </sh-icon>
                <sh-tooltip
                  label="Filter"
                  target="filter-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="download"
                  size="m"
                  id="export-icon"
                  button
                  @click="exportPendingRecommend"
                >
                </sh-icon>
                <sh-tooltip
                  label="Download"
                  target="export-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
              </sh-wrapper>
              <sh-text
                v-if="filteredRecommendGroupedByCSE_installation.size === 0"
                >No installation fl recommendation available</sh-text
              >

              <sh-menu-item
                v-for="(
                  item, index
                ) in filteredRecommendGroupedByCSE_installation"
                :key="'instlmenu' + index"
                label=""
                :active="item[0] === selectedCSEidRecList"
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="clickCSEName({ e: $event, elem: item })"
                expanded="true"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getCSEName(item[0]) }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in item[1]"
                  :key="'instlkey' + index + '_' + idx"
                  label=" "
                  label-rows="2"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="
                    clickItemCSEMenu({
                      e: $event,
                      elem: item,
                      it: it,
                      idx: idx,
                    })
                  "
                >
                  <div slot="functions" class="recItemMenu">
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >
                    <sh-text v-if="it.status !== 'Review'"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text v-if="it.status !== 'Review'"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >Status: {{ getReviewDescription(it.status) }}</sh-text
                    >
                    <sh-wrapper
                      direction="row"
                      spacing="s"
                      style="flex-wrap: nowrap"
                    >
                      <sh-text v-if="it.status !== 'Review'"
                        >Status: {{ getReviewDescription(it.status) }}
                      </sh-text>
                      <sh-icon
                        v-if="showWarningIconCSEmenu(index, idx)"
                        icon="warning-triangle"
                        size="s"
                        :id="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                      ></sh-icon>
                      <sh-tooltip
                        style="word-break: keep-all"
                        v-if="showWarningIconCSEmenu(index, idx)"
                        :label="getIconLabelCSEmenu(index, idx)"
                        :target="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                        placement="right"
                        variation="short"
                      ></sh-tooltip>
                    </sh-wrapper>
                  </div>
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.summary }}</sh-text>
                      <sh-text v-if="it.status === 'Review'"
                        >Posted on:
                        {{ getLocalTime(it.time_recommended) }}</sh-text
                      >
                      <sh-text v-if="it.status !== 'Review'"
                        >Modified on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        @click="openEditModalCSEmenu(it)"
                        label="Edit"
                        icon="edit"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
            </div>
            <div
              v-if="activePaneTabName == 'RBD Compliance'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">RBD Compliance</sh-text>
              <sh-wrapper
                direction="row"
                spacing="s"
                style="margin-bottom: 5px"
              >
                <sh-icon
                  icon="refresh"
                  size="m"
                  id="refresh-icon"
                  button
                  @click="callGetRecommend"
                ></sh-icon>
                <sh-tooltip
                  label="Refresh"
                  target="refresh-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="filter"
                  size="m"
                  id="filter-icon"
                  :color="filterButtonColor"
                  button
                  @click="toggleFilter"
                >
                </sh-icon>
                <sh-tooltip
                  label="Filter"
                  target="filter-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
                <sh-icon
                  icon="download"
                  size="m"
                  id="export-icon"
                  button
                  @click="exportPendingRecommend"
                >
                </sh-icon>
                <sh-tooltip
                  label="Download"
                  target="export-icon"
                  placement="bottom-right"
                  variation="short"
                ></sh-tooltip>
              </sh-wrapper>
              <sh-text v-if="filteredRecommendGroupedByCSE_rbd.size === 0"
                >No rbd compliance recommendation available</sh-text
              >

              <sh-menu-item
                v-for="(item, index) in filteredRecommendGroupedByCSE_rbd"
                :key="'rbdmenu' + index"
                label=""
                :active="item[0] === selectedCSEidRecList"
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="clickCSEName({ e: $event, elem: item })"
                expanded="true"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getCSEName(item[0]) }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in item[1]"
                  :key="'rbdlkey' + index + '_' + idx"
                  label=" "
                  label-rows="2"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="
                    clickItemCSEMenu({
                      e: $event,
                      elem: item,
                      it: it,
                      idx: idx,
                    })
                  "
                >
                  <div slot="functions" class="recItemMenu">
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >
                    <sh-text v-if="it.status !== 'Review'"
                      >{{ getFLName(it.new_assignments[0].FLID) }},
                      {{ getFLCity(it.new_assignments[0].FLID) }}</sh-text
                    >
                    <sh-text v-if="it.status !== 'Review'"
                      >[{{ getFlDesc(it.new_assignments[0].FLID) }}]</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >Status: {{ getReviewDescription(it.status) }}</sh-text
                    >
                    <sh-wrapper
                      direction="row"
                      spacing="s"
                      style="flex-wrap: nowrap"
                    >
                      <sh-text v-if="it.status !== 'Review'"
                        >Status: {{ getReviewDescription(it.status) }}
                      </sh-text>
                      <sh-icon
                        v-if="showWarningIconCSEmenu(index, idx)"
                        icon="warning-triangle"
                        size="s"
                        :id="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                      ></sh-icon>
                      <sh-tooltip
                        style="word-break: keep-all"
                        v-if="showWarningIconCSEmenu(index, idx)"
                        :label="getIconLabelCSEmenu(index, idx)"
                        :target="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                        placement="right"
                        variation="short"
                      ></sh-tooltip>
                    </sh-wrapper>
                  </div>
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.summary }}</sh-text>
                      <sh-text v-if="it.status === 'Review'"
                        >Posted on:
                        {{ getLocalTime(it.time_recommended) }}</sh-text
                      >
                      <sh-text v-if="it.status !== 'Review'"
                        >Modified on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        @click="openEditModalCSEmenu(it)"
                        label="Edit"
                        icon="edit"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
            </div>
          </div>
        </div>

        <div
          v-if="activeNavBarTabName == 'Trainings'"
          style="display: flex; height: 100%"
        >
          <div
            style="
              display: grid;
              place-items: start center;
              flex: 0 0 15%;
              height: 100%;
            "
          >
            <sh-tabs
              style="
                transform: rotate(-90deg) translateX(-50%);
                width: fit-content;
              "
              condensed="true"
            >
              <sh-tab-item
                v-for="(item, index) in trainingsTabs"
                :label="item.name + totalItemsInTrainingCategory(item.name)"
                :key="index"
                :active="item.current"
                :disabled="item.disabled"
                @click="changeTrainingsTab(item)"
              ></sh-tab-item>
            </sh-tabs>
          </div>
          <div style="flex: 0 0 85%; height: 100%; padding-left: 8px">
            <div
              v-if="activeTrainingsTabName == 'History'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">History</sh-text>
              <!-- <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Pending')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Pending") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Pending')"
                  :key="'actmenukeyPend' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>

                      <sh-text v-if="it.status == 'Pending'"
                        >Pending since: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        v-if="
                          it.status == 'Pending' &&
                          it.is_user_provided_assignment !== 1
                        "
                        @click="
                          resetPendingActionHist({
                            actHist: it,
                            area: area,
                            selecteddivision: selecteddivision,
                          })
                        "
                        label="Reset"
                        icon="reset"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                      <sh-button
                        v-if="
                          it.status == 'Pending' &&
                          it.is_user_provided_assignment == 1
                        "
                        @click="
                          deletePendingActionHist({
                            actHist: it,
                            area: area,
                            selecteddivision: selecteddivision,
                          })
                        "
                        label="Delete"
                        icon="delete"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
              <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Exported')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Exported") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Exported')"
                  :key="'actmenukeyExp' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>
                      <sh-text v-if="it.status == 'Exported'"
                        >Sent to DMG on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
              <sh-menu-item
                expanded="true"
                v-if="actionsGroupedByStatus.has('Implemented')"
                label=""
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="blockEvent"
                ><div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getActionLabel("Implemented") }}
                  </sh-text>
                </div>
                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in actionsGroupedByStatus.get('Implemented')"
                  :key="'actmenukeyImpl' + '_' + idx"
                  :label="it.summary"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="clickActionsHistMenu(it)"
                >
                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>

                      <sh-text v-if="it.status == 'Implemented'"
                        >Implemented on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item> -->
            </div>

            <div
              v-if="activeTrainingsTabName == 'Recommendations'"
              style="
                margin-top: 0px;
                overflow-y: auto;
                height: 100%;
                overflow-x: hidden;
                padding-right: 8px;
              "
            >
              <sh-text size="super-header">Recommendations</sh-text>
              <sh-text v-if="trainingReccomendations.size === 0"
                >No training recommendation available</sh-text
              >

              <sh-menu-item
                v-for="(item, index) in filteredTrainingRecommendGroupedByCSE"
                :key="'traincsemenu' + index"
                label=""
                :active="item[0] === selectedCSEidTrainingList"
                @expand="blockEvent"
                @collapse="blockEvent"
                @click="clickCSENameTraining({ e: $event, elem: item })"
                expanded="true"
              >
                <div slot="functions" style="margin-left: -100%; width: 100%">
                  <sh-text size="header-1" style="color: #ec6602">
                    {{ getCSEName(item[0]) }}
                  </sh-text>
                </div>

                <sh-menu-item
                  style="text-align: left; margin-left: -50px; width: auto"
                  v-for="(it, idx) in item[1]"
                  :key="'trnmenukey' + index + '_' + idx"
                  label=" "
                  label-rows="2"
                  :active="it.isExpanded"
                  :expanded="it.isExpanded"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click="
                    clickItemTrainingMenu({
                      e: $event,
                      elem: item,
                      it: it,
                      idx: idx,
                    })
                  "
                >
                  <div slot="functions" class="recItemMenu">
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >Context:{{ it.context }}
                    </sh-text>

                    <sh-text v-if="it.status !== 'Review'"
                      >Context: {{ it.context }}</sh-text
                    >
                    <sh-text
                      v-if="it.status === 'Review'"
                      style="font-weight: bold"
                      >Status: {{ getReviewDescription(it.status) }}</sh-text
                    >
                    <sh-wrapper
                      direction="row"
                      spacing="s"
                      style="flex-wrap: nowrap"
                    >
                      <!-- <sh-text v-if="it.status !== 'Review'"
                        >Status: {{ getReviewDescription(it.status) }}
                      </sh-text>
                      <sh-icon
                        v-if="showWarningIconCSEmenu(index, idx)"
                        icon="warning-triangle"
                        size="s"
                        :id="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                      ></sh-icon>
                      <sh-tooltip
                        style="word-break: keep-all"
                        v-if="showWarningIconCSEmenu(index, idx)"
                        :label="getIconLabelCSEmenu(index, idx)"
                        :target="getIconIdCSEmenu('sentDMG-icon-', index, idx)"
                        placement="right"
                        variation="short"
                      ></sh-tooltip> -->
                    </sh-wrapper>
                  </div>

                  <div
                    style="display: flex; text-align: left; margin-left: -26px"
                  >
                    <div>
                      <sh-text>{{ it.description }}</sh-text>
                      <sh-text v-if="it.status === 'Review'"
                        >Posted on:
                        {{ getLocalTime(it.time_recommended) }}</sh-text
                      >
                      <sh-text v-if="it.status !== 'Review'"
                        >Modified on: {{ getLocalTime(it.time) }}</sh-text
                      >
                    </div>
                    <div style="display: flex; bottom: 16px; right: 16px">
                      <sh-button
                        @click="openEditTrainingRecModal(it)"
                        label="Edit"
                        icon="edit"
                        tooltip="top"
                        color="tertiary"
                      >
                      </sh-button>
                    </div>
                  </div>
                </sh-menu-item>
              </sh-menu-item>
            </div>
          </div>
        </div>

        <div
          v-if="activeNavBarTabName == 'Workforce'"
          style="display: flex; height: 100%"
        >
          <div
            style="
              margin-top: 0px;
              overflow-y: auto;
              height: 100%;
              overflow-x: hidden;
              padding-right: 8px;
            "
          >
            <sh-menu-item
              v-for="(item, index) in getRegionCSEs()"
              :key="'workforcemenu' + index"
              label=""
              :active="item.Id === selectedCSEidWorkforceList"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click="callClickCSENameWorkforce({ e: $event, elem: item })"
              :expanded="item.Id === selectedCSEidWorkforceList"
              ><div slot="functions" style="margin-left: -100%; width: 100%">
                <sh-text size="header-1" style="color: #ec6602">
                  {{ getCSEName(item.Id) }}
                </sh-text>
              </div>
              <div style="display: flex; text-align: left; margin-left: -26px">
                <div>
                  <sh-text>Utilization: {{ item.ResUtil_Heatmap }}%</sh-text>
                  <sh-text
                    >Trained modalities:
                    {{ item.Modalities_Trained.join(", ") }}</sh-text
                  >
                  <div v-if="buildDestination === 'development'">
                  <sh-spinner
                    size="s"
                    v-if="loadingCSEtrainingPreferences"
                    label="Loading preferred modalities..."
                  ></sh-spinner>
                  <sh-dropdown
                    v-if="!loadingCSEtrainingPreferences"
                    label="Preferred modalities:"
                    multi-select
                    :value="cse_training_preferences[item.Id]"
                  >
                    <sh-menu-item
                      v-for="(mod, idx) in getModalitiesNamesList"
                      :key="'prefmod' + index + idx"
                      :label="mod"
                      :active="
                        cse_training_preferences[item.Id]?.includes(mod) ??
                        false
                      "
                      @expand="blockEvent"
                      @collapse="blockEvent"
                      @click="
                        clickModalityWf({
                          e: $event,
                          modality: mod,
                          cse: item,
                          country: country,
                          area: area,
                        })
                      "
                    ></sh-menu-item>
                  </sh-dropdown>
                </div>
                </div>
                <div style="display: flex; bottom: 16px; right: 16px">
                  <sh-button
                    @click="openCSEmenu(item)"
                    label="Edit CSE"
                    icon="edit"
                    tooltip="top"
                    color="tertiary"
                  >
                  </sh-button>
                </div>
              </div>
            </sh-menu-item>
            <!-- @click="clickCSEName({ e: $event, elem: item })" -->
          </div>
        </div>

        <sh-spinner
          style="position: absolute"
          overlay="true"
          v-if="deleteInProgress"
          label=""
        ></sh-spinner>
        <sh-spinner
          style="position: absolute"
          overlay="true"
          v-if="submitUserActionInProgress"
          label=""
        ></sh-spinner>
        <sh-spinner
          style="position: absolute"
          overlay="true"
          v-if="editRecInProgress"
          label=""
        ></sh-spinner>

        <!-- pane footer -->
      </sh-pane>

      <div id="mapContainer">
        <sh-modal
          :label="flModalContent.Name"
          icon="location-pin"
          id="fl-modal"
          modal-height="640px"
          modal-width="705px"
          @modal-closed="closeFLModal"
        >
          <div slot="header" style="display: flex; width: 100%">
            <sh-icon style="flex: 10%" icon="location-pin" size="m"></sh-icon>
            <div style="flex: 90%; text-align: center">
              <div>
                <sh-text size="title-1">{{ flModalContent.Name }}</sh-text>
              </div>
              <div>
                <sh-text size="body-2" color="primary"
                  >Plant Section: {{ flModalContent.Region }}</sh-text
                >
              </div>
            </div>
          </div>

          <sh-tabs condensed="true">
            <!-- active tab-items have the 'active' property, this property is transferred to clicked tabs -->
            <sh-tab-item
              v-for="(item, index) in flModalTabs"
              :label="item.name"
              :key="index"
              :active="item.current"
              @click="changeFlModalTab(item)"
            ></sh-tab-item>
          </sh-tabs>
          <div v-if="activeFlModalTabName == 'Overview'">
            <div style="margin-left: 16px">
              <div>{{ flModalContent.Modality }}</div>
              <div>{{ flModalContent.Descripton }}</div>
              <br />
              <div>FL ID: {{ selectedFlId }}</div>
              <div>Contract Type: {{ flModalContent.ContractType }}</div>
              <div>
                Active Contract End Date: {{ flModalContent.ContractEndDate }}
              </div>
              <br />
            </div>

            <!-- {{ connectionsModalAverageWallclockTime }} -->
            <div
              style="
                overflow: auto;
                max-height: 400px;
                width: 100%;
                margin: 0 auto;
              "
            >
              <sh-table condensed="true">
                <sh-table-row slot="header">
                  <sh-table-head unsortable="true" columns="6"
                    >Role</sh-table-head
                  >
                  <sh-table-head unsortable="true" columns="9"
                    >Current Assignment</sh-table-head
                  >
                  <sh-table-head unsortable="true" columns="9"
                    >New Assignment</sh-table-head
                  >
                </sh-table-row>

                <sh-table-row>
                  <sh-table-cell columns="6">Primary CSE</sh-table-cell>
                  <sh-table-cell columns="9"
                    ><div>
                      <div style="float: left">
                        {{ selectedFl_primary }}
                      </div>
                      <div style="float: right">
                        {{
                          findTimeToTravelByCSELabel(
                            selectedFlId,
                            "PrimaryCSEID"
                          )
                        }}
                      </div>
                    </div>
                  </sh-table-cell>
                  <sh-table-cell columns="9">
                    <sh-dropdown
                      v-if="selecteddivision != 'ImagingZone'"
                      style="width: auto"
                      label="New Primary"
                      :value="flModalContent.selectedPrimary.Name"
                      ref="primarySelector"
                    >
                      <sh-text style="margin-top: 8px" size="title-1"
                        >IVK Trained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.trainedRegionCSEs"
                        :key="
                          'prmDrop' + index + flModalContent.selectedPrimary.Id
                        "
                        :label="item.Name"
                        :active="isCSEprimaryListItemActive(item)"
                        :disabled="isCSEprimaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPrimary(item)"
                      >
                        <sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                        <!-- <div
                          slot="functions"
                          style="margin-left: -100%; width: 100%"
                        >
                          <div style="float: left">
                            <sh-text
                              v-if="item.trainedForFL === true"
                              style="font-weight: bold"
                              >{{ item.Name }}</sh-text
                            >
                            <sh-text v-if="item.trainedForFL === false">{{
                              item.Name
                            }}</sh-text>
                          </div>

                          <div style="float: right">
                            <sh-text
                              v-if="item.trainedForFL === true"
                              style="font-weight: bold"
                              >{{ item.timeToTravel }}</sh-text
                            >
                            <sh-text v-if="item.trainedForFL === false">{{
                              item.timeToTravel
                            }}</sh-text>
                          </div>
                        </div> -->
                      </sh-menu-item>
                      <sh-divider></sh-divider>

                      <sh-text style="margin-top: 8px" size="title-1"
                        >RBD Compliant</sh-text
                      >
                      <sh-menu-item
                        v-for="(item, index) in flModalContent.rbdCompliantCSEs"
                        :key="
                          'prmRbdDrop' +
                          index +
                          flModalContent.selectedPrimary.Id
                        "
                        :label="item.Name"
                        :active="isCSEprimaryListItemActive(item)"
                        :disabled="isCSEprimaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPrimary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        ></sh-menu-item
                      >
                      <sh-divider></sh-divider>

                      <sh-text style="margin-top: 8px" size="title-1"
                        >Untrained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.untrainedRegionCSEs"
                        :key="
                          'prmDropUn' +
                          index +
                          flModalContent.selectedPrimary.Id
                        "
                        :label="item.Name"
                        :active="isCSEprimaryListItemActive(item)"
                        :disabled="isCSEprimaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPrimary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                    </sh-dropdown>
                  </sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="6">Secondary CSE</sh-table-cell>
                  <sh-table-cell columns="9">
                    <div>
                      <div style="float: left">
                        {{ selectedFl_secondary }}
                      </div>
                      <div style="float: right">
                        {{
                          findTimeToTravelByCSELabel(
                            selectedFlId,
                            "SecondaryCSEID"
                          )
                        }}
                      </div>
                    </div>
                  </sh-table-cell>
                  <sh-table-cell columns="9">
                    <sh-dropdown
                      v-if="selecteddivision != 'ImagingZone'"
                      style="width: auto"
                      label="New Secondary"
                      :value="flModalContent.selectedSecondary.Name"
                      ref="secondarySelector"
                    >
                      <sh-text style="margin-top: 8px" size="title-1"
                        >IVK Trained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.trainedRegionCSEs"
                        :key="
                          'secDrop' +
                          index +
                          flModalContent.selectedSecondary.Id
                        "
                        :label="item.Name"
                        :active="isCSEsecondaryListItemActive(item)"
                        :disabled="isCSEsecondaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedSecondary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                      <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >RBD Compliant</sh-text
                      >

                      <sh-menu-item
                        v-for="(item, index) in flModalContent.rbdCompliantCSEs"
                        :key="
                          'secRbdDrop' +
                          index +
                          flModalContent.selectedSecondary.Id
                        "
                        :label="item.Name"
                        :active="isCSEsecondaryListItemActive(item)"
                        :disabled="isCSEsecondaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedSecondary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        ></sh-menu-item
                      >
                      <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >Untrained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.untrainedRegionCSEs"
                        :key="
                          'secDropUn' +
                          index +
                          flModalContent.selectedSecondary.Id
                        "
                        :label="item.Name"
                        :active="isCSEsecondaryListItemActive(item)"
                        :disabled="isCSEsecondaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedSecondary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                    </sh-dropdown>
                  </sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="6">Tertiary CSE</sh-table-cell>
                  <sh-table-cell columns="9">
                    <div>
                      <div style="float: left">
                        {{ selectedFl_tertiary }}
                      </div>
                      <div style="float: right">
                        {{
                          findTimeToTravelByCSELabel(
                            selectedFlId,
                            "TertiaryCSEID"
                          )
                        }}
                      </div>
                    </div>
                  </sh-table-cell>
                  <sh-table-cell columns="9">
                    <sh-dropdown
                      v-if="selecteddivision != 'ImagingZone'"
                      style="width: auto"
                      label="New Tertiary"
                      :value="flModalContent.selectedTertiary.Name"
                      ref="tertiarySelector"
                    >
                      <sh-text style="margin-top: 8px" size="title-1"
                        >IVK Trained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.trainedRegionCSEs"
                        :key="
                          'trdDrop' + index + flModalContent.selectedTertiary.Id
                        "
                        :label="item.Name"
                        :active="isCSEtertiaryListItemActive(item)"
                        :disabled="isCSEtertiaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedTertiary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                      <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >RBD Compliant</sh-text
                      >
                      <sh-menu-item
                        v-for="(item, index) in flModalContent.rbdCompliantCSEs"
                        :key="
                          'trdRbdDrop' +
                          index +
                          flModalContent.selectedTertiary.Id
                        "
                        :label="item.Name"
                        :active="isCSEtertiaryListItemActive(item)"
                        :disabled="isCSEtertiaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedTertiary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        ></sh-menu-item
                      >
                      <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >Untrained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.untrainedRegionCSEs"
                        :key="
                          'trdDropUn' +
                          index +
                          flModalContent.selectedTertiary.Id
                        "
                        :label="item.Name"
                        :active="isCSEtertiaryListItemActive(item)"
                        :disabled="isCSEtertiaryListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedTertiary(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                    </sh-dropdown>
                  </sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="6">PM CSE</sh-table-cell>
                  <sh-table-cell columns="9">
                    <div>
                      <div style="float: left">
                        {{ selectedFl_pm }}
                      </div>
                      <div style="float: right">
                        {{
                          findTimeToTravelByCSELabel(selectedFlId, "PMCSEID")
                        }}
                      </div>
                    </div>
                  </sh-table-cell>
                  <sh-table-cell columns="9">
                    <sh-dropdown
                      style="width: auto"
                      label="New PM"
                      :value="flModalContent.selectedPM.Name"
                      ref="pmSelector"
                    >
                      <sh-text style="margin-top: 8px" size="title-1"
                        >IVK Trained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.trainedRegionCSEs"
                        :key="'pmDrop' + index + flModalContent.selectedPM.Id"
                        :label="item.Name"
                        :active="isPmListItemActive(item)"
                        :disabled="isPmListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPM(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>
                      <!-- <sh-divider></sh-divider>

                      <sh-text style="margin-top: 8px" size="title-1"
                        >IVK Trained CSAs</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.trainedRegionCSAs"
                        :key="
                          'pmCsaDrop' + index + flModalContent.selectedPM.Id
                        "
                        :label="item.Name"
                        :active="isPmListItemActive(item)"
                        :disabled="isPmListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPM(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item> -->
                      <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >RBD Compliant</sh-text
                      >
                      <sh-menu-item
                        v-for="(item, index) in flModalContent.rbdCompliantCSEs"
                        :key="
                          'pmRbdDrop' + index + flModalContent.selectedPM.Id
                        "
                        :label="item.Name"
                        :active="isPmListItemActive(item)"
                        :disabled="isPmListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPM(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        ></sh-menu-item
                      >
                      <sh-divider></sh-divider>

                      <sh-text style="margin-top: 8px" size="title-1"
                        >Untrained</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.untrainedRegionCSEs"
                        :key="'pmDropUn' + index + flModalContent.selectedPM.Id"
                        :label="item.Name"
                        :active="isPmListItemActive(item)"
                        :disabled="isPmListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPM(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item>

                      <!-- <sh-divider></sh-divider>
                      <sh-text style="margin-top: 8px" size="title-1"
                        >Untrained CSAs</sh-text
                      >
                      <sh-menu-item
                        v-for="(
                          item, index
                        ) in flModalContent.untrainedRegionCSAs"
                        :key="
                          'pmUnCsaDrop' + index + flModalContent.selectedPM.Id
                        "
                        :label="item.Name"
                        :active="isPmListItemActive(item)"
                        :disabled="isPmListItemDisabled(item)"
                        @expand="blockEvent"
                        @collapse="blockEvent"
                        @click.prevent="callSetSelectedPM(item)"
                        ><sh-text
                          slot="functions"
                          color="secondary"
                          style="width: fit-content"
                          >{{ item.timeToTravel }}</sh-text
                        >
                      </sh-menu-item> -->
                    </sh-dropdown>
                    <sh-checkbox
                      v-if="selecteddivision != 'ImagingZone'"
                      style="text-align: left"
                      label="Same as primary"
                      :active="flModalContent.isPmSameAsPrimary"
                      @checked="setPmSameAsPrimary($event)"
                    >
                    </sh-checkbox>
                  </sh-table-cell>
                </sh-table-row>
              </sh-table>
            </div>
          </div>
          <div
            v-if="activeFlModalTabName == 'Overview' && isSubmitButtonVisible()"
            slot="footer"
          >
            <div style="margin-bottom: 8px">
              <sh-button
                style="margin-left: auto; margin-right: 0px"
                size="max-content"
                label="Submit new assignments"
                @click="submitNewAssignments()"
              ></sh-button>
              <sh-text style="margin-top: 8px"
                >All submitted changes will be sent to DMG on a daily
                basis</sh-text
              >
            </div>
          </div>
          <div v-if="activeFlModalTabName == 'Contract'">
            <div style="margin-left: 16px">
              <div>Contract Type: {{ flModalContent.ContractType }}</div>
              <div>
                Active Contract End Date: {{ flModalContent.ContractEndDate }}
              </div>
              <div>Billing Status: {{ flModalContent.BillingStatus }}</div>
              <div>End of Service Date: {{ flModalContent.EoS }}</div>
              <br />
              <div style="text-align: center">
                <sh-text size="title-1">Principal Coverage Period</sh-text>
              </div>
            </div>
            <div
              style="
                overflow: auto;
                max-height: 400px;
                width: 100%;
                margin: 0 auto;
              "
            >
              <sh-table condensed="true">
                <sh-table-row slot="header">
                  <sh-table-head unsortable="true" columns="8"
                    >Day</sh-table-head
                  >
                  <!-- style="padding-left: 24px" -->
                  <sh-table-head
                    style="padding-left: 69px"
                    unsortable="true"
                    columns="8"
                    >Start Time</sh-table-head
                  >
                  <sh-table-head
                    style="padding-left: 70px"
                    unsortable="true"
                    columns="8"
                    >End Time</sh-table-head
                  >
                </sh-table-row>
                <sh-table-row v-for="(item, i) in weekDays" :key="i">
                  <sh-table-cell columns="8">{{ item }}</sh-table-cell>
                  <sh-table-cell style="text-align: center" columns="8">{{
                    flModalContent.PCPSchedule[item].StartTime
                      ? flModalContent.PCPSchedule[item].StartTime
                      : "None"
                  }}</sh-table-cell>
                  <sh-table-cell style="text-align: center" columns="8">{{
                    flModalContent.PCPSchedule[item].EndTime
                      ? flModalContent.PCPSchedule[item].EndTime
                      : "None"
                  }}</sh-table-cell>
                </sh-table-row>
              </sh-table>
            </div>
          </div>
        </sh-modal>
        <sh-modal
          :label="cseModalContent.Name"
          id="cse-modal"
          modal-height="600px"
          icon="user-avatar"
          modal-width="550px"
          @modal-closed="closeCSEModal"
        >
          <div slot="header" style="display: flex; width: 100%">
            <sh-icon style="flex: 10%" icon="user-avatar" size="m"></sh-icon>
            <div style="flex: 90%; text-align: center">
              <div>
                <sh-text size="title-1">{{ cseModalContent.Name }}</sh-text>
              </div>
              <div>
                <sh-text size="body-2" color="primary"
                  >Plant Section: {{ cseModalContent.RegionID }}</sh-text
                >
              </div>
            </div>
          </div>

          <sh-tabs condensed="true">
            <sh-tab-item
              v-for="(item, index) in cseModalTabs"
              :label="item.name"
              :key="index"
              :active="item.current"
              @click="changeCseModalTab(item)"
            ></sh-tab-item>
          </sh-tabs>
          <div
            v-if="activeCseModalTabName == 'Shift'"
            style="overflow: auto; max-height: 380px"
          >
            <sh-table condensed="true">
              <sh-table-row slot="header">
                <sh-table-head unsortable="true" columns="8">Day</sh-table-head>
                <sh-table-head
                  style="padding-left: 26px"
                  unsortable="true"
                  columns="8"
                  >Start Time</sh-table-head
                >
                <sh-table-head
                  style="padding-left: 28px"
                  unsortable="true"
                  columns="8"
                  >End Time</sh-table-head
                >
              </sh-table-row>
              <sh-table-row v-for="(item, i) in weekDays" :key="i">
                <sh-table-cell columns="8">{{ item }}</sh-table-cell>
                <sh-table-cell style="text-align: center" columns="8">{{
                  cseModalContent.WorkSchedule[item].StartTime
                    ? cseModalContent.WorkSchedule[item].StartTime
                    : "None"
                }}</sh-table-cell>
                <sh-table-cell style="text-align: center" columns="8">{{
                  cseModalContent.WorkSchedule[item].EndTime
                    ? cseModalContent.WorkSchedule[item].EndTime
                    : "None"
                }}</sh-table-cell>
              </sh-table-row>
            </sh-table>
          </div>
          <div
            v-if="activeCseModalTabName == 'Overview'"
            style="max-height: 380px"
          >
            <div style="display: block">
              <sh-table condensed="true">
                <sh-table-row>
                  <sh-table-cell columns="10">Status</sh-table-cell>
                  <sh-table-cell columns="14">{{
                    cseModalContent.Status
                  }}</sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10"
                    ><sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >Within shift utilization (last 6 months)</sh-text
                    ></sh-table-cell
                  >
                  <sh-table-cell columns="14"
                    >{{ cseModalContent.ResUtil_Heatmap }}%</sh-table-cell
                  >
                </sh-table-row>
                <sh-table-row v-if="cseModalContent.Status !== 'ACTIVE'">
                  <sh-table-cell columns="10"
                    >Return to work date</sh-table-cell
                  >
                  <sh-table-cell columns="14">
                    <sh-spinner
                      size="s"
                      v-if="loadingCseReturnRetirementDate"
                      label="Loading Return to work Date"
                    ></sh-spinner>
                    <sh-datepicker
                      format="YYYYMMDD"
                      v-if="!loadingCseReturnRetirementDate"
                      label="Return to work Date"
                      :value="cseBackToWorkDate"
                      @value-changed="cseReturnWorkDateChanged"
                    ></sh-datepicker
                  ></sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10">Retirement date</sh-table-cell>
                  <sh-table-cell columns="14">
                    <sh-spinner
                      size="s"
                      v-if="loadingCseReturnRetirementDate"
                      label="Loading Retirement Date"
                    ></sh-spinner>
                    <sh-datepicker
                      format="YYYYMMDD"
                      v-if="!loadingCseReturnRetirementDate"
                      label="Retirement Date"
                      :value="cseRetirementDate"
                      @value-changed="cseRetirementDateChanged"
                    ></sh-datepicker
                  ></sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10">Trained modalities</sh-table-cell>
                  <sh-table-cell style="word-spacing: -2px" columns="14"
                    ><sh-text
                      style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ cseModalContent.Modalities_Trained }}</sh-text
                    ></sh-table-cell
                  >
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10"
                    >Primary Assignments</sh-table-cell
                  >
                  <sh-table-cell style="word-spacing: -2px" columns="14"
                    ><sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ cseModalContent.primaryAssignments }} (Under contract:
                      {{ cseModalContent.primaryAssignmentsContract }}, T&M:
                      {{
                        cseModalContent.primaryAssignmentsNoContract
                      }})</sh-text
                    >
                  </sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10"
                    >Secondary Assignments</sh-table-cell
                  >
                  <sh-table-cell style="word-spacing: -2px" columns="14"
                    ><sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ cseModalContent.seccondaryAssignments }} (Under
                      contract:
                      {{ cseModalContent.seccondaryAssignmentsContract }}, T&M:
                      {{
                        cseModalContent.seccondaryAssignmentsNoContract
                      }})</sh-text
                    ></sh-table-cell
                  >
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10"
                    >Tertiary Assignments</sh-table-cell
                  >
                  <sh-table-cell style="word-spacing: -2px" columns="14">
                    <sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ cseModalContent.tertiaryAssignments }} (Under
                      contract:
                      {{ cseModalContent.tertiaryAssignmentsContract }}, T&M:
                      {{
                        cseModalContent.tertiaryAssignmentsNoContract
                      }})</sh-text
                    ></sh-table-cell
                  >
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="10">PM Assignments</sh-table-cell>
                  <sh-table-cell style="word-spacing: -2px" columns="14">
                    <sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ cseModalContent.pmAssignments }} (Under contract:
                      {{ cseModalContent.pmAssignmentsContract }}, T&M:
                      {{ cseModalContent.pmAssignmentsNoContract }})</sh-text
                    ></sh-table-cell
                  >
                </sh-table-row>
              </sh-table>
            </div>
          </div>
          <div v-if="activeCseModalTabName == 'Overview'" slot="footer">
            <div style="margin-bottom: 8px">
              <sh-button
                style="margin-left: auto; margin-right: 0px"
                size="max-content"
                label="Export Assignment Data"
                @click="
                  exportAssignData(
                    selectedCSEId,
                    'Qualified_CSEs',
                    'PrimaryCSEID',
                    'FLs_Where_CSE_Trained_',
                    'Primary'
                  )
                "
              ></sh-button>
            </div>

            <a :href="cseDashboardLink" target="_blank"
              >Click to visit dashboard for training, flight hours,
              expertise.</a
            >
          </div>
        </sh-modal>

        <sh-modal
          :label="csaModalContent.Name"
          id="csa-modal"
          modal-height="470px"
          icon="user-avatar"
          modal-width="450px"
          @modal-closed="closeCSAModal"
        >
          <div slot="header" style="display: flex; width: 100%">
            <sh-icon style="flex: 10%" icon="user-avatar" size="m"></sh-icon>
            <div style="flex: 90%; text-align: center">
              <div>
                <sh-text size="title-1">{{ csaModalContent.Name }}</sh-text>
              </div>
              <div>
                <sh-text size="body-2" color="primary"
                  >Zone: {{ csaModalContent.Zone }}</sh-text
                >
              </div>
            </div>
          </div>

          <sh-tabs condensed="true">
            <sh-tab-item
              v-for="(item, index) in csaModalTabs"
              :label="item.name"
              :key="index"
              :active="item.current"
              @click="changeCsaModalTab(item)"
            ></sh-tab-item>
          </sh-tabs>
          <div
            v-if="activeCsaModalTabName == 'Shift'"
            style="overflow: auto; max-height: 380px"
          >
            <sh-table condensed="true">
              <sh-table-row slot="header">
                <sh-table-head unsortable="true" columns="8">Day</sh-table-head>
                <sh-table-head
                  style="padding-left: 26px"
                  unsortable="true"
                  columns="8"
                  >Start Time</sh-table-head
                >
                <sh-table-head
                  style="padding-left: 28px"
                  unsortable="true"
                  columns="8"
                  >End Time</sh-table-head
                >
              </sh-table-row>
              <sh-table-row v-for="(item, i) in weekDays" :key="i">
                <sh-table-cell columns="8">{{ item }}</sh-table-cell>
                <sh-table-cell style="text-align: center" columns="8">{{
                  csaModalContent.WorkSchedule[item].StartTime
                    ? csaModalContent.WorkSchedule[item].StartTime
                    : "None"
                }}</sh-table-cell>
                <sh-table-cell style="text-align: center" columns="8">{{
                  csaModalContent.WorkSchedule[item].EndTime
                    ? csaModalContent.WorkSchedule[item].EndTime
                    : "None"
                }}</sh-table-cell>
              </sh-table-row>
            </sh-table>
          </div>
          <div
            v-if="activeCsaModalTabName == 'Overview'"
            style="overflow: auto; max-height: 380px"
          >
            <div style="display: block">
              <sh-table condensed="true">
                <sh-table-row>
                  <sh-table-cell columns="11">Status</sh-table-cell>
                  <sh-table-cell columns="13">{{
                    csaModalContent.Status
                  }}</sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="11"
                    >Utilization (last 6 months)</sh-table-cell
                  >
                  <sh-table-cell columns="13"
                    >{{ csaModalContent.ResUtil_Heatmap }}%</sh-table-cell
                  >
                </sh-table-row>
                <sh-table-row v-if="csaModalContent.Status !== 'ACTIVE'">
                  <sh-table-cell columns="11"
                    >Return to work date</sh-table-cell
                  >
                  <sh-table-cell columns="13">
                    <sh-spinner
                      size="s"
                      v-if="loadingCseReturnRetirementDate"
                      label="Loading Return to work Date"
                    ></sh-spinner>
                    <sh-datepicker
                      format="YYYYMMDD"
                      v-if="!loadingCseReturnRetirementDate"
                      label="Return to work Date"
                      :value="csaBackToWorkDate"
                      @value-changed="csaReturnWorkDateChanged"
                    ></sh-datepicker
                  ></sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="11">Retirement date</sh-table-cell>
                  <sh-table-cell columns="13">
                    <sh-spinner
                      size="s"
                      v-if="loadingCseReturnRetirementDate"
                      label="Loading Retirement Date"
                    ></sh-spinner>
                    <sh-datepicker
                      format="YYYYMMDD"
                      v-if="!loadingCseReturnRetirementDate"
                      label="Retirement Date"
                      :value="csaRetirementDate"
                      @value-changed="csaRetirementDateChanged"
                    ></sh-datepicker
                  ></sh-table-cell>
                </sh-table-row>
                <sh-table-row>
                  <sh-table-cell columns="11">PM Assignments</sh-table-cell>
                  <sh-table-cell style="word-spacing: -2px" columns="13">
                    <sh-text style="line-height: 1.5em; margin: 0.25rem 0rem"
                      >{{ csaModalContent.pmAssignments }} (Under contract:
                      {{ csaModalContent.pmAssignmentsContract }}, T&M:
                      {{ csaModalContent.pmAssignmentsNoContract }})</sh-text
                    ></sh-table-cell
                  >
                </sh-table-row>
              </sh-table>
            </div>
          </div>

          <div v-if="activeCsaModalTabName == 'Overview'" slot="footer">
            <div style="margin-bottom: 8px">
              <sh-button
                style="margin-left: auto; margin-right: 0px"
                size="max-content"
                label="Export Assignment Data"
                @click="
                  exportAssignData(
                    selectedCSAId,
                    'Qualified_CSAs',
                    'PMCSEID',
                    'FLs_Where_CSA_Trained_',
                    'PM'
                  )
                "
              ></sh-button>
            </div>

            <a :href="csaDashboardLink" target="_blank"
              >Click to visit dashboard for training, flight hours,
              expertise.</a
            >
          </div>
        </sh-modal>
        <div id="map"></div>
      </div>
      <sh-spinner
        style="position: absolute"
        overlay="true"
        label="Loading Plant Section Data"
        v-if="loadingRegionData"
      ></sh-spinner>

      <sh-spinner
        style="position: absolute"
        overlay="true"
        v-if="loadingZoneData"
        label="Loading zone data… This may take a few minutes"
      >
      </sh-spinner>
      <div style="position: absolute; top: 10px; left: 27px; width: auto">
        <sh-text size="super-header">Last Updated: {{ lastUpdated }}</sh-text>
      </div>
      <div
        style="
          position: absolute;
          top: 10px;
          right: 10px;
          max-height: 75vh;
          overflow-y: auto;
          width: 25%;
          max-width: 350px;
        "
      >
        <sh-accordion label="KPI Selection" class="accordionStyling">
          <ul class="column-list">
            <li
              v-for="(item, i) in kpiList"
              :key="item.kpiName + item.active.toString()"
            >
              <sh-checkbox
                style="text-align: left"
                :label="item.kpiName"
                :active="item.active"
                @checked="filterKPIs($event, i)"
              >
              </sh-checkbox>
            </li>
          </ul>
        </sh-accordion>

        <sh-accordion
          expanded="true"
          v-show="isKPIvisible('Wall Clock')"
          label="Wall Clock"
          class="accordionStyling"
        >
          <forcast-chart
            v-if="
              wall_clock_chart_data_linechart.historical.length &&
              isKPIvisible('Wall Clock')
            "
            :key="key_wall_clock + isKPIvisible('Wall Clock')"
            :config="chart_config_wall"
            :height="chartHeight"
            :chartdata="wall_clock_chart_data_linechart"
            :style="cssVars"
          ></forcast-chart>
        </sh-accordion>

        <sh-accordion
          expanded="true"
          v-show="isKPIvisible('Gated Wall Clock')"
          label="Gated Wall Clock"
          class="accordionStyling"
        >
          <sh-text size="body-2"
            >Limit per notification wallclock to 2 weeks</sh-text
          >

          <forcast-chart
            v-if="
              gated_wall_clock_chart_data_linechart.historical.length &&
              isKPIvisible('Gated Wall Clock')
            "
            :key="key_gated_wall_clock + isKPIvisible('Gated Wall Clock')"
            :config="chart_config_wall_gated"
            :height="chartHeight"
            :chartdata="gated_wall_clock_chart_data_linechart"
            :style="cssVars"
          ></forcast-chart>
        </sh-accordion>

        <sh-accordion
          expanded="true"
          v-show="isKPIvisible('Within Shift Utilization')"
          label="Within Shift Utilization"
          class="accordionStyling"
        >
          <sh-text size="body-2">Rolling 28 days</sh-text>
          <forcast-chart
            v-if="
              resource_utilization_chart_data_linechart.historical.length &&
              isKPIvisible('Within Shift Utilization')
            "
            :key="key_resource + isKPIvisible('Within Shift Utilization')"
            :config="chart_config_resource"
            :height="chartHeight"
            :chartdata="resource_utilization_chart_data_linechart"
            :style="cssVars"
          ></forcast-chart>
        </sh-accordion>

        <sh-accordion
          expanded="true"
          v-show="isKPIvisible('Travel Time')"
          label="Travel Time"
          class="accordionStyling"
        >
          <forcast-chart
            v-if="
              travel_time_chart_data_linechart.historical.length &&
              isKPIvisible('Travel Time')
            "
            :key="key_travel + isKPIvisible('Travel Time')"
            :config="chart_config_travel"
            :height="chartHeight"
            :chartdata="travel_time_chart_data_linechart"
            :style="cssVars"
          ></forcast-chart>
        </sh-accordion>
      </div>

      <div
        style="
          position: absolute;
          bottom: 70px;
          left: 30px;
          overflow-y: auto;
          max-height: 72vh;
          width: auto;
        "
      >
        <sh-accordion label="FL Filters" collapsed class="accordionStyling">
          <div>
            <sh-text style="text-align: left" size="title-1"
              >Plant Sections</sh-text
            >

            <ul class="column-list" style="max-height: 100px">
              <li
                v-for="(item, i) in regions"
                :key="item.regionName + item.active.toString()"
              >
                <sh-checkbox
                  style="text-align: left"
                  :label="item.regionName"
                  :active="item.active"
                  @checked="filterSelectedRegion($event, i)"
                >
                </sh-checkbox>
              </li>
            </ul>

            <sh-text
              style="text-align: left; margin-top: 16px; margin-bottom: 16px"
              size="title-1"
              >FL Description</sh-text
            >
            <!-- <sh-dropdown
              condensed="true"
              style="width: auto"
              label="FL Description"
              :value="selectedFlDesc"
              editable="true"
            >
              <div
                style="text-align: left"
                v-for="(descs, modality) in filteredModalitiesDecs"
                :key="modality"
              >
                <sh-text style="margin-top: 8px" size="title-1">{{
                  modality
                }}</sh-text>
                <sh-menu-item
                  v-for="(desc, index) in descs"
                  :key="modality + index + selectedFlDesc"
                  :label="desc"
                  :active="desc === selectedFlDesc"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click.prevent="setSelectedFlDesc(desc)"
                >
                </sh-menu-item>
                <sh-divider></sh-divider>
              </div>
            </sh-dropdown> -->
            <div style="display: flex; align-items: center; width: 100%">
              <sh-dropdown
                condensed="true"
                label="FL Description"
                :value="selectedFlDesc"
                editable="true"
              >
                <sh-menu-item
                  style="text-align: left"
                  v-for="(item, index) in filteredModalitiesDecs"
                  :key="index + selectedFlDesc"
                  :label="item.modalityDesc"
                  :active="item.desc === selectedFlDesc"
                  @expand="blockEvent"
                  @collapse="blockEvent"
                  @click.prevent="setSelectedFlDesc(item.desc)"
                  @keyup.enter="setSelectedFlDesc(item.desc)"
                >
                </sh-menu-item>
              </sh-dropdown>
              <sh-icon
                icon="cancel"
                size="m"
                button="true"
                color="#EC6602"
                id="reset-desc-icon"
                @click="setSelectedFlDesc('')"
              ></sh-icon>
              <sh-tooltip
                label="Remove selected FL Description"
                target="reset-desc-icon"
                placement="bottom-right"
                variation="short"
              ></sh-tooltip>
            </div>
            <sh-text style="text-align: left; margin-top: 16px" size="title-1"
              >FL Modalities</sh-text
            >
            <ul class="column-list">
              <li
                v-for="(item, i) in getModalities"
                :key="item.Modality + item.active.toString()"
              >
                <sh-checkbox
                  style="text-align: left"
                  :label="item.Modality"
                  :active="item.active"
                  @checked="filterByModality($event, i)"
                >
                </sh-checkbox>
              </li>
            </ul>

            <div class="buttonsFooter">
              <sh-button
                style="margin-right: 8px"
                v-if="getModalities.length"
                size="m"
                label="Reset Modalities"
                @click="resetModalities"
              ></sh-button>
              <sh-button
                size="l"
                v-if="getModalities.length"
                label="Uncheck All Modalities"
                @click="uncheckModalities"
              ></sh-button>
            </div>

            <sh-text style="text-align: left; margin-top: 16px" size="title-1"
              >FL Contract Status</sh-text
            >
            <ul class="column-list">
              <li
                v-for="(item, i) in contractStatus"
                :key="item.status + item.active.toString()"
              >
                <sh-checkbox
                  style="text-align: left"
                  :label="item.status"
                  :active="item.active"
                  @checked="filterByContractStatus($event, i)"
                >
                </sh-checkbox>
              </li>
            </ul>
          </div>
        </sh-accordion>
        <sh-accordion label="CSE Filters" collapsed class="accordionStyling">
          <sh-text style="text-align: left" size="title-1">Connections</sh-text>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-top: 0px;
            "
          >
            <div>
              <ul class="column-list">
                <li
                  v-for="(item, i) in selectedCSEdisplayedConnections"
                  :key="item.connType + item.active.toString()"
                >
                  <sh-checkbox
                    style="text-align: left"
                    :label="item.connType"
                    :active="item.active"
                    @checked="filterSelectedCSEVisibleConnections($event, i)"
                  >
                  </sh-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <sh-text style="text-align: left" size="title-1">Status</sh-text>
          <ul class="column-list">
            <li
              v-for="(item, i) in cseStatus"
              :key="item.status + item.active.toString()"
            >
              <sh-checkbox
                style="text-align: left"
                :label="item.status"
                :active="item.active"
                @checked="filterCSEbyStatus($event, i)"
              >
              </sh-checkbox>
            </li>
          </ul>
          <sh-checkbox
            style="text-align: left"
            label="Filter CSE by selected Modalities"
            :active="filterCSEbySelectedModalities"
            @checked="toggleFilterCSEbySelectedModalities($event)"
          >
          </sh-checkbox>
          <sh-checkbox
            style="text-align: left"
            label="Filter CSE by selected Plant Sections"
            :active="filterCSEbySelectedPlantSections"
            @checked="toggleFilterCSEbySelectedPlantSections($event)"
          >
          </sh-checkbox>
        </sh-accordion>
        <sh-accordion label="Map Layers" collapsed class="accordionStyling">
          <sh-toggle
            style="text-align: left"
            v-for="(item, i) in activeLayers"
            :key="item.id.toString() + item.active.toString()"
            :label="item.label"
            :active="item.active"
            v-show="item.show"
            @click="setLayerVisibility(item.label, i)"
          ></sh-toggle>
        </sh-accordion>
        <sh-accordion label="Map Legend" collapsed class="accordionStyling">
          <map-legend></map-legend>
        </sh-accordion>

        <sh-accordion label="Lines Legend" collapsed class="accordionStyling">
          <map-lines></map-lines>
        </sh-accordion>
      </div>
    </sh-page>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import mapboxgl from "mapbox-gl";
import ForcastChart from "@/components/charts/forcastchart/forcastchart.vue";
import MapLegend from "@/components/MapLegend.vue";
import MapLines from "@/components/MapLines.vue";
import RecommendationAssignments from "@/components/RecommendationAssignments.vue";
import RecommendationRejected from "@/components/RecommendationRejected.vue";
import TrainingRecommendation from "@/components/TrainingRecommendation.vue";
import axios from "axios";
import csv2geojson from "csv2geojson";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

export default {
  name: "CockpitPage",
  props: {
    area: { type: String, required: true },
    selecteddivision: { type: String, required: true },
    country: { type: String, required: true },
  },
  components: {
    ForcastChart,
    MapLegend,
    MapLines,
    RecommendationAssignments,
    RecommendationRejected,
    TrainingRecommendation,
  },
  data() {
    return {
      KPIlabels: [
        "CSE busy/idle",
        "FL down/active",
        "Agg Overtime (hours)",
        "Notifications",
      ],
      Latitude: null,
      Longitude: null,
      map: null,

      wall_clock_chart_data_linechart: {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      },
      gated_wall_clock_chart_data_linechart: {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      },
      resource_utilization_chart_data_linechart: {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      },
      travel_time_chart_data_linechart: {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      },
      key_wall_clock: 0,
      key_gated_wall_clock: 0,
      key_resource: 0,
      key_travel: 0,
      source2Layer: {
        primaryLines: "CSEtoFLprimaryLines",
        secondaryLines: "CSEtoFLsecondaryLines",
        tertiaryLines: "CSEtoFLtertiaryLines",
        csePmLines: "PMCSEtoFLLines",
        csaPmLines: "PMCSAtoFLLines",
        flStatic: "FLlayerBackend",
        cseStatic: "CSElayerBackend",
        csaStatic: "CSAlayerBackend",
        flAffected: "flAffectedLayer",
        cseAffected: "cseAffectedLayer",
        singleCSETrainedConnections: "SingleCSETrainedLayer",
        singleCSEUntrainedConnections: "SingleCSEUntrainedLayer",
        singleFLTrainedConnections: "SingleFlTrainedLayer",
        singleFLUntrainedConnections: "SingleFlUnTrainedLayer",
      },
      connectionsColors: {
        PrimaryCSEID: "#f7a71e",
        SecondaryCSEID: "#39b54a",
        TertiaryCSEID: "#672dca",
        TrainedCSE: "#737373",
        PMCSEID: "#009999",
      },
      activeLayers: [
        {
          id: 1,
          label: "FLs to primary CSEs",
          active: false,
          layerName: "CSEtoFLprimaryLines",
          show: true,
        },
        {
          id: 2,
          label: "FLs to secondary CSEs",
          active: false,
          layerName: "CSEtoFLsecondaryLines",
          show: true,
        },
        {
          id: 3,
          label: "FLs to tertiary CSEs",
          active: false,
          layerName: "CSEtoFLtertiaryLines",
          show: true,
        },
        {
          id: 4,
          label: "FLs",
          active: true,
          layerName: "FLlayerBackend",
          show: false,
        },
        {
          id: 5,
          label: "Home CSEs",
          active: true,
          layerName: "CSElayerBackend",
          show: false,
        },
        {
          id: 6,
          label: "Affected FLs",
          active: true,
          layerName: "flAffectedLayer",
          show: false,
        },
        {
          id: 7,
          label: "Affected CSEs",
          active: true,
          layerName: "cseAffectedLayer",
          show: false,
        },
        {
          id: 8,
          label: "Home CSAs",
          active: true,
          layerName: "CSAlayerBackend",
          show: false,
        },
        {
          id: 9,
          label: "FLs to CSE PMs",
          active: false,
          layerName: "PMCSEtoFLLines",
          show: true,
        },
        {
          id: 10,
          label: "FLs to CSA PMs",
          active: false,
          layerName: "PMCSAtoFLLines",
          show: true,
        },
      ],
      chart_config_wall: {
        clipName: "clipwall",
        values: ["count"],
        date: {
          key: "when",
          inputFormat: "%Y-%m-%d %H:%M",
          outputFormat: "%b%e",
        },
        points: false,
        color: {
          scheme: ["#EC6602", "#2DC4B2"],
          axis: "#000",
        },
        tooltip: {
          labels: ["Wall clock"],
        },
        axis: {
          yTitle: "Wall clock (hours)",
          xTitle: "Timestamp",
          yFormat: ".0f",
          xFormat: "%Y-%m-%d %H:%M",
          yTicks: 5,
          xTicks: 5,
        },
        transition: {
          duration: 350,
          ease: "easeLinear",
        },
        curve: "curveBasis",
      },
      chart_config_wall_gated: {
        clipName: "clipgated",
        values: ["count"],
        date: {
          key: "when",
          inputFormat: "%Y-%m-%d %H:%M",
          outputFormat: "%b%e",
        },
        points: false,
        color: {
          scheme: ["#EC6602", "#2DC4B2"],
          axis: "#000",
        },
        tooltip: {
          labels: ["Gated Wall clock"],
        },
        axis: {
          yTitle: "Gated Wall clock (hours)",
          xTitle: "Timestamp",
          yFormat: ".0f",
          xFormat: "%Y-%m-%d %H:%M",
          yTicks: 5,
          xTicks: 5,
        },
        transition: {
          duration: 350,
          ease: "easeLinear",
        },
        curve: "curveBasis",
      },
      chart_config_resource: {
        clipName: "clipresource",
        values: ["count"],
        date: {
          key: "when",
          inputFormat: "%Y-%m-%d %H:%M",
          outputFormat: "%b%e",
        },
        points: false,
        color: {
          scheme: ["#EC6602", "#2DC4B2"],
          axis: "#000000",
        },
        tooltip: {
          labels: ["Resource utilization"],
        },
        axis: {
          yTitle: "Resource utilization %",
          xTitle: "Timestamp",
          yFormat: ".0f",
          xFormat: "%Y-%m-%d %H:%M",
          yTicks: 5,
          xTicks: 5,
        },
        transition: {
          duration: 350,
          ease: "easeLinear",
        },
      },
      chart_config_travel: {
        clipName: "cliptravel",
        values: ["count"],
        date: {
          key: "when",
          inputFormat: "%Y-%m-%d %H:%M",
          outputFormat: "%b%e",
        },
        points: false,
        color: {
          scheme: ["#EC6602", "#2DC4B2"],
          axis: "#000000",
        },
        tooltip: {
          labels: ["Travel Time"],
        },
        axis: {
          yTitle: "Travel Time (hours)",
          xTitle: "Timestamp",
          yFormat: ".0f",
          xFormat: "%Y-%m-%d %H:%M",
          yTicks: 5,
          xTicks: 5,
        },
        transition: {
          duration: 350,
          ease: "easeLinear",
        },
      },
      chartHeight: 200,
      fl_to_cses_conn_arr: [],
      flModalContent: {
        Name: "",
        Modality: "",
        Descripton: "",
        EoS: "",
        Region: "",
        AverageWallclockTime: "",
        BillingStatus: "",
        ContractEndDate: "",
        ContractType: "",
        PCPSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        selectedPrimary: { Name: "", Id: "" },
        selectedSecondary: { Name: "", Id: "" },
        selectedTertiary: { Name: "", Id: "" },
        selectedPM: { Name: "", Id: "" },
        trainedRegionCSEs: [],
        rbdCompliantCSEs: [],
        untrainedRegionCSEs: [],
        isPmSameAsPrimary: true,
        trainedRegionCSAs: [],
        untrainedRegionCSAs: [],
      },
      FlModalEmpty: {
        Name: "",
        Modality: "",
        Descripton: "",
        EoS: "",
        Region: "",
        AverageWallclockTime: "",
        BillingStatus: "",
        ContractEndDate: "",
        ContractType: "",
        PCPSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        selectedPrimary: { name: "", Id: "" },
        selectedSecondary: { name: "", Id: "" },
        selectedTertiary: { name: "", Id: "" },
        selectedPM: { Name: "", Id: "" },
        trainedRegionCSEs: [],
        rbdCompliantCSEs: [],
        untrainedRegionCSEs: [],
        isPmSameAsPrimary: true,
        trainedRegionCSAs: [],
        untrainedRegionCSAs: [],
      },
      cseModalContent: {
        Id: "",
        Latitude: null,
        Longitude: null,
        Name: "",
        RenderLatitude: null,
        RenderLongitude: null,
        Schedule: "",
        WorkSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        Status: "",
        Modalities_Trained: "",
        ResUtil_Heatmap: "",
        RegionID: "",
        primaryAssignments: "",
        primaryAssignmentsContract: "",
        primaryAssignmentsNoContract: "",
        seccondaryAssignments: "",
        seccondaryAssignmentsContract: "",
        seccondaryAssignmentsNoContract: "",
        tertiaryAssignments: "",
        tertiaryAssignmentsContract: "",
        tertiaryAssignmentsNoContract: "",
        pmAssignments: "",
        pmAssignmentsContract: "",
        pmAssignmentsNoContract: "",
      },
      cseModalEmpty: {
        Id: "",
        Latitude: null,
        Longitude: null,
        Name: "",
        RenderLatitude: null,
        RenderLongitude: null,
        Schedule: "",
        WorkSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        Status: "",
        Modalities_Trained: "",
        ResUtil_Heatmap: "",
        RegionID: "",
        primaryAssignments: "",
        primaryAssignmentsContract: "",
        primaryAssignmentsNoContract: "",
        seccondaryAssignments: "",
        seccondaryAssignmentsContract: "",
        seccondaryAssignmentsNoContract: "",
        tertiaryAssignments: "",
        tertiaryAssignmentsContract: "",
        tertiaryAssignmentsNoContract: "",
        pmAssignments: "",
        pmAssignmentsContract: "",
        pmAssignmentsNoContract: "",
      },
      csaModalContent: {
        Name: "",
        Zone: "",
        WorkSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        Status: "",
        ResUtil_Heatmap: "",
        Id: "",
        pmAssignments: "",
        pmAssignmentsContract: "",
        pmAssignmentsNoContract: "",
      },
      csaModalEmpty: {
        Name: "",
        Zone: "",
        WorkSchedule: {
          Monday: {
            StartTime: null,
            EndTime: null,
          },
          Tuesday: {
            StartTime: null,
            EndTime: null,
          },
          Wednesday: {
            StartTime: null,
            EndTime: null,
          },
          Thursday: {
            StartTime: null,
            EndTime: null,
          },
          Friday: {
            StartTime: null,
            EndTime: null,
          },
          Saturday: {
            StartTime: null,
            EndTime: null,
          },
          Sunday: {
            StartTime: null,
            EndTime: null,
          },
        },
        Status: "",
        ResUtil_Heatmap: "",
        Id: "",
        pmAssignments: "",
        pmAssignmentsContract: "",
        pmAssignmentsNoContract: "",
      },
      selectedFlId: "",
      selectedCSEId: "",
      selectedCSAId: "",
      travel_time_map: {},
      zone_travel_time_map: {},
      lastUpdated: "",
      loadingRegionData: false,
      loadingZoneData: false,
      weekDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],

      selectedCSEdisplayedConnections: [
        { connType: "primary", active: true },
        { connType: "secondary", active: true },
        { connType: "tertiary", active: true },
        { connType: "trained (unassigned)", active: false },
        { connType: "PM", active: true },
      ],
      kpiList: [
        { kpiName: "Wall Clock", active: false },
        { kpiName: "Gated Wall Clock", active: true },
        { kpiName: "Within Shift Utilization", active: true },
        { kpiName: "Travel Time", active: false },
      ],
      kpiListDisabled: [
        { kpiName: "Wall Clock", active: false },
        { kpiName: "Gated Wall Clock", active: false },
        { kpiName: "Within Shift Utilization", active: false },
        { kpiName: "Travel Time", active: false },
      ],
      paneTabs: [
        { id: 2, name: "History", current: false, disabled: false },
        { id: 4, name: "RBD Compliance", current: false, disabled: false },
        {
          id: 3,
          name: "Installation FLs",
          current: false,
          disabled: false,
        },
        { id: 1, name: "Recommendations", current: true, disabled: false },
      ],
      trainingsTabs: [
        { id: 2, name: "History", current: false, disabled: false },
        { id: 1, name: "Recommendations", current: true, disabled: false },
      ],
      navBarTrabs: [],
      flModalTabs: [
        { id: 1, name: "Overview", current: true },
        { id: 2, name: "Contract", current: false },
      ],
      cseModalTabs: [
        { id: 1, name: "Overview", current: true },
        { id: 2, name: "Shift", current: false },
      ],
      csaModalTabs: [
        { id: 3, name: "Overview", current: true },
        { id: 4, name: "Shift", current: false },
      ],
      selectedFlCse: "",
      loadingCseReturnRetirementDate: false,
      cseBackToWorkDate: null,
      cseRetirementDate: null,
      csaBackToWorkDate: null,
      csaRetirementDate: null,
    };
  },
  async mounted() {
    // console.log(
    //   "___________________________Cockpit Mounted___________________________"
    // );
    // console.log("oidcIdToken ", this.oidcIdToken);
    // console.log(this.$store.state.oidcStore);

    if (this.selecteddivision == "ImagingZone") {
      this.kpiList = [...this.kpiListDisabled];
    }

    //when we reload from the cockpit, the areas are not loaded
    if (
      JSON.stringify(this.selectedCountry) === "{}" &&
      JSON.stringify(this.selectedArea) === "{}"
    ) {
      await this.getCountriesData();
      this.getAreasData();
    } else if (
      JSON.stringify(this.selectedCountry) !== "{}" &&
      JSON.stringify(this.selectedArea) === "{}"
    ) {
      this.getAreasData();
    } else if (
      JSON.stringify(this.selectedCountry) === "{}" &&
      JSON.stringify(this.selectedArea) !== "{}"
    ) {
      this.getCountriesData();
    } else {
      this.getTravelTimes();
    }
  },
  created() {
    if(this.buildDestination === 'development')
      {
        this.navBarTrabs = [
        { id: 1, name: "Assignments", current: true },
        { id: 2, name: "Trainings", current: false },
        { id: 3, name: "Workforce", current: false },
      ]
      }
      else
      {
        this.navBarTrabs = [
        { id: 1, name: "Assignments", current: true },
        { id: 2, name: "Workforce", current: false },
      ]
      }
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
    }
    this.clearCockpitState();
  },
  destroyed() {
    console.log("Cockpit tab destroyed!");
  },
  computed: {
    ...mapGetters([
      "buildDestination",
      "backendURL",
      "accessToken",
      "cse_static",
      "cse_training_preferences",
      "loadingCSEtrainingPreferences",
      "csa_static",
      "fl_cse_conn_obj",
      "fl_static",
      "filteredModalitiesDecs",
      "selectedFlDesc",
      "reccomendations",
      "selectedActionHist",
      "selectedRecommandationIndex",
      "selectedTrainingRecommandationIndex",
      "selectedCSEidTrainingList",
      "selectedCSEidRecList",
      "selectedCSEidWorkforceList",
      "getReviewDescription",
      "actionsHistory",
      "actionsGroupedByStatus",
      "regions",
      "getCSEName",
      "getActionLabel",
      "flsCsesNames",
      "getFLName",
      "getFLCity",
      "getFlDesc",
      "selectedArea",
      "areas",
      "division",
      "getModalities",
      "getModalitiesNamesList",
      "contractStatus",
      "cseStatus",
      "getActiveModalitiesNames",
      "getActiveRegionsNames",
      "getActiveStatusNames",
      "getCSEactiveStatusNames",
      "filteredReviewed",
      "filterButtonColor",
      "filteredRecommend",
      "trainingReccomendations",
      "trainingActionsHistory",
      "filteredRecommendGroupedByCSE_recommended",
      "filteredRecommendGroupedByCSE_installation",
      "filteredRecommendGroupedByCSE_rbd",
      "filteredTrainingRecommendGroupedByCSE",
      "filterCSEbySelectedModalities",
      "filterCSEbySelectedPlantSections",
      "dashboardLink",
      "deleteInProgress",
      "submitUserActionInProgress",
      "editRecInProgress",
      "selectedCountry",
      "countries",
    ]),
    ...mapGetters("oidcStore", ["oidcUser", "oidcIdToken"]),
    selectedFl_pm: function () {
      return this.getAssignedCSEorCSAname("PMCSEID", this.selectedFlId);
    },
    selectedFl_primary: function () {
      return this.getAssignedCSnameForSelFL("PrimaryCSEID");
    },
    selectedFl_secondary: function () {
      return this.getAssignedCSnameForSelFL("SecondaryCSEID");
    },
    selectedFl_tertiary: function () {
      return this.getAssignedCSnameForSelFL("TertiaryCSEID");
    },

    zoomLevel: function () {
      if (this.selecteddivision == "ImagingZone") {
        return 4;
      } else {
        return 6;
      }
    },

    cssVars: function () {
      return {
        "--bg-color": this.chart_config_wall.color.scheme[0],
      };
    },
    activePaneTabName: function () {
      let activeTab = this.paneTabs.find((el) => el.current === true);
      return activeTab.name;
    },
    activeTrainingsTabName: function () {
      let activeTab = this.trainingsTabs.find((el) => el.current === true);
      return activeTab.name;
    },
    activeNavBarTabName: function () {
      let activeTab = this.navBarTrabs.find((el) => el.current === true);
      return activeTab.name;
    },
    activeFlModalTabName: function () {
      let activeTab = this.flModalTabs.find((el) => el.current === true);
      return activeTab.name;
    },
    activeCseModalTabName: function () {
      let activeTab = this.cseModalTabs.find((el) => el.current === true);
      return activeTab.name;
    },
    activeCsaModalTabName: function () {
      let activeTab = this.csaModalTabs.find((el) => el.current === true);
      return activeTab.name;
    },
    collapseRecPane: function () {
      if (this.reccomendations.length) return "expanded";
      else return "collapsed";
    },
    displayReccomendModal: function () {
      if (this.$route.name === "CountyMap") return false;
      else return true;
    },
    cseDashboardLink: function () {
      return this.dashboardLink + "/" + this.cseModalContent.Id;
    },
    csaDashboardLink: function () {
      return this.dashboardLink + "/" + this.csaModalContent.Id;
    },
  },
  methods: {
    ...mapActions([
      "getDowngradeOptions",
      "getDashboardLink",
      "getActionRecommendations",
      "getTrainingsRecommendations",
      "pushNotification",
      "clearCockpitState",
      "exportPendingRecommendation",
      "clickItemCSEMenu",
      "clickCSEName",
      "clickCSENameWorkforce",
      "clickCSENameTraining",
      "clickItemTrainingMenu",
      "clickActionsHistMenu",
      "clickModalityWf",
      "loadAreas",
      "resetPendingActionHist",
      "deletePendingActionHist",
      "updateRecommendations",
      "loadCountries",
      "getCSEsPreferedModalities",
    ]),
    ...mapMutations([
      "setCSEs",
      "setCSAs",
      "setFLs",
      "setFlsCsesNames",
      "setMOdalitiesDesc",
      "setSelectedFlDesc",
      "setConnectionObj",
      "setRegions",
      "setSelectedArea",
      "setSelectedDivision",
      "clearSelectedRecommendationIndex",
      "clearSelectedTrainingRecommendationIndex",
      "clearSelectedActionHist",
      "setSelectedCSEidRecList",
      "setSelectedCSEidWorkforceList",
      "setSelectedRecommendationIndex",
      "setSelectedTrainingRecommendationIndex",
      "contractReccomendations",
      "contractActionHist",
      "contractTrainingReccomendations",
      "changeRegionActiveState",
      "setModalities",
      "setModalitiesNamesList",
      "setModalityActiveState",
      "setContractStatusActiveState",
      "setCSEstatusActiveState",
      "resetModalities",
      "uncheckModalities",
      "toggleFilteredReviewed",
      "setFilterCSEbySelectedModalities",
      "setFilterCSEbySelectedPlantSections",
      "setSubmitUserActionInProgress",
      "setSelectedCountry",
    ]),

    async getAreasData() {
      await this.loadAreas();

      //set selected area
      // console.log(this.$route.params.area);
      // console.log(this.$route.params.selecteddivision);

      let index = this.areas.findIndex((el) => {
        return el.name === this.area;
      });

      if (index !== -1) {
        this.setSelectedArea(this.areas[index]);
      }

      let indexInDivisions = this.division.findIndex((div) => {
        return div.value === this.selecteddivision;
      });

      if (indexInDivisions !== -1) {
        this.setSelectedDivision(this.division[indexInDivisions]);
      }

      this.getTravelTimes();
    },

    async getCountriesData() {
      await this.loadCountries();

      let index = this.countries.findIndex((el) => {
        return el.iso_3166_1 === this.country;
      });

      if (index !== -1) {
        this.setSelectedCountry(this.countries[index]);
      }
    },

    goToFirstPage() {
      this.setSelectedArea({});
      this.$router.push({ name: "CountyMap" });
    },

    callGetRecommend() {
      // this.clearSelectedRecommendation();
      // this.clearSelectedActionHist();
      this.clearSelRecActionHistContractMenus();
      this.getActionRecommendations({
        area: this.area,
        selecteddivision: this.selecteddivision,
      });
    },

    callSetSelectedPrimary(cse) {
      // console.log(cse);
      if (this.flModalContent.selectedPrimary.Id === cse.Id) {
        //deselect primary
        this.flModalContent.selectedPrimary = { Name: "", Id: "" };
      } else {
        this.flModalContent.selectedPrimary = { ...cse };
      }
      if (this.flModalContent.isPmSameAsPrimary) {
        this.flModalContent.selectedPM = {
          ...this.flModalContent.selectedPrimary,
        };
      }
    },

    callSetSelectedSecondary(cse) {
      // console.log(cse);
      if (this.flModalContent.selectedSecondary.Id === cse.Id) {
        //deselect secondary
        this.flModalContent.selectedSecondary = { Name: "", Id: "" };
      } else {
        this.flModalContent.selectedSecondary = { ...cse };
      }
    },

    callSetSelectedTertiary(cse) {
      // console.log(cse);
      if (this.flModalContent.selectedTertiary.Id === cse.Id) {
        this.flModalContent.selectedTertiary = { Name: "", Id: "" };
      } else {
        this.flModalContent.selectedTertiary = { ...cse };
      }
    },

    callSetSelectedPM(cseCsa) {
      // console.log(cse);
      if (this.flModalContent.selectedPM.Id === cseCsa.Id) {
        this.flModalContent.selectedPM = { Name: "", Id: "" };
      } else {
        this.flModalContent.selectedPM = { ...cseCsa };
      }
      if (
        this.flModalContent.selectedPM.Id !==
        this.flModalContent.selectedPrimary.Id
      ) {
        this.flModalContent.isPmSameAsPrimary = false;
      } else {
        this.flModalContent.isPmSameAsPrimary = true;
      }
    },

    setPmSameAsPrimary(event) {
      console.log(event);
      this.flModalContent.isPmSameAsPrimary = event.target.active;
      if (this.flModalContent.isPmSameAsPrimary) {
        this.flModalContent.selectedPM = {
          ...this.flModalContent.selectedPrimary,
        };
      }
    },

    toggleFilter() {
      // this.clearSelectedRecommendation();
      // this.clearSelectedActionHist();
      // this.contractReccomendations();
      // this.contractActionHist();
      this.clearSelRecActionHistContractMenus();
      this.toggleFilteredReviewed();
    },

    changePaneTab(selectedTab) {
      let changedTabs = this.paneTabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      // console.log(selectedTab);
      this.paneTabs = [...changedTabs];

      // this.clearSelectedRecommendation();
      // this.clearSelectedActionHist();
      // this.contractReccomendations();
      // this.contractActionHist();
      this.clearAndContract();
    },

    changeTrainingsTab(selectedTab) {
      let changedTabs = this.trainingsTabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      this.trainingsTabs = [...changedTabs];
      //todo clear and contract?
    },

    changeNavBarTab(selectedTab) {
      let changedTabs = this.navBarTrabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      this.navBarTrabs = [...changedTabs];

      this.clearAndContract();
    },

    changeFlModalTab(selectedTab) {
      let changedTabs = this.flModalTabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      this.flModalTabs = [...changedTabs];
    },

    changeCseModalTab(selectedTab) {
      let changedTabs = this.cseModalTabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      this.cseModalTabs = [...changedTabs];
    },

    changeCsaModalTab(selectedTab) {
      let changedTabs = this.csaModalTabs.map((t) => {
        t.id === selectedTab.id ? (t.current = true) : (t.current = false);
        return t;
      });
      this.csaModalTabs = [...changedTabs];
    },

    clearSelRecActionHistContractMenus() {
      // console.time("clearSelRecActionHistContractMenus");

      if (this.activePaneTabName == "History") {
        this.clearSelectedActionHist();
        this.contractActionHist();
      }

      if (
        this.activePaneTabName == "Recommendations" ||
        this.activePaneTabName == "RBD Compliance" ||
        this.activePaneTabName == "Installation FLs"
      ) {
        this.clearSelectedRecommendationIndex();
        this.clearSelectedTrainingRecommendationIndex();
        this.contractReccomendations();
        this.contractTrainingReccomendations();
      }
      // console.timeEnd("clearSelRecActionHistContractMenus");
    },

    clearAndContract() {
      this.clearSelectedActionHist();
      this.contractActionHist();
      this.clearSelectedRecommendationIndex();
      this.clearSelectedTrainingRecommendationIndex();
      this.contractReccomendations();
      this.contractTrainingReccomendations();
      this.setSelectedCSEidRecList("");
      this.setSelectedCSEidWorkforceList("");
    },

    exportPendingRecommend() {
      this.exportPendingRecommendation();
      this.clearSelRecActionHistContractMenus();
    },

    exportAssignData(
      engId,
      qualifiedLabel,
      assignmentLabel,
      fileName,
      assignmentStr
    ) {
      let flsWhereQualified = this.fl_static.filter((el) => {
        return el[qualifiedLabel].indexOf(engId) !== -1;
      });

      let csvContent = flsWhereQualified
        .map((el) => {
          const fl_pm = this.fl_cse_conn_obj[el.Id];
          let pmId = "",
            pmName = "",
            pmRole = "",
            pmTimeToTravel = "";

          if (fl_pm) {
            pmId = fl_pm[assignmentLabel];
            ({ pmName, pmRole } = this.getAssignedCSEorCSAnameAndRole(
              assignmentLabel,
              el.Id
            ));
            pmTimeToTravel = this.findTimeToTravel(el.Id, fl_pm["PMCSEID"], "");
          }

          let mapEl = [
            el.Id,
            el.Name.replaceAll(",", " "),
            el.City.replaceAll(",", " "),
            el.Modality,
            el.Desc.replaceAll(",", " -"),
            el.ContractType,
            this.findTimeToTravel(el.Id, engId, ""), //from fl to currently selected engineer
            pmTimeToTravel, //from fl to currently assigned PM
            pmName,
            pmId,
            pmRole,
          ].join(",");

          return mapEl;
        })
        .join("\n");

      let csvHeader = `FLID,ShipTo,City,Modality,FL Description,Contract Type,Travel Time (in hours),Travel time (in hours) for current PM,Name of currently assigned ${assignmentStr},ID of currently assigned ${assignmentStr}, Role\n`;

      let csvToExport = "data:text/csv;charset=utf-8," + csvHeader + csvContent;

      var encodedUri = encodeURI(csvToExport);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", fileName + engId + ".csv");
      document.body.appendChild(link);

      link.click();
    },

    getLocalTime(time) {
      if (time) {
        let mydate = new Date(time + " UTC");
        // console.log("my local time ", mydate);
        return (
          mydate.getDate() +
          " " +
          mydate.toLocaleString("en-us", { month: "short" }) +
          " " +
          mydate.getFullYear()
        );
      } else return "";
    },

    blockEvent() {
      return;
    },

    openEditModalCSEmenu(rec) {
      console.log(rec);

      let filteredIndex = this.filteredRecommend.findIndex((obj) => {
        return obj.uid === rec.uid;
      });
      if (filteredIndex !== -1) {
        this.setSelectedRecommendationIndex(filteredIndex);

        if (this.filteredRecommend[filteredIndex].status == "Review") {
          this.$refs.childRecomendationsModal.getCSERetirementReturnDates();
          document.querySelector("#assignments-modal").visible = true;
        } else if (
          this.filteredRecommend[filteredIndex].status == "Downgraded"
        ) {
          document.querySelector("#rejected-modal").visible = true;
        }
      }
    },

    openEditTrainingRecModal(rec) {
      console.log(rec);

      let trainIndex = this.trainingReccomendations.findIndex((obj) => {
        return obj.uid === rec.uid;
      });

      if (trainIndex !== -1) {
        this.setSelectedTrainingRecommendationIndex(trainIndex);
        if (this.trainingReccomendations[trainIndex].status == "Review") {
          document.querySelector("#training-modal").visible = true;
        }
        //todo add reject modal
        // else if (
        //   this.trainingReccomendations[trainIndex].status == "Downgraded"
        // ) {
        //   document.querySelector("#rejected-training-modal").visible = true;
        // }
      }
    },

    openCSEmenu(param) {
      const cse = JSON.parse(JSON.stringify(param));

      // cse.WorkSchedule = JSON.parse(cse.WorkSchedule);

      cse.Modalities_Trained = cse.Modalities_Trained.sort().join(", ");

      cse.ResUtil_Heatmap = parseInt(cse.ResUtil_Heatmap);

      //count FLs where CSE is primary
      let flsWherePrm = this.fl_to_cses_conn_arr.filter((el) => {
        return el["PrimaryCSEID"] === cse.Id;
      });
      let primContractStats = this.countContract(flsWherePrm);
      cse.primaryAssignmentsContract = primContractStats.contract;
      cse.primaryAssignmentsNoContract = primContractStats.noContract;
      cse.primaryAssignments =
        primContractStats.contract + primContractStats.noContract;

      //count FLs where CSE is secondary
      let flsWhereSec = this.fl_to_cses_conn_arr.filter((el) => {
        return el["SecondaryCSEID"] === cse.Id;
      });
      let secContractStats = this.countContract(flsWhereSec);
      cse.seccondaryAssignmentsContract = secContractStats.contract;
      cse.seccondaryAssignmentsNoContract = secContractStats.noContract;
      cse.seccondaryAssignments =
        secContractStats.contract + secContractStats.noContract;

      //count FLs where CSE is Tertiary
      let flsWhereTrd = this.fl_to_cses_conn_arr.filter((el) => {
        return el["TertiaryCSEID"] === cse.Id;
      });
      let trdContractStats = this.countContract(flsWhereTrd);
      cse.tertiaryAssignmentsContract = trdContractStats.contract;
      cse.tertiaryAssignmentsNoContract = trdContractStats.noContract;
      cse.tertiaryAssignments =
        trdContractStats.contract + trdContractStats.noContract;

      //count FLs where CSE is PM
      let flsWherePM = this.fl_to_cses_conn_arr.filter((el) => {
        return el["PMCSEID"] === cse.Id;
      });
      let pmContractStats = this.countContract(flsWherePM);
      cse.pmAssignmentsContract = pmContractStats.contract;
      cse.pmAssignmentsNoContract = pmContractStats.noContract;
      cse.pmAssignments = pmContractStats.contract + pmContractStats.noContract;

      this.cseModalContent = { ...cse };

      this.getCSERetirementReturnDates(cse.Id, true);

      document.querySelector("#cse-modal").visible = true;
    },

    clearLayer(sourceName) {
      if (this.map) {
        let mapLayer = this.map.getLayer(this.source2Layer[sourceName]);
        if (typeof mapLayer !== "undefined") {
          this.map.setLayoutProperty(
            this.source2Layer[sourceName],
            "visibility",
            "none"
          );
        }
        if (this.map.getSource(sourceName) != null) {
          this.map.getSource(sourceName).setData({
            type: "FeatureCollection",
            features: [],
          });
        }
      }
    },

    countContract(flsList) {
      let contractStats = { contract: 0, noContract: 0 };

      flsList.forEach((el) => {
        //find FL id in flstatic
        let index = this.fl_static.findIndex((obj) => {
          return obj.Id === el.FLID;
        });

        if (index !== -1) {
          if (this.fl_static[index].FlContractStatus === "Contract") {
            contractStats.contract = contractStats.contract + 1;
          } else {
            contractStats.noContract = contractStats.noContract + 1;
          }
        }
      });

      return contractStats;
    },

    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        center: [this.Longitude, this.Latitude],
        zoom: this.zoomLevel,
        minZoom: 3,
      });

      this.map.addControl(new mapboxgl.ScaleControl());
      return new Promise((resolve) => {
        this.map.on("load", () => {
          this.map.getCanvas().style.cursor = "default";
          this.map.loadImage("/trianglesmall.png", (error, image) => {
            if (error) throw error;
            this.map.loadImage("/square.png", (sqerror, sqImage) => {
              if (sqerror) throw sqerror;

              // Add the loaded image to the style's sprite with the ID 'fl-icon'.
              this.map.addImage("CSE-icon", image, { sdf: true });
              this.map.addImage("CSA-icon", sqImage, { sdf: true });

              this.addLinesLayer("primaryLines");
              this.addLinesLayer("secondaryLines");
              this.addLinesLayer("tertiaryLines");
              this.addLinesLayer("csePmLines");
              this.addLinesLayer("csaPmLines");

              this.addEmptyLinesLayer("singleCSETrainedConnections");
              this.addEmptyDashedLinesLayer("singleCSEUntrainedConnections");

              this.map.addLayer({
                id: "singleCSETrainedConnectionsLabel",
                type: "symbol",
                source: "singleCSETrainedConnections",
                layout: {
                  "symbol-placement": "line",
                  "text-font": ["Open Sans Regular"],
                  "text-field": "{title}",
                  "text-size": 10,
                },
              });

              this.map.addLayer({
                id: "singleCSEUntrainedConnectionsLabel",
                type: "symbol",
                source: "singleCSEUntrainedConnections",
                layout: {
                  "symbol-placement": "line",
                  "text-font": ["Open Sans Regular"],
                  "text-field": "{title}",
                  "text-size": 10,
                },
              });

              this.addEmptyLinesLayer("singleFLTrainedConnections");
              this.addEmptyDashedLinesLayer("singleFLUntrainedConnections");

              this.map.addLayer({
                id: "singleFLConnectionsLabel",
                type: "symbol",
                source: "singleFLTrainedConnections",
                layout: {
                  "symbol-placement": "line",
                  "text-font": ["Open Sans Regular"],
                  "text-field": "{title}",
                  "text-size": 10,
                },
              });

              this.map.addLayer({
                id: "singleFLUntrainedConnectionsLabel",
                type: "symbol",
                source: "singleFLUntrainedConnections",
                layout: {
                  "symbol-placement": "line",
                  "text-font": ["Open Sans Regular"],
                  "text-field": "{title}",
                  "text-size": 10,
                },
              });

              //add empty FL static layer
              this.addCircleLayer("flStatic", {
                "circle-radius": 7.5,
                "circle-color": [
                  "match",
                  ["get", "AverageWallclockTime"],
                  9,
                  "#d73027",
                  8,
                  "#f46c43",
                  7,
                  "#fdae61",
                  6,
                  "#fedf8b",
                  5,
                  "#ffff64",
                  4,
                  "#d9ef8b",
                  3,
                  "#a6d96a",
                  2,
                  "#66bd63",
                  1,
                  "#1a9850",
                  0,
                  "#087035",
                  "#087035",
                ],
                //"#2DC4B2",
                "circle-opacity": 0.6,
                "circle-stroke-width": 2,
                "circle-stroke-color": [
                  "match",
                  ["get", "AverageWallclockTime"],
                  9,
                  "#96211b",
                  8,
                  "#aa4b2e",
                  7,
                  "#b17943",
                  6,
                  "#b19c61",
                  5,
                  "#b2b246",
                  4,
                  "#97a761",
                  3,
                  "#74974a",
                  2,
                  "#478445",
                  1,
                  "#126a38",
                  0,
                  "#054e25",
                  "#054e25",
                ],
                "circle-stroke-opacity": [
                  "match",
                  ["get", "BillingStatus"],
                  "CONTRACT",
                  1,
                  "WARRANTY",
                  1,
                  "EXTENDED WARRANTY",
                  1,
                  "COURTESY",
                  1,
                  0 /* other */,
                ],
              });

              let self = this;
              this.map.on("click", this.source2Layer["flStatic"], (e) => {
                self.map.setLayoutProperty(
                  "CSEtoFLprimaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLsecondaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLtertiaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSEtoFLLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSAtoFLLines",
                  "visibility",
                  "none"
                );
                self.clearLayer("singleCSETrainedConnections");
                self.clearLayer("singleCSEUntrainedConnections");

                self.selectedFlId = e.features[0].properties.Id;
                self.selectedCSEId = "";
                self.selectedCSAId = "";
                self.addTempConnectionsOfSelFL(e.features[0].properties.Id);

                if (e.originalEvent.ctrlKey) {
                  let cityFormatted = e.features[0].properties.City.split(" ")
                    .map((word) => {
                      return (
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                      );
                    })
                    .join(" ");

                  self.flModalContent.Name =
                    e.features[0].properties.Name + ", " + cityFormatted;
                  self.flModalContent.Modality =
                    e.features[0].properties.Modality;

                  self.flModalContent.BillingStatus =
                    e.features[0].properties.BillingStatus;
                  self.flModalContent.AverageWallclockTime =
                    "Avg Wall Clock Time " +
                    e.features[0].properties.AverageWallclockTime;
                  self.flModalContent.Descripton =
                    e.features[0].properties.Desc;
                  self.flModalContent.EoS = e.features[0].properties.GoDeadDate;
                  self.flModalContent.Region =
                    e.features[0].properties.RegionID;
                  self.flModalContent.ContractEndDate =
                    e.features[0].properties.ContractEndDate;
                  self.flModalContent.ContractType =
                    e.features[0].properties.ContractType;

                  let regionCSEs = self.cse_static
                    .filter(
                      (cse) =>
                        cse.RegionID === e.features[0].properties.RegionID
                    )
                    .map((cse) => {
                      return {
                        ...cse,
                        trainedForFL:
                          e.features[0].properties.Qualified_CSEs.includes(
                            cse.Id
                          )
                            ? true
                            : false,
                        rbdCompliantForFL:
                          e.features[0].properties.RBD_Compliant_CSEs.includes(
                            cse.Id
                          )
                            ? true
                            : false,
                        timeToTravel: self.findTimeToTravel(
                          e.features[0].properties.Id,
                          cse.Id,
                          " hrs"
                        ),
                        timeToTravelAsNumber: parseFloat(
                          self.findTimeToTravel(
                            e.features[0].properties.Id,
                            cse.Id,
                            ""
                          )
                        ),
                      };
                    })
                    .sort((a, b) => {
                      return a.timeToTravelAsNumber - b.timeToTravelAsNumber;
                    });

                  self.flModalContent.trainedRegionCSEs = regionCSEs.filter(
                    (cse) => cse.trainedForFL
                  );
                  self.flModalContent.rbdCompliantCSEs = regionCSEs.filter(
                    (cse) => cse.rbdCompliantForFL
                  );
                  self.flModalContent.untrainedRegionCSEs = regionCSEs.filter(
                    (cse) => {
                      return (
                        !self.flModalContent.trainedRegionCSEs.includes(cse) &&
                        !self.flModalContent.rbdCompliantCSEs.includes(cse)
                      );
                    }
                  );
                  let regionCSAs = self.csa_static
                    .map((csa) => {
                      return {
                        ...csa,
                        trainedForFL:
                          e.features[0].properties.Qualified_CSAs.includes(
                            csa.Id
                          )
                            ? true
                            : false,
                        timeToTravel: self.findTimeToTravel(
                          e.features[0].properties.Id,
                          csa.Id,
                          " hrs"
                        ),
                        timeToTravelAsNumber: parseFloat(
                          self.findTimeToTravel(
                            e.features[0].properties.Id,
                            csa.Id,
                            ""
                          )
                        ),
                      };
                    })
                    .sort((a, b) => {
                      return a.timeToTravelAsNumber - b.timeToTravelAsNumber;
                    });

                  self.flModalContent.trainedRegionCSAs = regionCSAs.filter(
                    (csa) => csa.trainedForFL
                  );
                  self.flModalContent.untrainedRegionCSAs = regionCSAs.filter(
                    (csa) => !csa.trainedForFL
                  );

                  // console.log(e.features[0].properties.PCPSchedule);

                  if (
                    Object.prototype.hasOwnProperty.call(
                      e.features[0].properties,
                      "PCPSchedule"
                    )
                  ) {
                    e.features[0].properties.PCPSchedule = JSON.parse(
                      e.features[0].properties.PCPSchedule
                    );
                    // console.log(e.features[0].properties.PCPSchedule);

                    let pcpSche = { ...self.FlModalEmpty.PCPSchedule };
                    // console.log(pcpSche);
                    for (const key in e.features[0].properties.PCPSchedule) {
                      pcpSche[key] = {
                        ...e.features[0].properties.PCPSchedule[key],
                      };
                    }

                    self.flModalContent.PCPSchedule = pcpSche;
                  } else {
                    self.flModalContent.PCPSchedule = {
                      ...self.FlModalEmpty.PCPSchedule,
                    };
                  }

                  document.querySelector("#fl-modal").visible = true;
                }
              });

              const flStatic_popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
              });

              this.map.on("mouseenter", this.source2Layer["flStatic"], (e) => {
                // Change the cursor style as a UI indicator.
                this.map.getCanvas().style.cursor = "pointer";

                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();
                const description =
                  "<div style='text-align: center;'><strong>" +
                  e.features[0].properties.Name +
                  "</strong><br>" +
                  e.features[0].properties.Id +
                  "<br>" +
                  e.features[0].properties.Modality +
                  "<br>" +
                  e.features[0].properties.Desc +
                  "<br>" +
                  "Contract Type: " +
                  e.features[0].properties.ContractType +
                  "<br>" +
                  "Active Contract End Date: " +
                  e.features[0].properties.ContractEndDate +
                  "<br>" +
                  "Plant Section: " +
                  e.features[0].properties.RegionID +
                  "<br>Use <strong>Ctrl + Click</strong> for more details</div>";
                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                flStatic_popup
                  .setLngLat(coordinates)
                  .setHTML(description)
                  .addTo(this.map);
              });

              this.map.on("mouseleave", this.source2Layer["flStatic"], () => {
                this.map.getCanvas().style.cursor = "default";
                flStatic_popup.remove();
              });

              this.map.on("click", function (e) {
                //this is used for deselecting a marker
                //set source for temporary layer that only holds the connections
                //reset visibility for connections layers according to the layers control
                if (e.originalEvent.target.style.cursor == "default") {
                  // console.log("______________map was clicked_____________");
                  // console.log(e.originalEvent.target);
                  // console.log(e);
                  self.clearTemporaryFLandCSElayers();
                }
              });

              this.addCSlayer("cseStatic");
              this.addCSlayer("csaStatic");

              this.map.on("click", this.source2Layer["cseStatic"], (e) => {
                self.map.setLayoutProperty(
                  "CSEtoFLprimaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLsecondaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLtertiaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSEtoFLLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSAtoFLLines",
                  "visibility",
                  "none"
                );
                self.clearLayer("singleFLTrainedConnections");
                self.clearLayer("singleFLUntrainedConnections");

                let cseCoord = self.findCSEcoord(
                  e.features[0].properties.Id,
                  self.cse_static
                );

                self.selectedCSEId = e.features[0].properties.Id;
                self.selectedFlId = "";
                self.selectedCSAId = "";
                self.addTempConnectionsOfSelCSE(
                  e.features[0].properties.Id,
                  cseCoord
                );

                if (e.originalEvent.ctrlKey) {
                  e.features[0].properties.WorkSchedule = JSON.parse(
                    e.features[0].properties.WorkSchedule
                  );

                  e.features[0].properties.Modalities_Trained = JSON.parse(
                    e.features[0].properties.Modalities_Trained
                  )
                    .sort()
                    .join(", ");

                  e.features[0].properties.ResUtil_Heatmap = parseInt(
                    e.features[0].properties.ResUtil_Heatmap
                  );

                  //count FLs where CSE is primary
                  let flsWherePrm = self.fl_to_cses_conn_arr.filter((el) => {
                    return el["PrimaryCSEID"] === e.features[0].properties.Id;
                  });
                  let primContractStats = self.countContract(flsWherePrm);
                  e.features[0].properties.primaryAssignmentsContract =
                    primContractStats.contract;
                  e.features[0].properties.primaryAssignmentsNoContract =
                    primContractStats.noContract;
                  e.features[0].properties.primaryAssignments =
                    primContractStats.contract + primContractStats.noContract;

                  //count FLs where CSE is secondary
                  let flsWhereSec = self.fl_to_cses_conn_arr.filter((el) => {
                    return el["SecondaryCSEID"] === e.features[0].properties.Id;
                  });
                  let secContractStats = self.countContract(flsWhereSec);
                  e.features[0].properties.seccondaryAssignmentsContract =
                    secContractStats.contract;
                  e.features[0].properties.seccondaryAssignmentsNoContract =
                    secContractStats.noContract;
                  e.features[0].properties.seccondaryAssignments =
                    secContractStats.contract + secContractStats.noContract;

                  //count FLs where CSE is Tertiary
                  let flsWhereTrd = self.fl_to_cses_conn_arr.filter((el) => {
                    return el["TertiaryCSEID"] === e.features[0].properties.Id;
                  });
                  let trdContractStats = self.countContract(flsWhereTrd);
                  e.features[0].properties.tertiaryAssignmentsContract =
                    trdContractStats.contract;
                  e.features[0].properties.tertiaryAssignmentsNoContract =
                    trdContractStats.noContract;
                  e.features[0].properties.tertiaryAssignments =
                    trdContractStats.contract + trdContractStats.noContract;

                  //count FLs where CSE is PM
                  let flsWherePM = self.fl_to_cses_conn_arr.filter((el) => {
                    return el["PMCSEID"] === e.features[0].properties.Id;
                  });
                  let pmContractStats = self.countContract(flsWherePM);
                  e.features[0].properties.pmAssignmentsContract =
                    pmContractStats.contract;
                  e.features[0].properties.pmAssignmentsNoContract =
                    pmContractStats.noContract;
                  e.features[0].properties.pmAssignments =
                    pmContractStats.contract + pmContractStats.noContract;

                  self.cseModalContent = { ...e.features[0].properties };

                  self.getCSERetirementReturnDates(
                    e.features[0].properties.Id,
                    true
                  );

                  // console.log(self.cseModalContent);
                  document.querySelector("#cse-modal").visible = true;
                }
              });

              const cseStatic_popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
              });

              this.map.on("mouseenter", this.source2Layer["cseStatic"], (e) => {
                // Change the cursor style as a UI indicator.
                this.map.getCanvas().style.cursor = "pointer";

                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();

                // const today = new Date();
                // var priorDay = new Date(
                //   new Date().setDate(today.getDate() - 180)
                // );
                // let todayDate = today.toLocaleDateString("en-US", {
                //   day: "numeric",
                //   month: "short",
                // });
                // let priorDateFormatted = priorDay.toLocaleDateString("en-US", {
                //   day: "numeric",
                //   month: "short",
                // });
                // const description =
                //   e.features[0].properties.Name +
                //   "<br><strong>" +
                //   "From</strong> " +
                //   priorDateFormatted +
                //   " <strong>To</strong> " +
                //   todayDate +
                //   ": <strong>" +
                //   parseInt(e.features[0].properties.ResUtil_Heatmap) +
                //   "%</strong>";

                const description =
                  "<div style='text-align: center;'><strong>" +
                  e.features[0].properties.Name +
                  "</strong><br>" +
                  "Within shift utilization over last 6 months: <strong>" +
                  parseInt(e.features[0].properties.ResUtil_Heatmap) +
                  "%</strong><br>Use <strong>Ctrl + Click</strong> for more details</div>";

                // +
                // "<br>" +
                // e.features[0].properties.Modalities_Trained
                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                cseStatic_popup
                  .setLngLat(coordinates)
                  .setHTML(description)
                  .addTo(this.map);
              });

              this.map.on("mouseleave", this.source2Layer["cseStatic"], () => {
                this.map.getCanvas().style.cursor = "default";
                cseStatic_popup.remove();
              });

              this.map.on("click", this.source2Layer["csaStatic"], (e) => {
                self.map.setLayoutProperty(
                  "CSEtoFLprimaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLsecondaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "CSEtoFLtertiaryLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSEtoFLLines",
                  "visibility",
                  "none"
                );
                self.map.setLayoutProperty(
                  "PMCSAtoFLLines",
                  "visibility",
                  "none"
                );
                self.clearLayer("singleFLTrainedConnections");
                self.clearLayer("singleFLUntrainedConnections");
                self.clearLayer("singleCSETrainedConnections");
                self.clearLayer("singleCSEUntrainedConnections");

                self.selectedCSAId = e.features[0].properties.Id;
                self.selectedCSEId = "";
                self.selectedFlId = "";

                let csaCoord = self.findCSEcoord(
                  e.features[0].properties.Id,
                  self.csa_static
                );
                self.addTempConnectionsOfSelCSA(
                  e.features[0].properties.Id,
                  csaCoord
                );

                if (e.originalEvent.ctrlKey) {
                  e.features[0].properties.WorkSchedule = JSON.parse(
                    e.features[0].properties.WorkSchedule
                  );

                  let flsWherePM = self.fl_to_cses_conn_arr.filter((el) => {
                    return el["PMCSEID"] === e.features[0].properties.Id;
                  });
                  let pmContrSts = self.countContract(flsWherePM);
                  e.features[0].properties.pmAssignmentsContract =
                    pmContrSts.contract;
                  e.features[0].properties.pmAssignmentsNoContract =
                    pmContrSts.noContract;
                  e.features[0].properties.pmAssignments =
                    pmContrSts.contract + pmContrSts.noContract;

                  self.csaModalContent = { ...e.features[0].properties };

                  self.getCSERetirementReturnDates(
                    e.features[0].properties.Id,
                    false
                  );

                  document.querySelector("#csa-modal").visible = true;
                }
              });

              const csaStatic_popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
              });

              this.map.on("mouseenter", this.source2Layer["csaStatic"], (e) => {
                // Change the cursor style as a UI indicator.
                this.map.getCanvas().style.cursor = "pointer";

                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();

                const description =
                  "<div style='text-align: center;'><strong>" +
                  e.features[0].properties.Name +
                  "</strong><br>" +
                  "Utilization over last 6 months: <strong>" +
                  parseInt(e.features[0].properties.ResUtil_Heatmap) +
                  "%</strong><br>Use <strong>Ctrl + Click</strong> for more details</div>";

                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                csaStatic_popup
                  .setLngLat(coordinates)
                  .setHTML(description)
                  .addTo(this.map);
              });

              this.map.on("mouseleave", this.source2Layer["csaStatic"], () => {
                this.map.getCanvas().style.cursor = "default";
                csaStatic_popup.remove();
              });

              let flsCircleSettings = {
                "circle-radius": 20,
                "circle-opacity": 0,
                "circle-stroke-color": "#FF0000",
                "circle-stroke-opacity": 1,
                "circle-stroke-width": 3,
              };

              let csesCircleSettings = {
                "circle-opacity": 0,
                "circle-stroke-opacity": 1,
                //3,
                "circle-stroke-width": [
                  "match",
                  ["get", "AssignmentType"],
                  "primary",
                  5,
                  3,
                ],
                "circle-stroke-color": [
                  "match",
                  ["get", "AssignmentType"],
                  "primary",
                  this.connectionsColors.PrimaryCSEID,
                  "secondary",
                  this.connectionsColors.SecondaryCSEID,
                  "tertiary",
                  this.connectionsColors.TertiaryCSEID,
                  "pm",
                  this.connectionsColors.PMCSEID,
                  "#FF0000",
                ],
                "circle-radius": [
                  "match",
                  ["get", "AssignmentType"],
                  "primary",
                  26,
                  "secondary",
                  23,
                  "tertiary",
                  21,
                  "pm",
                  19,
                  20,
                ],
              };

              this.addCircleLayer("flAffected", flsCircleSettings);
              this.addCircleLayer("cseAffected", csesCircleSettings);
              resolve();
            });
          });
        });
      });
    },

    clearTemporaryFLandCSElayers() {
      //empty/reset temporary cse connections layer

      this.clearLayer("singleCSETrainedConnections");
      this.clearLayer("singleCSEUntrainedConnections");
      this.clearLayer("singleFLTrainedConnections");
      this.clearLayer("singleFLUntrainedConnections");

      this.resetLayerVisibility("primaryLines");
      this.resetLayerVisibility("secondaryLines");
      this.resetLayerVisibility("tertiaryLines");
      this.resetLayerVisibility("csePmLines");
      this.resetLayerVisibility("csaPmLines");

      this.selectedFlId = "";
      this.selectedCSEId = "";
      this.selectedCSAId = "";
    },

    checkFLVisible(fl_index) {
      // console.log(this.fl_static[fl_index]);

      if (
        this.getActiveRegionsNames.indexOf(
          this.fl_static[fl_index].RegionID
        ) !== -1
      ) {
        if (
          this.getActiveModalitiesNames.indexOf(
            this.fl_static[fl_index].Modality
          ) !== -1
        ) {
          if (
            this.getActiveStatusNames.indexOf(
              this.fl_static[fl_index].FlContractStatus
            ) !== -1
          ) {
            // return true;
            if (this.selectedFlDesc) {
              return this.fl_static[fl_index].Desc == this.selectedFlDesc;
            } else return true;
          } else return false;
        } else return false;
      } else return false;
    },

    checkCSEVisible(cseId) {
      const cse_index = this.findCSEIndexById(cseId, this.cse_static);
      if (cse_index == -1) return false;

      //todo this needs to check status region + check usage
      if (this.filterCSEbySelectedModalities) {
        let cse_trained_modalities =
          this.cse_static[cse_index].Modalities_Trained;

        const foundModalitiesinCSE = this.getActiveModalitiesNames.some((r) =>
          cse_trained_modalities.includes(r)
        );

        if (this.filterCSEbySelectedPlantSections) {
          if (
            this.getCSEactiveStatusNames.includes(
              this.cse_static[cse_index].Status
            ) &&
            this.getActiveRegionsNames.includes(
              this.cse_static[cse_index].RegionID
            ) &&
            foundModalitiesinCSE
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            this.getCSEactiveStatusNames.includes(
              this.cse_static[cse_index].Status
            ) &&
            foundModalitiesinCSE
          ) {
            return true;
          } else {
            return false;
          }
        }

        // return foundModalitiesinCSE;
      } else {
        if (this.filterCSEbySelectedPlantSections) {
          if (
            this.getCSEactiveStatusNames.includes(
              this.cse_static[cse_index].Status
            ) &&
            this.getActiveRegionsNames.includes(
              this.cse_static[cse_index].RegionID
            )
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          //check only status
          if (
            this.getCSEactiveStatusNames.includes(
              this.cse_static[cse_index].Status
            )
          ) {
            return true;
          } else {
            return false;
          }
        }
      }
    },

    findConnectionsForSelFL(flId) {
      let connArr = [];
      let connArrUntrained = [];

      let index = this.fl_static.findIndex((obj) => {
        return obj.Id === flId;
      });

      if (index !== -1) {
        // console.log(index);
        if (this.checkFLVisible(index)) {
          const fl_cse = this.fl_cse_conn_obj[flId];

          if (fl_cse) {
            let indexOfPrimary = this.selectedCSEdisplayedConnections.findIndex(
              (object) => {
                return object.connType === "primary";
              }
            );
            let indexOfSecondary =
              this.selectedCSEdisplayedConnections.findIndex((object) => {
                return object.connType === "secondary";
              });
            let indexOfTertiary =
              this.selectedCSEdisplayedConnections.findIndex((object) => {
                return object.connType === "tertiary";
              });
            let indexOfTrained = this.selectedCSEdisplayedConnections.findIndex(
              (object) => {
                return object.connType === "trained (unassigned)";
              }
            );
            let indexOfPM = this.selectedCSEdisplayedConnections.findIndex(
              (object) => {
                return object.connType === "PM";
              }
            );

            if (
              indexOfPrimary !== -1 &&
              indexOfSecondary !== -1 &&
              indexOfTertiary !== -1 &&
              indexOfTrained !== -1 &&
              indexOfPM !== -1
            ) {
              const flCoord = [
                this.fl_static[index].RenderLongitude,
                this.fl_static[index].RenderLatitude,
              ];
              // get primary connection
              let timeToTravPrimary = this.findTimeToTravel(
                flId,
                fl_cse["PrimaryCSEID"]
              );
              let cseCoordPrm = this.findCSEcoord(
                fl_cse.PrimaryCSEID,
                this.cse_static
              );

              let primary = null;
              if (this.checkCSEVisible(fl_cse.PrimaryCSEID)) {
                primary = this.createConnectionObj(
                  cseCoordPrm,
                  flCoord,
                  this.connectionsColors.PrimaryCSEID,
                  timeToTravPrimary,
                  this.fl_static[index].Modality,
                  this.fl_static[index].RegionID,
                  this.fl_static[index].FlContractStatus,
                  4
                );
              }

              // get secondary connection
              let timeToTravSecondary = this.findTimeToTravel(
                flId,
                fl_cse["SecondaryCSEID"]
              );
              let cseCoordSec = this.findCSEcoord(
                fl_cse.SecondaryCSEID,
                this.cse_static
              );

              let secondary = null;
              if (this.checkCSEVisible(fl_cse.SecondaryCSEID)) {
                secondary = this.createConnectionObj(
                  cseCoordSec,
                  flCoord,
                  this.connectionsColors.SecondaryCSEID,
                  timeToTravSecondary,
                  this.fl_static[index].Modality,
                  this.fl_static[index].RegionID,
                  this.fl_static[index].FlContractStatus,
                  2
                );
              }

              // get tertiary connection
              let timeToTravTertiary = this.findTimeToTravel(
                flId,
                fl_cse["TertiaryCSEID"]
              );
              let cseCoordTrd = this.findCSEcoord(
                fl_cse.TertiaryCSEID,
                this.cse_static
              );

              let tertiary = null;
              if (this.checkCSEVisible(fl_cse.TertiaryCSEID)) {
                tertiary = this.createConnectionObj(
                  cseCoordTrd,
                  flCoord,
                  this.connectionsColors.TertiaryCSEID,
                  timeToTravTertiary,
                  this.fl_static[index].Modality,
                  this.fl_static[index].RegionID,
                  this.fl_static[index].FlContractStatus,
                  2
                );
              }

              //get PM connection
              let timeToTravelPM = this.findTimeToTravel(
                flId,
                fl_cse["PMCSEID"]
              );
              // console.log(timeToTravelPM);
              let pm = null;
              // is PM CSE or CSA ?
              const pm_cse_index = this.findCSEIndexById(
                fl_cse["PMCSEID"],
                this.cse_static
              );
              if (pm_cse_index !== -1) {
                // PM is CSE
                let cseCoordPM = this.findCSEcoord(
                  fl_cse["PMCSEID"],
                  this.cse_static
                );
                if (this.checkCSEVisible(fl_cse["PMCSEID"])) {
                  pm = this.createConnectionObj(
                    cseCoordPM,
                    flCoord,
                    this.connectionsColors.PMCSEID,
                    timeToTravelPM,
                    this.fl_static[index].Modality,
                    this.fl_static[index].RegionID,
                    this.fl_static[index].FlContractStatus,
                    2
                  );
                }
              }

              const pm_csa_index = this.findCSEIndexById(
                fl_cse["PMCSEID"],
                this.csa_static
              );
              if (pm_csa_index !== -1) {
                // PM is CSA
                let csaCoordPM = this.findCSEcoord(
                  fl_cse["PMCSEID"],
                  this.csa_static
                );
                pm = this.createConnectionObj(
                  csaCoordPM,
                  flCoord,
                  this.connectionsColors.PMCSEID,
                  timeToTravelPM,
                  this.fl_static[index].Modality,
                  this.fl_static[index].RegionID,
                  this.fl_static[index].FlContractStatus,
                  2
                );
              }

              if (this.fl_static[index].Qualified_CSEs) {
                if (
                  primary &&
                  this.selectedCSEdisplayedConnections[indexOfPrimary].active
                ) {
                  if (
                    this.fl_static[index].Qualified_CSEs.indexOf(
                      fl_cse.PrimaryCSEID
                    ) !== -1
                  ) {
                    connArr.push(primary);
                  } else {
                    connArrUntrained.push(primary);
                  }
                }
                // else
                //   console.log("primary not found for FL with Id ", flId);
                if (
                  secondary &&
                  this.selectedCSEdisplayedConnections[indexOfSecondary].active
                ) {
                  if (
                    this.fl_static[index].Qualified_CSEs.indexOf(
                      fl_cse.SecondaryCSEID
                    ) !== -1
                  ) {
                    connArr.push(secondary);
                  } else {
                    connArrUntrained.push(secondary);
                  }
                }
                // else
                //   console.log("secondary not found for FL with Id ", flId);

                if (
                  tertiary &&
                  this.selectedCSEdisplayedConnections[indexOfTertiary].active
                ) {
                  if (
                    this.fl_static[index].Qualified_CSEs.indexOf(
                      fl_cse.TertiaryCSEID
                    ) !== -1
                  ) {
                    connArr.push(tertiary);
                  } else {
                    connArrUntrained.push(tertiary);
                  }
                }

                if (
                  pm &&
                  this.selectedCSEdisplayedConnections[indexOfPM].active
                ) {
                  if (pm_cse_index !== -1) {
                    // PM is CSE
                    if (
                      this.fl_static[index].Qualified_CSEs.indexOf(
                        fl_cse.PMCSEID
                      ) !== -1
                    ) {
                      connArr.push(pm);
                    } else {
                      connArrUntrained.push(pm);
                    }
                  }

                  if (pm_csa_index !== -1) {
                    // PM is CSA
                    if (
                      this.fl_static[index].Qualified_CSAs.indexOf(
                        fl_cse.PMCSEID
                      ) !== -1
                    ) {
                      connArr.push(pm);
                    } else {
                      connArrUntrained.push(pm);
                    }
                  }
                }

                this.fl_static[index].Qualified_CSEs.forEach((elQual) => {
                  //only add trained CSEs if they are not already assigned to FL
                  if (
                    elQual !== fl_cse.PrimaryCSEID &&
                    elQual !== fl_cse.SecondaryCSEID &&
                    elQual !== fl_cse.TertiaryCSEID &&
                    elQual !== fl_cse.PMCSEID
                  ) {
                    let timeToTravelTrained = this.findTimeToTravel(
                      flId,
                      elQual
                    );
                    let cseCoord = this.findCSEcoord(elQual, this.cse_static);

                    let qualified = null;

                    if (this.checkCSEVisible(elQual)) {
                      qualified = this.createConnectionObj(
                        cseCoord,
                        flCoord,
                        this.connectionsColors.TrainedCSE,
                        timeToTravelTrained,
                        this.fl_static[index].Modality,
                        this.fl_static[index].RegionID,
                        this.fl_static[index].FlContractStatus
                      );
                    }

                    if (
                      qualified &&
                      this.selectedCSEdisplayedConnections[indexOfTrained]
                        .active
                    ) {
                      connArr.push(qualified);
                    }
                  }
                });

                this.fl_static[index].Qualified_CSAs.forEach((csaQual) => {
                  if (csaQual !== fl_cse.PMCSEID) {
                    let timeToTravTrainedCSA = this.findTimeToTravel(
                      flId,
                      csaQual
                    );
                    let csaCoord = this.findCSEcoord(csaQual, this.csa_static);

                    let qualifiedCSA = null;
                    qualifiedCSA = this.createConnectionObj(
                      csaCoord,
                      flCoord,
                      this.connectionsColors.TrainedCSE,
                      timeToTravTrainedCSA,
                      this.fl_static[index].Modality,
                      this.fl_static[index].RegionID,
                      this.fl_static[index].FlContractStatus
                    );

                    if (
                      qualifiedCSA &&
                      this.selectedCSEdisplayedConnections[indexOfTrained]
                        .active
                    ) {
                      connArr.push(qualifiedCSA);
                    }
                  }
                });
              }
            }
          }
        }
      }
      // console.log(flId);
      return { trained: connArr, untrained: connArrUntrained };
    },
    addTempConnectionsOfSelFL(flId) {
      let tempConn = this.findConnectionsForSelFL(flId);

      let cseConnData = {
        type: "FeatureCollection",
        features: tempConn.trained,
      };
      this.setDataToLayer(cseConnData, "singleFLTrainedConnections");

      let untrConnData = {
        type: "FeatureCollection",
        features: tempConn.untrained,
      };

      this.setDataToLayer(untrConnData, "singleFLUntrainedConnections");
    },

    addCseConnectionToArr(
      el,
      fl_index,
      fl_cse,
      connectionType,
      cseId,
      cseCoord,
      qualifLabel,
      trainedFoundConn,
      untrainedFoundConn,
      lineWidth = 2
    ) {
      const flCoord = [
        this.fl_static[fl_index].RenderLongitude,
        this.fl_static[fl_index].RenderLatitude,
      ];

      // console.log(flCoord);
      let timeToTrav = this.findTimeToTravel(el.FLID, fl_cse[connectionType]);
      // console.log(timeToTrav);
      let elOfRank = this.createConnectionObj(
        cseCoord,
        flCoord,
        this.connectionsColors[connectionType],
        timeToTrav,
        this.fl_static[fl_index].Modality,
        this.fl_static[fl_index].RegionID,
        this.fl_static[fl_index].FlContractStatus,
        lineWidth
      );

      if (this.fl_static[fl_index][qualifLabel]) {
        if (elOfRank) {
          if (this.fl_static[fl_index][qualifLabel].indexOf(cseId) !== -1) {
            trainedFoundConn.push(elOfRank);
          } else {
            untrainedFoundConn.push(elOfRank);
          }
        }
        // else
        //   console.log(`${connectionType} not found for FL with Id ${el.FLID}`);
      }
    },

    findCseConnectionOfType(connectionType, cseId, cseCoord, lineWidth = 2) {
      let trainedFoundConn = [];
      let untrainedFoundConn = [];

      let flWhereRank = this.fl_to_cses_conn_arr.filter((el) => {
        return el[connectionType] === cseId;
      });

      flWhereRank.forEach((el) => {
        const fl_cse = this.fl_cse_conn_obj[el.FLID];

        if (fl_cse) {
          const fl_index = this.fl_static.findIndex((object) => {
            return object.Id === el.FLID;
          });

          if (fl_index !== -1) {
            if (this.checkFLVisible(fl_index) && this.checkCSEVisible(cseId)) {
              this.addCseConnectionToArr(
                el,
                fl_index,
                fl_cse,
                connectionType,
                cseId,
                cseCoord,
                "Qualified_CSEs",
                trainedFoundConn,
                untrainedFoundConn,
                lineWidth
              );
            }
          }
        }
      });
      return { trained: trainedFoundConn, untrained: untrainedFoundConn };
    },

    findCsaConnectionOfType(connectionType, csaId, csaCoord) {
      let trainedFoundConn = [];
      let untrainedFoundConn = [];

      let flWhereRank = this.fl_to_cses_conn_arr.filter((el) => {
        return el[connectionType] === csaId;
      });

      flWhereRank.forEach((el) => {
        const fl_cse = this.fl_cse_conn_obj[el.FLID];

        if (fl_cse) {
          const fl_index = this.fl_static.findIndex((object) => {
            return object.Id === el.FLID;
          });
          if (fl_index !== -1) {
            if (this.checkFLVisible(fl_index)) {
              this.addCseConnectionToArr(
                el,
                fl_index,
                fl_cse,
                connectionType,
                csaId,
                csaCoord,
                "Qualified_CSAs",
                trainedFoundConn,
                untrainedFoundConn
              );
            }
          }
        }
      });
      return { trained: trainedFoundConn, untrained: untrainedFoundConn };
    },

    findFlsWhereCseTrained(cseId, cseCoord) {
      let connQualified = [];

      let flsWhereQualified = this.fl_static.filter((el) => {
        return el.Qualified_CSEs.indexOf(cseId) !== -1;
      });
      // console.log(cseCoord);
      // console.log(flsWhereQualified);

      let assignedFls = [];
      let flsWherePrimary = this.fl_to_cses_conn_arr
        .filter((el) => {
          return el["PrimaryCSEID"] === cseId;
        })
        .map((e) => e.FLID);

      let flsWhereSecondary = this.fl_to_cses_conn_arr
        .filter((el) => {
          return el["SecondaryCSEID"] === cseId;
        })
        .map((e) => e.FLID);

      let flsWhereTertiary = this.fl_to_cses_conn_arr
        .filter((el) => {
          return el["TertiaryCSEID"] === cseId;
        })
        .map((e) => e.FLID);

      let flsWherePm = this.fl_to_cses_conn_arr
        .filter((el) => {
          return el["PMCSEID"] === cseId;
        })
        .map((e) => e.FLID);

      assignedFls = assignedFls.concat(
        flsWherePrimary,
        flsWhereSecondary,
        flsWhereTertiary,
        flsWherePm
      );

      let flsWhereQualifiedButNotAssigned = flsWhereQualified.filter((item) => {
        return assignedFls.indexOf(item.Id) === -1;
      });

      // console.log(flsWhereQualifiedButNotAssigned);

      flsWhereQualifiedButNotAssigned.forEach((elQual) => {
        //only add trained CSEs if they are not already assigned to FL

        let timeToTravelTrained = this.findTimeToTravel(elQual.Id, cseId);

        let qualified = null;

        const index_qual = this.fl_static.findIndex((object) => {
          return object.Id === elQual.Id;
        });

        if (index_qual !== -1) {
          if (this.checkFLVisible(index_qual) && this.checkCSEVisible(cseId)) {
            qualified = this.createConnectionObj(
              cseCoord,
              [elQual.RenderLongitude, elQual.RenderLatitude],
              this.connectionsColors.TrainedCSE,
              timeToTravelTrained,
              elQual.Modality,
              elQual.RegionID,
              elQual.FlContractStatus
            );
          }
        }

        if (qualified) {
          connQualified.push(qualified);
        }
      });

      // console.log(assignedFls);

      return connQualified;
    },

    findFlsWhereCsaTrained(csaId, csaCoord) {
      let connQualified = [];

      let flsWhereQualified = this.fl_static.filter((el) => {
        return el.Qualified_CSAs.indexOf(csaId) !== -1;
      });

      let flsWherePm = this.fl_to_cses_conn_arr
        .filter((el) => {
          return el["PMCSEID"] === csaId;
        })
        .map((e) => e.FLID);

      let flsWhereQualifiedButNotAssigned = flsWhereQualified.filter((item) => {
        return flsWherePm.indexOf(item.Id) === -1;
      });

      flsWhereQualifiedButNotAssigned.forEach((elQual) => {
        let timeToTravelTrained = this.findTimeToTravel(elQual.Id, csaId);

        let qualified = null;

        const index_qual = this.fl_static.findIndex((object) => {
          return object.Id === elQual.Id;
        });

        if (index_qual !== -1) {
          if (this.checkFLVisible(index_qual)) {
            qualified = this.createConnectionObj(
              csaCoord,
              [elQual.RenderLongitude, elQual.RenderLatitude],
              this.connectionsColors.TrainedCSE,
              timeToTravelTrained,
              elQual.Modality,
              elQual.RegionID,
              elQual.FlContractStatus
            );
          }
        }

        if (qualified) {
          connQualified.push(qualified);
        }
      });
      return connQualified;
    },

    findConnectionsForSelCSE(cseId, cseCoord) {
      let connArrTrained = [];
      let connArrUntrained = [];

      let indexOfPrimary = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "primary";
        }
      );
      let indexOfSecondary = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "secondary";
        }
      );
      let indexOfTertiary = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "tertiary";
        }
      );
      let indexOfTrained = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "trained (unassigned)";
        }
      );
      let indexOfPM = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "PM";
        }
      );

      if (
        indexOfPrimary !== -1 &&
        indexOfSecondary !== -1 &&
        indexOfTertiary !== -1 &&
        indexOfTrained !== -1 &&
        indexOfPM !== -1
      ) {
        let primConn = this.findCseConnectionOfType(
          "PrimaryCSEID",
          cseId,
          cseCoord,
          4
        );
        let secConn = this.findCseConnectionOfType(
          "SecondaryCSEID",
          cseId,
          cseCoord
        );
        let trdConn = this.findCseConnectionOfType(
          "TertiaryCSEID",
          cseId,
          cseCoord
        );
        let pmConn = this.findCseConnectionOfType("PMCSEID", cseId, cseCoord);
        // console.log(pmConn);
        let trainedConn = this.findFlsWhereCseTrained(cseId, cseCoord);

        if (this.selectedCSEdisplayedConnections[indexOfPrimary].active) {
          connArrTrained = connArrTrained.concat(primConn.trained);
          connArrUntrained = connArrUntrained.concat(primConn.untrained);
        }

        if (this.selectedCSEdisplayedConnections[indexOfSecondary].active) {
          connArrTrained = connArrTrained.concat(secConn.trained);
          connArrUntrained = connArrUntrained.concat(secConn.untrained);
        }
        if (this.selectedCSEdisplayedConnections[indexOfTertiary].active) {
          connArrTrained = connArrTrained.concat(trdConn.trained);
          connArrUntrained = connArrUntrained.concat(trdConn.untrained);
        }
        if (this.selectedCSEdisplayedConnections[indexOfPM].active) {
          connArrTrained = connArrTrained.concat(pmConn.trained);
          connArrUntrained = connArrUntrained.concat(pmConn.untrained);
        }
        if (this.selectedCSEdisplayedConnections[indexOfTrained].active) {
          connArrTrained = connArrTrained.concat(trainedConn);
        }
      }

      return { trained: connArrTrained, untrained: connArrUntrained };
    },

    findConnectionsForSelCSA(csaId, csaCoord) {
      let connArrTrained = [];
      let connArrUntrained = [];

      let indexOfTrained = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "trained (unassigned)";
        }
      );
      let indexOfPM = this.selectedCSEdisplayedConnections.findIndex(
        (object) => {
          return object.connType === "PM";
        }
      );

      if (indexOfTrained !== -1 && indexOfPM !== -1) {
        let pmConn = this.findCsaConnectionOfType("PMCSEID", csaId, csaCoord);

        let trainedConn = this.findFlsWhereCsaTrained(csaId, csaCoord);

        if (this.selectedCSEdisplayedConnections[indexOfPM].active) {
          connArrTrained = connArrTrained.concat(pmConn.trained);
          connArrUntrained = connArrUntrained.concat(pmConn.untrained);
        }
        if (this.selectedCSEdisplayedConnections[indexOfTrained].active) {
          connArrTrained = connArrTrained.concat(trainedConn);
        }
      }

      return { trained: connArrTrained, untrained: connArrUntrained };
    },

    addTempConnectionsOfSelCSE(cseId, cseCoord) {
      let tempConn = this.findConnectionsForSelCSE(cseId, cseCoord);
      let cseTrainedConnData = {
        type: "FeatureCollection",
        features: tempConn.trained,
      };
      this.setDataToLayer(cseTrainedConnData, "singleCSETrainedConnections");

      let cseUntrainedConnData = {
        type: "FeatureCollection",
        features: tempConn.untrained,
      };
      this.setDataToLayer(
        cseUntrainedConnData,
        "singleCSEUntrainedConnections"
      );
    },

    addTempConnectionsOfSelCSA(csaId, csaCoord) {
      let tempConn = this.findConnectionsForSelCSA(csaId, csaCoord);
      let csaTrainedConnData = {
        type: "FeatureCollection",
        features: tempConn.trained,
      };
      this.setDataToLayer(csaTrainedConnData, "singleCSETrainedConnections");

      let csaUntrainedConnData = {
        type: "FeatureCollection",
        features: tempConn.untrained,
      };
      this.setDataToLayer(
        csaUntrainedConnData,
        "singleCSEUntrainedConnections"
      );
    },

    setDataToLayer(data, sourceName) {
      this.map.getSource(sourceName).setData(data);
      this.map.setLayoutProperty(
        this.source2Layer[sourceName],
        "visibility",
        "visible"
      );
    },

    addEmptySource(sourceName) {
      this.map.addSource(sourceName, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
    },

    addEmptyLinesLayer(sourceName) {
      this.addEmptySource(sourceName);

      this.map.addLayer({
        id: this.source2Layer[sourceName],
        type: "line",
        source: sourceName,
        paint: {
          "line-width": ["get", "linewidth"],
          // Use a get expression (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-get)
          // to set the line-color to a feature property value.
          "line-color": ["get", "color"],
          "line-opacity": 0.7,
        },
      });
    },

    addEmptyDashedLinesLayer(sourceName) {
      this.addEmptySource(sourceName);

      this.map.addLayer({
        id: this.source2Layer[sourceName],
        type: "line",
        source: sourceName,
        paint: {
          "line-width": ["get", "linewidth"],
          // Use a get expression (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-get)
          // to set the line-color to a feature property value.
          "line-color": ["get", "color"],
          "line-opacity": 0.5,
          "line-dasharray": [4, 4],
        },
      });
    },

    addLinesLayer(sourceName) {
      this.addEmptyLinesLayer(sourceName);

      // this.map.on('click', this.source2Layer[sourceName], (e) => {
      //   // Copy coordinates array.
      //   // console.log(e);
      //   const coordinatesA = e.features[0].geometry.coordinates[0].slice();
      //   const coordinatesB = e.features[0].geometry.coordinates[1].slice();
      //   const coordinates = [(coordinatesA[0] + coordinatesB[0]) / 2, (coordinatesA[1] + coordinatesB[1]) / 2]
      //   const description = e.features[0].properties.title;

      //   // console.log(coordinates);
      //   // Ensure that if the map is zoomed out such that multiple
      //   // copies of the feature are visible, the popup appears
      //   // over the copy being pointed to.
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   }

      //   new mapboxgl.Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(description)
      //     .addTo(this.map);
      // });

      const lineLayer_popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      });

      this.map.on("mouseenter", this.source2Layer[sourceName], (e) => {
        // Change the cursor style as a UI indicator.
        this.map.getCanvas().style.cursor = "pointer";

        const coordinates = [e.lngLat.lng, e.lngLat.lat];
        const description = e.features[0].properties.title;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // Populate the popup and set its coordinates
        // based on the feature found.
        lineLayer_popup
          .setLngLat(coordinates)
          .setHTML(description)
          .addTo(this.map);
      });

      this.map.on("mouseleave", this.source2Layer[sourceName], () => {
        this.map.getCanvas().style.cursor = "default";
        lineLayer_popup.remove();
      });
    },

    addCircleLayer(sourceName, paintProps) {
      this.addEmptySource(sourceName);

      this.map.addLayer({
        id: this.source2Layer[sourceName],
        type: "circle",
        source: sourceName,
        paint: paintProps,
      });
    },

    addCSlayer(sourceName) {
      this.addEmptySource(sourceName);
      this.map.addLayer({
        id: this.source2Layer[sourceName],
        type: "symbol",
        source: sourceName,
        layout: {
          "icon-image": ["get", "Icon"],
          "icon-size": ["get", "IconSize"],
          "icon-allow-overlap": true,
        },
        paint: {
          "icon-color": ["get", "IconColor"],
          "icon-opacity": 0.5,
        },
      });

      // map.addLayer({
      //   id: "bus-layer",
      //   type: "symbol",
      //   source: "bus-source", // reference the data source
      //   layout: {
      //     "icon-image": ["get", "icon"], // reference the icon in properties
      //     "icon-size": 0.2,
      //   },
      // });
    },

    getServiceRegionData() {
      // let that = this;

      let user = this.oidcUser ? this.oidcUser.email : "";
      axios
        .get(
          this.backendURL +
            "/api/service_current_data/" +
            this.selectedCountry.iso_3166_1 +
            "/" +
            this.area +
            "?username=" +
            user
        )
        .then((res) => {
          // console.log("Service Regions data loaded!");

          this.getActionRecommendations({
            area: this.area,
            selecteddivision: this.selecteddivision,
          });

          if(this.buildDestination === 'development')
          {
            this.getTrainingsRecommendations({ area: this.area });
          }

          if ("Longitude" in res.data) this.Longitude = res.data.Longitude;
          if ("Latitude" in res.data) this.Latitude = res.data.Latitude;

          this.initMap()
            .then(() => {
              this.map.once("idle", () => {
                this.map.resize();
                this.loadingRegionData = false;

                this.populateRegOrZoneData(res.data);
              });
            })
            .catch((err) => {
              console.log(err);
              let notification = {
                type: "error",
                label: "Map error",
                // duration: "short",
                text: "Error wile loading map!",
              };
              this.pushNotification(notification);
            });
        })
        .catch((err) => {
          console.log(err);
          this.loadingRegionData = false;

          this.cleanup();
          let notification = {
            type: "error",
            label: "No data",
            duration: "short",
            text: "No data available for plant section " + this.area,
          };
          this.pushNotification(notification);
        });
    },

    getZoneData() {
      let user = this.oidcUser ? this.oidcUser.email : "";
      axios
        .get(
          this.backendURL +
            "/api/service_zone_current_data/" +
            this.selectedCountry.iso_3166_1 +
            "/" +
            this.area +
            "?username=" +
            user
        )
        .then((res) => {
          this.loadingZoneData = false;

          this.getActionRecommendations({
            area: this.area,
            selecteddivision: this.selecteddivision,
          });

          // this.getTrainingsRecommendations({ area: this.area });

          if ("Longitude" in res.data) this.Longitude = res.data.Longitude;
          if ("Latitude" in res.data) this.Latitude = res.data.Latitude;

          this.initMap()
            .then(() => {
              this.map.once("idle", () => {
                this.map.resize();
                this.loadingZoneData = false;

                this.populateRegOrZoneData(res.data);
              });
            })
            .catch((err) => {
              console.log(err);
              let notification = {
                type: "error",
                label: "Map error",
                // duration: "short",
                text: "Error wile loading map!",
              };
              this.pushNotification(notification);
            });
        })
        .catch((err) => {
          console.log(err);

          this.loadingZoneData = false;

          this.cleanup();
          let notification = {
            type: "error",
            label: "No data",
            duration: "short",
            text: "No data available for zone " + this.area,
          };
          this.pushNotification(notification);
        });
    },

    populateRegOrZoneData(data) {
      if ("FLs" in data && "WallClock_Heatmap" in data) {
        let formattedFLs = this.formatFLdata(data.FLs, data.WallClock_Heatmap);
        this.setFLs(formattedFLs);
        this.setMOdalitiesDesc(formattedFLs);
      }

      const uniqueRegions = [...new Set(data.FLs.map((item) => item.RegionID))];
      let regionsObjsArr = uniqueRegions.map((item) => {
        const container = {};

        container.regionName = item;
        container.active = true;

        return container;
      });

      this.setRegions(regionsObjsArr);

      if ("Modality_List" in data) {
        let modalitiesObj = data.Modality_List.sort().map((el) => {
          return { Modality: el, active: true };
        });

        this.setModalities(modalitiesObj);
        this.setModalitiesNamesList(data.Modality_List.sort());
      }
      if ("CSEs" in data && "ResUtil_Heatmap" in data) {
        let cses = data.CSEs.filter((el) => {
          return el.Role != "CSE AA";
        });
        let csas = data.CSEs.filter((el) => {
          return el.Role == "CSE AA";
        });
        //CSE AA

        this.setCSEs(this.formatCSEdata(cses, data.ResUtil_Heatmap));

        this.getCSEsPreferedModalities({
          area: this.area,
          country: this.country,
        });

        this.setCSAs(this.formatCSAdata(csas, data.ResUtil_Heatmap));
      }

      this.setFlsCsesNames();

      if ("FL_CSEs" in data) {
        this.fl_to_cses_conn_arr = Object.assign([], data.FL_CSEs);
      }

      if ("FL_CSEs" in data) {
        const fl_conn = data.FL_CSEs.reduce((acc, connObj) => {
          acc[connObj.FLID] = connObj;
          return acc;
        }, {});

        this.setConnectionObj(fl_conn);
      }

      // this.map.setCenter([data.Longitude, data.Latitude]);

      if ("LastUpdated" in data) this.lastUpdated = data.LastUpdated;

      this.convert2geojson(
        "cseStatic",
        this.cse_static,
        "RenderLatitude",
        "RenderLongitude"
      );
      this.convert2geojson(
        "csaStatic",
        this.csa_static,
        "RenderLatitude",
        "RenderLongitude"
      );
      this.convert2geojson(
        "flStatic",
        this.fl_static,
        "RenderLatitude",
        "RenderLongitude"
      );
      this.getConnectionsGeoJson();
      let res_utiliz_forecast_noActions = [];
      if ("Forecast_ResUtil_Histogram" in data) {
        res_utiliz_forecast_noActions = this.formatDataForChart(
          data.Forecast_ResUtil_Histogram,
          "ResourceUtilization",
          "ResourceUtilization_min",
          "ResourceUtilization_max"
        );
      }

      this.resource_utilization_chart_data_linechart = {
        ...this.resource_utilization_chart_data_linechart,
        forcastednoaction: res_utiliz_forecast_noActions,
      };

      let res_utiliz_actual = [];
      if ("ResUtil_Histogram" in data) {
        res_utiliz_actual = this.formatDataForChart(
          data.ResUtil_Histogram,
          "ResourceUtilization",
          "ResourceUtilization_min",
          "ResourceUtilization_max"
        );
      }
      this.resource_utilization_chart_data_linechart = {
        ...this.resource_utilization_chart_data_linechart,
        historical: res_utiliz_actual,
      };

      let wall_clock_forecast_noActions = [];
      if ("Forecast_Wallclock_Histogram" in data) {
        wall_clock_forecast_noActions = this.formatDataForChart(
          data.Forecast_Wallclock_Histogram,
          "Wallclock",
          "Wallclock_min",
          "Wallclock_max"
        );
      }
      this.wall_clock_chart_data_linechart = {
        ...this.wall_clock_chart_data_linechart,
        forcastednoaction: wall_clock_forecast_noActions,
      };

      let wall_clock_actual = [];
      if ("WallClock_Histogram" in data) {
        wall_clock_actual = this.formatDataForChart(
          data.WallClock_Histogram,
          "Wallclock",
          "Wallclock_min",
          "Wallclock_max"
        );
      }
      this.wall_clock_chart_data_linechart = {
        ...this.wall_clock_chart_data_linechart,
        historical: wall_clock_actual,
      };

      let gated_wall_clock_forecast_noActions = [];
      if ("Forecast_GatedWallclock_Histogram" in data) {
        gated_wall_clock_forecast_noActions = this.formatDataForChart(
          data.Forecast_GatedWallclock_Histogram,
          "Wallclock",
          "Wallclock_min",
          "Wallclock_max"
        );
      }
      this.gated_wall_clock_chart_data_linechart = {
        ...this.gated_wall_clock_chart_data_linechart,
        forcastednoaction: gated_wall_clock_forecast_noActions,
      };

      let gated_wall_clock_actual = [];
      if ("GatedWallClock_Histogram" in data) {
        gated_wall_clock_actual = this.formatDataForChart(
          data.GatedWallClock_Histogram,
          "Wallclock",
          "Wallclock_min",
          "Wallclock_max"
        );
      }
      this.gated_wall_clock_chart_data_linechart = {
        ...this.gated_wall_clock_chart_data_linechart,
        historical: gated_wall_clock_actual,
      };

      let travel_time_forecast_noActions = [];
      if ("Forecast_TravelTime_Histogram" in data) {
        travel_time_forecast_noActions = this.formatDataForChart(
          data.Forecast_TravelTime_Histogram,
          "TravelTime",
          "TravelTime_min",
          "TravelTime_max"
        );
      }
      this.travel_time_chart_data_linechart = {
        ...this.travel_time_chart_data_linechart,
        forcastednoaction: travel_time_forecast_noActions,
      };

      let travel_time_actual = [];
      if ("TravelTime_Histogram" in data) {
        travel_time_actual = this.formatDataForChart(
          data.TravelTime_Histogram,
          "TravelTime",
          "TravelTime_min",
          "TravelTime_max"
        );
      }
      this.travel_time_chart_data_linechart = {
        ...this.travel_time_chart_data_linechart,
        historical: travel_time_actual,
      };
    },

    getTravelTimes() {
      if (this.selecteddivision == "ImagingZone") {
        this.loadingZoneData = true;
        axios
          .get(
            this.backendURL +
              "/api/zone_travel_time_map/" +
              this.selectedCountry.iso_3166_1 +
              "/" +
              this.area
          )
          .then((res) => {
            this.zone_travel_time_map = res.data;
            this.getZoneData();
            this.getDowngradeOptions();
            this.getDashboardLink();
          })
          .catch((err) => {
            console.log(err);
            let notification = {
              type: "warning",
              label: "No travel times for zone",
              duration: "short",
              text: "No travel times available for zone " + this.area,
            };
            this.pushNotification(notification);

            this.getZoneData();
            this.getDowngradeOptions();
            this.getDashboardLink();
          });
      } else {
        this.loadingRegionData = true;
        axios
          .get(
            this.backendURL +
              "/api/travel_time_map/" +
              this.selectedCountry.iso_3166_1 +
              "/" +
              this.area
          )
          .then((res) => {
            this.travel_time_map = res.data;
            this.getServiceRegionData();
            this.getDowngradeOptions();
            this.getDashboardLink();
          })
          .catch((err) => {
            console.log(err);
            let notification = {
              type: "warning",
              label: "No travel times",
              duration: "short",
              text: "No travel times available for region " + this.area,
            };
            this.pushNotification(notification);

            this.getServiceRegionData();
            this.getDowngradeOptions();
            this.getDashboardLink();
          });
      }
    },

    sortFct(a, b) {
      var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    },

    formatDataForChart(data, label, min_label = label, maxLabel = label) {
      let formatedArr = data.map((el) => {
        var year = el.Timestamp.substring(0, 4);
        var month = el.Timestamp.substring(5, 7);
        var day = el.Timestamp.substring(8, 10);
        var hour = el.Timestamp.substring(11, 13);
        var min = el.Timestamp.substring(14, 16);

        return {
          when: year + "-" + month + "-" + day + " " + hour + ":" + min,
          y: el[label],
          y0: el[min_label],
          y1: el[maxLabel],
        };
      });

      return formatedArr;
    },

    formatCSEdata(cses, resUtil) {
      let formatAr = cses.map((el) => {
        const resUtilIndex = resUtil.findIndex((obj) => {
          return obj.CSEID === el.Id;
        });

        if (resUtilIndex === -1) {
          return {
            ...el,
            ResUtil_Heatmap: null,
            ResUtil_Heatmap_Categ: null,
            IconColor: null,
            Icon: "CSE-icon",
            IconSize: 1,
          };
        } else {
          if (
            resUtil[resUtilIndex].ResourceUtilization >= 0 &&
            resUtil[resUtilIndex].ResourceUtilization < 33
          ) {
            return {
              ...el,
              ResUtil_Heatmap_Categ: "Low",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              IconColor: "#0000bf",
              Icon: "CSE-icon",
              IconSize: 1,
            };
          } else if (
            resUtil[resUtilIndex].ResourceUtilization >= 33 &&
            resUtil[resUtilIndex].ResourceUtilization < 85
          ) {
            return {
              ...el,
              ResUtil_Heatmap_Categ: "Med",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              IconColor: "#007d00",
              Icon: "CSE-icon",
              IconSize: 1,
            };
          } else if (resUtil[resUtilIndex].ResourceUtilization >= 85) {
            return {
              ...el,
              ResUtil_Heatmap_Categ: "High",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              IconColor: "#bf0000",
              Icon: "CSE-icon",
              IconSize: 1,
            };
          }
        }
      });

      return formatAr;
    },

    formatCSAdata(csas, resUtil) {
      let csasWithIcons = csas.map((el) => {
        const resUtilIndex = resUtil.findIndex((obj) => {
          return obj.CSEID === el.Id;
        });

        if (resUtilIndex === -1) {
          return {
            ...el,
            Icon: "CSA-icon",
            IconSize: 0.5,
            IconColor: "#4472C4",
            ResUtil_Heatmap: null,
          };
        } else {
          if (
            resUtil[resUtilIndex].ResourceUtilization >= 0 &&
            resUtil[resUtilIndex].ResourceUtilization < 33
          ) {
            return {
              ...el,
              Icon: "CSA-icon",
              IconSize: 0.5,
              IconColor: "#0000bf",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              ResUtil_Heatmap_Categ: "Low",
            };
          } else if (
            resUtil[resUtilIndex].ResourceUtilization >= 33 &&
            resUtil[resUtilIndex].ResourceUtilization < 85
          ) {
            return {
              ...el,
              Icon: "CSA-icon",
              IconSize: 0.5,
              IconColor: "#007d00",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              ResUtil_Heatmap_Categ: "Med",
            };
          } else if (resUtil[resUtilIndex].ResourceUtilization >= 85) {
            return {
              ...el,
              Icon: "CSA-icon",
              IconSize: 0.5,
              IconColor: "#bf0000",
              ResUtil_Heatmap: parseInt(
                resUtil[resUtilIndex].ResourceUtilization
              ),
              ResUtil_Heatmap_Categ: "High",
            };
          }
        }
      });

      return csasWithIcons;
    },

    formatFLdata(fls, wallclock) {
      let contractNames = [
        "CONTRACT",
        "WARRANTY",
        "EXTENDED WARRANTY",
        "COURTESY",
      ];
      let formatArr = fls.map((el) => {
        const wallClkIndex = wallclock.findIndex((obj) => {
          return obj.FunctionalLocation === el.Id;
        });

        if (wallClkIndex === -1) {
          return {
            ...el,
            AverageWallclockTime: null,
            FlContractStatus:
              contractNames.indexOf(el.BillingStatus) > -1
                ? "Contract"
                : "No Contract",
          };
        } else {
          return {
            ...el,
            AverageWallclockTime: Math.abs(
              parseInt(wallclock[wallClkIndex].AverageWallclockTime)
            ),
            FlContractStatus:
              contractNames.indexOf(el.BillingStatus) > -1
                ? "Contract"
                : "No Contract",
          };
        }
      });

      // console.log(formatArr);
      return formatArr;
    },

    getConnectionsGeoJson() {
      let primaryFeatArray = [],
        secondaryFeatArray = [],
        tertiaryFeatArray = [],
        pmCSEFeatArray = [],
        pmCSAFeatArray = [];

      this.fl_static.forEach((fl, index) => {
        const fl_cse = this.fl_cse_conn_obj[fl.Id];

        if (fl_cse) {
          const flCoord = [
            this.fl_static[index].RenderLongitude,
            this.fl_static[index].RenderLatitude,
          ];

          let timeToTravPrimary = this.findTimeToTravel(
            fl.Id,
            fl_cse["PrimaryCSEID"]
          );

          let cseCoordPrim = this.findCSEcoord(
            fl_cse.PrimaryCSEID,
            this.cse_static
          );

          const pr_cse_index = this.findCSEIndexById(
            fl_cse.PrimaryCSEID,
            this.cse_static
          );
          let pr_cse_trained_modalities = [];
          let pr_cseReg = "";
          let pr_cseStat = "";
          if (pr_cse_index !== -1) {
            pr_cse_trained_modalities =
              this.cse_static[pr_cse_index].Modalities_Trained;
            pr_cseReg = this.cse_static[pr_cse_index].RegionID;
            pr_cseStat = this.cse_static[pr_cse_index].Status;
          }

          // console.log(pr_cse_trained_modalities);

          let primary = this.createConnectionObj(
            cseCoordPrim,
            flCoord,
            this.connectionsColors.PrimaryCSEID,
            timeToTravPrimary,
            this.fl_static[index].Modality,
            this.fl_static[index].RegionID,
            this.fl_static[index].FlContractStatus,
            1,
            pr_cse_trained_modalities,
            pr_cseReg,
            pr_cseStat,
            this.fl_static[index].Desc
          );

          if (primary) {
            // console.log("primary", primary);
            primaryFeatArray.push(primary);
          }
          // else
          //   console.log("primary not found for FL with Id ", fl.Id);
          let timeToTravSecondary = this.findTimeToTravel(
            fl.Id,
            fl_cse["SecondaryCSEID"]
          );
          let cseCoordSec = this.findCSEcoord(
            fl_cse.SecondaryCSEID,
            this.cse_static
          );
          //todo restructure such that findCSEIndexById is not called twice
          const sec_cse_index = this.findCSEIndexById(
            fl_cse.SecondaryCSEID,
            this.cse_static
          );
          let sec_cse_trained_modalities = [];
          let sec_cseReg = "";
          let sec_cseStat = "";
          if (sec_cse_index !== -1) {
            sec_cse_trained_modalities =
              this.cse_static[sec_cse_index].Modalities_Trained;
            sec_cseReg = this.cse_static[sec_cse_index].RegionID;
            sec_cseStat = this.cse_static[sec_cse_index].Status;
          }

          let secondary = this.createConnectionObj(
            cseCoordSec,
            flCoord,
            this.connectionsColors.SecondaryCSEID,
            timeToTravSecondary,
            this.fl_static[index].Modality,
            this.fl_static[index].RegionID,
            this.fl_static[index].FlContractStatus,
            1,
            sec_cse_trained_modalities,
            sec_cseReg,
            sec_cseStat,
            this.fl_static[index].Desc
          );
          if (secondary) {
            // console.log("secondary", secondary);
            secondaryFeatArray.push(secondary);
          }
          // else
          //   console.log("secondary not found for FL with Id ", fl.Id);
          let timeToTravTertiary = this.findTimeToTravel(
            fl.Id,
            fl_cse["TertiaryCSEID"]
          );
          let cseCoordTrd = this.findCSEcoord(
            fl_cse.TertiaryCSEID,
            this.cse_static
          );

          const tr_cse_index = this.findCSEIndexById(
            fl_cse.TertiaryCSEID,
            this.cse_static
          );
          let tr_cse_trained_modalities = [];
          let tr_cseReg = "";
          let tr_cseStat = "";
          if (tr_cse_index !== -1) {
            tr_cse_trained_modalities =
              this.cse_static[tr_cse_index].Modalities_Trained;
            tr_cseReg = this.cse_static[tr_cse_index].RegionID;
            tr_cseStat = this.cse_static[tr_cse_index].Status;
          }

          let tertiary = this.createConnectionObj(
            cseCoordTrd,
            flCoord,
            this.connectionsColors.TertiaryCSEID,
            timeToTravTertiary,
            this.fl_static[index].Modality,
            this.fl_static[index].RegionID,
            this.fl_static[index].FlContractStatus,
            1,
            tr_cse_trained_modalities,
            tr_cseReg,
            tr_cseStat,
            this.fl_static[index].Desc
          );
          if (tertiary) {
            tertiaryFeatArray.push(tertiary);
          }
          // else
          //   console.log("tertiary not found  for FL with Id ", fl.Id);

          let timeToTravPM = this.findTimeToTravel(fl.Id, fl_cse["PMCSEID"]);
          // is PM CSE or CSA ?
          const pm_cse_index = this.findCSEIndexById(
            fl_cse["PMCSEID"],
            this.cse_static
          );
          if (pm_cse_index !== -1) {
            // PM is CSE
            let cseCoordPM = this.findCSEcoord(fl_cse.PMCSEID, this.cse_static);

            let pm_cse_trained_modalities = [],
              pm_cse_reg = "",
              pm_cse_stat = "";
            if (pm_cse_index !== -1) {
              pm_cse_trained_modalities =
                this.cse_static[pm_cse_index].Modalities_Trained;
              pm_cse_reg = this.cse_static[pm_cse_index].RegionID;
              pm_cse_stat = this.cse_static[pm_cse_index].Status;
            }

            let pmCSE = this.createConnectionObj(
              cseCoordPM,
              flCoord,
              this.connectionsColors.PMCSEID,
              timeToTravPM,
              this.fl_static[index].Modality,
              this.fl_static[index].RegionID,
              this.fl_static[index].FlContractStatus,
              1,
              pm_cse_trained_modalities,
              pm_cse_reg,
              pm_cse_stat,
              this.fl_static[index].Desc
            );

            if (pmCSE) {
              pmCSEFeatArray.push(pmCSE);
            }
          }

          const pm_csa_index = this.findCSEIndexById(
            fl_cse["PMCSEID"],
            this.csa_static
          );
          if (pm_csa_index !== -1) {
            // PM is CSA
            let csaCoordPM = this.findCSEcoord(
              fl_cse["PMCSEID"],
              this.csa_static
            );
            let pmCSA = this.createConnectionObj(
              csaCoordPM,
              flCoord,
              this.connectionsColors.PMCSEID,
              timeToTravPM,
              this.fl_static[index].Modality,
              this.fl_static[index].RegionID,
              this.fl_static[index].FlContractStatus,
              1,
              [],
              "",
              "",
              this.fl_static[index].Desc
            ); //todo should I also filter the PM connections ny PM status? it is available in the csa_static

            if (pmCSA) {
              pmCSAFeatArray.push(pmCSA);
            }
          }
        }
      });

      // console.log("FeatArray ", FeatArray);

      let primarySource = {
        type: "FeatureCollection",
        features: primaryFeatArray,
      };
      let secSource = {
        type: "FeatureCollection",
        features: secondaryFeatArray,
      };
      let trdSource = {
        type: "FeatureCollection",
        features: tertiaryFeatArray,
      };
      let pmCSESource = {
        type: "FeatureCollection",
        features: pmCSEFeatArray,
      };
      let pmCSASource = {
        type: "FeatureCollection",
        features: pmCSAFeatArray,
      };

      this.addDataToLayer("primaryLines", primarySource);
      this.addDataToLayer("secondaryLines", secSource);
      this.addDataToLayer("tertiaryLines", trdSource);
      this.addDataToLayer("csePmLines", pmCSESource);
      this.addDataToLayer("csaPmLines", pmCSASource);
    },

    findTimeToTravel(flId, cseId, unitMeasure = " hours") {
      let time = "";

      if (this.selecteddivision == "ImagingZone") {
        if (this.zone_travel_time_map[cseId]) {
          let traveTimes = this.zone_travel_time_map[cseId];
          if (traveTimes[flId]) {
            time = traveTimes[flId] + unitMeasure;
          }
        }
      } else {
        if (this.travel_time_map[cseId]) {
          let traveTimes = this.travel_time_map[cseId];
          if (traveTimes[flId]) {
            time = traveTimes[flId] + unitMeasure;
          }
        }
      }

      return time;
    },

    findTimeToTravelByCSELabel(flId, assignType) {
      const fl_cse = this.fl_cse_conn_obj[flId];
      if (fl_cse) {
        let timeToTrav = this.findTimeToTravel(
          flId,
          fl_cse[assignType],
          " hrs"
        );
        return timeToTrav;
      }
      return "";
    },

    createFeature(
      source,
      dest,
      color,
      title,
      linewidth,
      modality,
      region,
      contractStatus,
      modalitiesTrained,
      cseRegion,
      cseStatus,
      flDesc
    ) {
      return {
        type: "Feature",
        properties: {
          color: color,
          title: title,
          linewidth: linewidth,
          Modality: modality,
          RegionID: region,
          FlContractStatus: contractStatus,
          Modalities_Trained: modalitiesTrained,
          cseRegionId: cseRegion,
          cseStatus: cseStatus,
          Desc: flDesc,
        },
        geometry: {
          type: "LineString",
          coordinates: [source, dest],
        },
      };
    },

    createConnectionObj(
      cseCoord,
      sourceCoord,
      color,
      rank,
      modality,
      region,
      contractStatus,
      linewidth = 1,
      modalitiesTrained = [],
      cseRegion = "",
      cseStatus = "",
      flDesc = ""
    ) {
      if (cseCoord)
        return this.createFeature(
          sourceCoord,
          cseCoord,
          color,
          rank,
          linewidth,
          modality,
          region,
          contractStatus,
          modalitiesTrained,
          cseRegion,
          cseStatus,
          flDesc
        );
      else return null;
    },

    findCSEcoord(id, dataArr) {
      const pr_cse_index = this.findCSEIndexById(id, dataArr);

      if (pr_cse_index === -1) return null;
      else
        return [
          dataArr[pr_cse_index].RenderLongitude,
          dataArr[pr_cse_index].RenderLatitude,
        ];
    },

    findCSEIndexById(id, dataArr) {
      return dataArr.findIndex((object) => {
        return object.Id === id;
      });
    },

    findFLCoord(flId) {
      let index = this.fl_static.findIndex((obj) => {
        return obj.Id === flId;
      });
      if (index === -1) return null;
      else {
        return [
          this.fl_static[index].RenderLongitude,
          this.fl_static[index].RenderLatitude,
        ];
      }
    },

    convert2geojson(
      sourceName,
      sourceData,
      latLabel = "Latitude",
      longLabel = "Longitude"
    ) {
      let self = this;
      csv2geojson.csv2geojson(
        JSON.parse(JSON.stringify(sourceData)),
        {
          latfield: latLabel,
          lonfield: longLabel,
          delimiter: ",",
        },
        function (err, data) {
          // console.log(data);
          self.addDataToLayer(sourceName, data);
        }
      );
    },

    addDataToLayer(sourceName, sourceData) {
      const loop = () => {
        if (this.map && this.map.loaded()) {
          this.resetLayerVisibility(sourceName);
          this.map.getSource(sourceName).setData(sourceData);
        } else {
          requestAnimationFrame(loop);
        }
      };
      loop();
    },

    resetLayerVisibility(sourceName) {
      const index = this.activeLayers.findIndex((object) => {
        return object.layerName === this.source2Layer[sourceName];
      });
      if (this.activeLayers[index].active)
        this.map.setLayoutProperty(
          this.activeLayers[index].layerName,
          "visibility",
          "visible"
        );
      else
        this.map.setLayoutProperty(
          this.activeLayers[index].layerName,
          "visibility",
          "none"
        );
    },

    setLayerVisibility(val, index) {
      // console.log(val + " was " + this.activeLayers[index].active);
      this.clearTemporaryFLandCSElayers();
      let currentState = this.activeLayers[index].active;
      this.activeLayers[index].active = !currentState; //todo check reactivity

      //this is needed if we want this change to be caught by the warcher
      // this.activeLayers = this.activeLayers.slice();

      if (this.activeLayers[index].active) {
        if (this.map) {
          this.map.setLayoutProperty(
            this.activeLayers[index].layerName,
            "visibility",
            "visible"
          );
        }
      } else {
        if (this.map) {
          this.map.setLayoutProperty(
            this.activeLayers[index].layerName,
            "visibility",
            "none"
          );
        }
      }

      // console.log(val + " is " + this.activeLayers[index].active);
    },

    filterByModality($event, i) {
      // console.log(i);
      //this.modalities[i].active = !$event.target.active;
      this.setModalityActiveState({ index: i, val: $event.target.active });
    },

    toggleFilterCSEbySelectedModalities($event) {
      //console.log($event.target.active);
      this.setFilterCSEbySelectedModalities($event.target.active);
    },

    toggleFilterCSEbySelectedPlantSections($event) {
      this.setFilterCSEbySelectedPlantSections($event.target.active);
    },

    filterSelectedRegion($event, i) {
      // console.log($event.target.active, i);
      this.changeRegionActiveState({ index: i, active: $event.target.active });
    },

    filterByContractStatus($event, i) {
      this.setContractStatusActiveState({
        index: i,
        val: $event.target.active,
      });
    },

    filterCSEbyStatus($event, i) {
      this.setCSEstatusActiveState({
        index: i,
        val: $event.target.active,
      });
    },

    filterSelectedCSEVisibleConnections($event, i) {
      this.selectedCSEdisplayedConnections[i].active = $event.target.active;
    },

    filterKPIs($event, i) {
      this.kpiList[i].active = $event.target.active;
    },

    isKPIvisible(kpiName) {
      let indexInKPIs = this.kpiList.findIndex((obj) => {
        return obj.kpiName === kpiName;
      });
      if (indexInKPIs !== -1) {
        return this.kpiList[indexInKPIs].active;
      } else return false;
    },

    getAssignedCSEorCSAname(label, flId) {
      let cseName = "";

      const fl_cse = this.fl_cse_conn_obj[flId];

      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });

        if (indexInCSE !== -1) {
          cseName = this.cse_static[indexInCSE].Name;
        } else {
          const indexInCSA = this.csa_static.findIndex((obj) => {
            return obj.Id == fl_cse[label];
          });
          if (indexInCSA !== -1) {
            cseName = this.csa_static[indexInCSA].Name;
          }
        }
      }

      return cseName;
    },

    getAssignedCSEorCSAnameAndRole(label, flId) {
      let res = { pmName: "", pmRole: "" };

      const fl_cse = this.fl_cse_conn_obj[flId];

      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });

        if (indexInCSE !== -1) {
          res.pmName = this.cse_static[indexInCSE].Name.replaceAll(",", " ");
          res.pmRole = this.cse_static[indexInCSE].Role;
        } else {
          const indexInCSA = this.csa_static.findIndex((obj) => {
            return obj.Id == fl_cse[label];
          });
          if (indexInCSA !== -1) {
            res.pmName = this.csa_static[indexInCSA].Name.replaceAll(",", " ");
            res.pmRole = this.csa_static[indexInCSA].Role;
          } else {
            res.pmName = "External Contractor";
            res.pmRole = "EXT";
          }
        }
      }
      return res;
    },

    getAssignedCSnameForSelFL(label) {
      let cseName = "";

      const fl_cse = this.fl_cse_conn_obj[this.selectedFlId];

      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });

        if (indexInCSE !== -1) {
          cseName = this.cse_static[indexInCSE].Name;
        }
      }

      return cseName;
    },

    getAssignedCSEidForSelFL(label) {
      let cseId = "";
      const fl_cse = this.fl_cse_conn_obj[this.selectedFlId];
      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });
        if (indexInCSE !== -1) {
          cseId = this.cse_static[indexInCSE].Id;
        }
      }
      return cseId;
    },

    getAssignedCSEorCSAidForSelFL(label) {
      let engId = "";
      const fl_cse = this.fl_cse_conn_obj[this.selectedFlId];
      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });
        if (indexInCSE !== -1) {
          engId = this.cse_static[indexInCSE].Id;
        } else {
          const indexInCSA = this.csa_static.findIndex((obj) => {
            return obj.Id == fl_cse[label];
          });
          if (indexInCSA !== -1) {
            engId = this.csa_static[indexInCSA].Id;
          }
        }
      }
      return engId;
    },

    isCSEprimaryListItemDisabled(item) {
      return (
        item.Id == this.getAssignedCSEidForSelFL("PrimaryCSEID") ||
        item.Id == this.flModalContent.selectedSecondary.Id ||
        item.Id == this.flModalContent.selectedTertiary.Id
      );
    },

    isCSEprimaryListItemActive(item) {
      return item.Id == this.flModalContent.selectedPrimary.Id;
    },

    isCSEsecondaryListItemDisabled(item) {
      return (
        item.Id == this.getAssignedCSEidForSelFL("SecondaryCSEID") ||
        item.Id == this.flModalContent.selectedTertiary.Id ||
        item.Id == this.flModalContent.selectedPrimary.Id
      );
    },

    isCSEsecondaryListItemActive(item) {
      return item.Id == this.flModalContent.selectedSecondary.Id;
    },

    isCSEtertiaryListItemDisabled(item) {
      return (
        item.Id == this.getAssignedCSEidForSelFL("TertiaryCSEID") ||
        item.Id == this.flModalContent.selectedPrimary.Id ||
        item.Id == this.flModalContent.selectedSecondary.Id
      );
    },

    isCSEtertiaryListItemActive(item) {
      return item.Id == this.flModalContent.selectedTertiary.Id;
    },

    isPmListItemDisabled(item) {
      return item.Id == this.getAssignedCSEorCSAidForSelFL("PMCSEID");
    },

    isPmListItemActive(item) {
      return item.Id == this.flModalContent.selectedPM.Id;
    },

    isSubmitButtonVisible() {
      return (
        this.flModalContent.selectedPrimary.Id ||
        this.flModalContent.selectedSecondary.Id ||
        this.flModalContent.selectedTertiary.Id ||
        this.flModalContent.selectedPM.Id
      );
    },

    getRegionCSEs() {
      let regionCSEs = this.cse_static.filter((cse) => cse.RegionID !== "NA");
      return regionCSEs;
    },

    async submitNewAssignments() {
      this.setSubmitUserActionInProgress(true);
      this.hideFLModal();
      let user = this.oidcUser ? this.oidcUser.email : "";
      let payload = {
        username: user,
        new_assignments: [],
      };
      if (this.flModalContent.selectedPrimary.Id) {
        payload.new_assignments.push({
          AssignmentType: "primary",
          FLID: this.selectedFlId,
          CSEID: this.flModalContent.selectedPrimary.Id,
        });
      }
      if (this.flModalContent.selectedSecondary.Id) {
        payload.new_assignments.push({
          AssignmentType: "secondary",
          FLID: this.selectedFlId,
          CSEID: this.flModalContent.selectedSecondary.Id,
        });
      }
      if (this.flModalContent.selectedTertiary.Id) {
        payload.new_assignments.push({
          AssignmentType: "tertiary",
          FLID: this.selectedFlId,
          CSEID: this.flModalContent.selectedTertiary.Id,
        });
      }
      if (this.flModalContent.selectedPM.Id) {
        payload.new_assignments.push({
          AssignmentType: "pm",
          FLID: this.selectedFlId,
          CSEID: this.flModalContent.selectedPM.Id,
        });
      }
      // console.log(payload);
      let reqStr = this.backendURL;
      if (this.selecteddivision == "ImagingZone") {
        reqStr +=
          "/api/service_zone_current_data/edit_assignment/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          this.area;
      } else {
        reqStr +=
          "/api/service_current_data/edit_assignment/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          this.area;
      }
      try {
        const res = await axios.post(reqStr, payload);
        // console.log(res.data);
        this.updateRecommendations(res.data);
        this.setSubmitUserActionInProgress(false);

        //update actions hist list
      } catch (err) {
        console.log(err);
        this.setSubmitUserActionInProgress(false);

        let notification = {
          type: "error",
          label: "Cannot submit new assignments!",
          // duration: "short",
          text: "Error wile submitting new assignments!",
        };
        this.pushNotification(notification);
      }
      this.closeFLModal();
      this.changePaneTab(this.paneTabs[0]); //go to actions tab
    },

    closeFLModal() {
      this.flModalContent = { ...this.FlModalEmpty }; //todo check deep copy object
      this.flModalTabs = [
        { id: 1, name: "Overview", current: true },
        { id: 2, name: "Contract", current: false },
      ];
      this.hideFLModal();
    },

    hideFLModal() {
      document.querySelector("#fl-modal").visible = false;
    },

    closeCSEModal() {
      this.cseModalContent = { ...this.cseModalEmpty };
      this.cseModalTabs = [
        { id: 1, name: "Overview", current: true },
        { id: 2, name: "Shift", current: false },
      ];
      this.cseBackToWorkDate = null;
      this.cseRetirementDate = null;
    },

    closeCSAModal() {
      this.csaModalContent = this.csaModalEmpty;
      this.csaModalTabs = [
        { id: 3, name: "Overview", current: true },
        { id: 4, name: "Shift", current: false },
      ];
      this.csaBackToWorkDate = null;
      this.csaRetirementDate = null;
    },

    async getCSERetirementReturnDates(cseId, isCSE) {
      this.loadingCseReturnRetirementDate = true;
      try {
        const res = await axios.get(
          this.backendURL +
            "/api/cse_preference/" +
            this.selectedCountry.iso_3166_1 +
            "/" +
            cseId
        );
        if (isCSE) {
          this.cseBackToWorkDate = res.data.back_to_work_date;
          this.cseRetirementDate = res.data.retirement_date;
        } else {
          this.csaBackToWorkDate = res.data.back_to_work_date;
          this.csaRetirementDate = res.data.retirement_date;
        }

        this.loadingCseReturnRetirementDate = false;
      } catch (err) {
        this.loadingCseReturnRetirementDate = false;
        console.log(err);
        let notification = {
          type: "error",
          label: "Retirement date error",
          // duration: "short",
          text: "Error wile loading Retirement date!",
        };
        this.pushNotification(notification);
      }
    },

    // getCSETeturnToWorkDate(cseID){},

    cseReturnWorkDateChanged($event) {
      if (this.selectedCSEId) {
        let dateStr = $event.target.value;
        console.log("return date changed, ", dateStr);

        if (typeof dateStr == "string") {
          //send to backend either empty string = null or actual value
          console.log("event is string: ", dateStr);
          if (this.cseBackToWorkDate !== dateStr) {
            let payload = {
              username: this.oidcUser ? this.oidcUser.email : "",
              back_to_work_date: dateStr ? dateStr : null,
            };
            this.sendCsePreference(payload, this.selectedCSEId);
            this.cseBackToWorkDate = dateStr;
          }
        } else if (typeof dateStr == "undefined") {
          console.log("event is undefined: ", dateStr);
          //this comes when the value is set for the first time ?!?
          this.cseBackToWorkDate = dateStr;
        } else if (dateStr === null) {
          //do nothing, this comes from backend or when the modal is closed
          console.log("event is null: ", dateStr);
          this.cseBackToWorkDate = dateStr;
        }
      }
    },

    cseRetirementDateChanged($event) {
      if (this.selectedCSEId) {
        let dateStr = $event.target.value;
        console.log("retire date changed, ", dateStr);
        if (typeof dateStr == "string") {
          console.log("event is string: ", dateStr);
          if (this.cseRetirementDate !== dateStr) {
            let payload = {
              username: this.oidcUser ? this.oidcUser.email : "",
              retirement_date: dateStr ? dateStr : null,
            };
            this.sendCsePreference(payload, this.selectedCSEId);
            this.cseRetirementDate = dateStr;
          }
        } else if (typeof dateStr == "undefined") {
          console.log("event is undefined: ", dateStr);
          this.cseRetirementDate = dateStr;
        } else if (dateStr === null) {
          console.log("event is null: ", dateStr);
          this.cseRetirementDate = dateStr;
        }
      }
    },

    csaReturnWorkDateChanged($event) {
      if (this.selectedCSAId) {
        let dateStr = $event.target.value;
        console.log("csa return date changed, ", dateStr);

        if (typeof dateStr == "string") {
          //send to backend either empty string = null or actual value
          console.log("event is string: ", dateStr);
          if (this.csaBackToWorkDate !== dateStr) {
            let payload = {
              username: this.oidcUser ? this.oidcUser.email : "",
              back_to_work_date: dateStr ? dateStr : null,
            };
            this.sendCsePreference(payload, this.selectedCSAId);
            this.csaBackToWorkDate = dateStr;
          }
        } else if (typeof dateStr == "undefined") {
          console.log("event is undefined: ", dateStr);
          //this comes when the value is set for the first time ?!?
          this.csaBackToWorkDate = dateStr;
        } else if (dateStr === null) {
          //do nothing, this comes from backend or when the modal is closed
          console.log("event is null: ", dateStr);
          this.csaBackToWorkDate = dateStr;
        }
      }
    },

    csaRetirementDateChanged($event) {
      if (this.selectedCSAId) {
        let dateStr = $event.target.value;
        console.log("retire date changed, ", dateStr);
        if (typeof dateStr == "string") {
          console.log("event is string: ", dateStr);
          if (this.csaRetirementDate !== dateStr) {
            let payload = {
              username: this.oidcUser ? this.oidcUser.email : "",
              retirement_date: dateStr ? dateStr : null,
            };
            this.sendCsePreference(payload, this.selectedCSAId);
            this.csaRetirementDate = dateStr;
          }
        } else if (typeof dateStr == "undefined") {
          console.log("event is undefined: ", dateStr);
          this.csaRetirementDate = dateStr;
        } else if (dateStr === null) {
          console.log("event is null: ", dateStr);
          this.csaRetirementDate = dateStr;
        }
      }
    },

    sendCsePreference(payload, id) {
      axios
        .post(
          this.backendURL +
            "/api/cse_preference/" +
            this.selectedCountry.iso_3166_1 +
            "/" +
            id,
          payload
        )
        .then((res) => {
          console.log("cse_preference sent to backend ", res.data);
        })
        .catch((err) => {
          console.log(err);
          let notification = {
            type: "warning",
            label: "Back to Work Error",
            duration: "short",
            text: "cse preference date was not submitted!",
          };
          this.pushNotification(notification);
        });
    },

    cleanup() {
      this.resource_utilization_chart_data_linechart = {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      };
      this.wall_clock_chart_data_linechart = {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      };
      this.gated_wall_clock_chart_data_linechart = {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      };
      this.travel_time_chart_data_linechart = {
        forcastednoaction: [],
        historical: [],
        forecastData: [],
      };

      this.clearLayer("singleCSETrainedConnections");
      this.clearLayer("singleCSEUntrainedConnections");
      this.clearLayer("singleFLTrainedConnections");
      this.clearLayer("singleFLUntrainedConnections");

      this.clearLayer("flStatic");
      this.clearLayer("cseStatic");
      this.clearLayer("csaStatic");

      this.clearLayer("cseAffected");
      this.clearLayer("flAffected");

      this.clearLayer("primaryLines");
      this.clearLayer("secondaryLines");
      this.clearLayer("tertiaryLines");
      this.clearLayer("csePmLines");
      this.clearLayer("csaPmLines");
    },

    // filterLayerByName(
    //   activeModalities,
    //   activeRegions,
    //   activeStatus,
    //   layerName
    // ) {
    //   if (this.map.style.getLayer(layerName)) {
    //     if (activeStatus.length === 0) {
    //       //no item checked

    //       this.map.setFilter(layerName, [
    //         "in",
    //         ["get", "BillingStatus"],
    //         ["literal", []],
    //         // "all",
    //         // ["==", ["string", ["get", "time"]], timestamp],
    //         // ["!", ["in", '-', ["string", ["get", "CSEID"]]]]]);
    //       ]);
    //     } else if (activeStatus.length === 2) {
    //       // this.map.setFilter("FLlayerBackend", null);
    //       this.map.setFilter(layerName, [
    //         "all",
    //         ["in", ["get", "Modality"], ["literal", activeModalities]],
    //         ["in", ["get", "RegionID"], ["literal", activeRegions]],
    //       ]);
    //     } else if (activeStatus.length === 1) {
    //       if (activeStatus[0].status === "Contract") {
    //         this.map.setFilter(layerName, [
    //           "all",
    //           ["in", ["get", "Modality"], ["literal", activeModalities]],
    //           ["in", ["get", "RegionID"], ["literal", activeRegions]],
    //           ["in", ["get", "BillingStatus"], ["literal", ["CONTRACT"]]],
    //         ]);
    //       } else {
    //         this.map.setFilter(layerName, [
    //           "all",
    //           ["in", ["get", "Modality"], ["literal", activeModalities]],
    //           ["in", ["get", "RegionID"], ["literal", activeRegions]],
    //           [
    //             "!",
    //             ["in", ["get", "BillingStatus"], ["literal", ["CONTRACT"]]],
    //           ],
    //         ]);
    //       }
    //     }
    //   }
    // },
    // filterLayerByName(
    //   activeModalities,
    //   activeRegions,
    //   activeStatus,
    //   layerName
    // ) {
    //   if (this.map.style.getLayer(layerName)) {
    //     this.map.setFilter(layerName, [
    //       "all",
    //       ["in", ["get", "Modality"], ["literal", activeModalities]],
    //       ["in", ["get", "RegionID"], ["literal", activeRegions]],
    //       ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
    //     ]);
    //   }
    // },

    filterLayerByFlFilters(
      activeModalities,
      activeRegions,
      activeStatus,
      layerName
    ) {
      if (this.map.style.getLayer(layerName)) {
        const filter = [
          "all",
          ["in", ["get", "Modality"], ["literal", activeModalities]],
          ["in", ["get", "RegionID"], ["literal", activeRegions]],
          ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
        ];
        // if no Des is selected, we want to visualize all the FLs
        if (this.selectedFlDesc) {
          filter.push(["==", ["get", "Desc"], this.selectedFlDesc]);
        }
        this.map.setFilter(layerName, filter);
      }
    },

    filterConnectionLayerByFlAndCSEfilters(
      activeModalities,
      activeRegions,
      activeStatus,
      layerName
    ) {
      if (this.map.style.getLayer(layerName)) {
        let filters = [
          "all",
          ["in", ["get", "Modality"], ["literal", activeModalities]],
          ["in", ["get", "RegionID"], ["literal", activeRegions]],
          ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
          [
            "in",
            ["get", "cseStatus"],
            ["literal", this.getCSEactiveStatusNames],
          ],
        ];
        if (this.filterCSEbySelectedModalities) {
          filters.push(this.getTagsFilter(activeModalities));
        }
        if (this.filterCSEbySelectedPlantSections) {
          filters.push([
            "in",
            ["get", "cseRegionId"],
            ["literal", activeRegions],
          ]);
        }
        if (this.selectedFlDesc) {
          filters.push(["==", ["get", "Desc"], this.selectedFlDesc]);
        }

        // if (this.filterCSEbySelectedModalities) {
        //   if (this.filterCSEbySelectedPlantSections) {
        //     this.map.setFilter(layerName, [
        //       "all",
        //       ["in", ["get", "Modality"], ["literal", activeModalities]],
        //       ["in", ["get", "RegionID"], ["literal", activeRegions]],
        //       ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
        //       this.getTagsFilter(activeModalities),
        //       [
        //         "in",
        //         ["get", "cseStatus"],
        //         ["literal", this.getCSEactiveStatusNames],
        //       ],
        //       ["in", ["get", "cseRegionId"], ["literal", activeRegions]],
        //     ]);
        //   } else {
        //     this.map.setFilter(layerName, [
        //       "all",
        //       ["in", ["get", "Modality"], ["literal", activeModalities]],
        //       ["in", ["get", "RegionID"], ["literal", activeRegions]],
        //       ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
        //       this.getTagsFilter(activeModalities),
        //       [
        //         "in",
        //         ["get", "cseStatus"],
        //         ["literal", this.getCSEactiveStatusNames],
        //       ],
        //     ]);
        //   }
        // } else {
        //   if (this.filterCSEbySelectedPlantSections) {
        //     this.map.setFilter(layerName, [
        //       "all",
        //       ["in", ["get", "Modality"], ["literal", activeModalities]],
        //       ["in", ["get", "RegionID"], ["literal", activeRegions]],
        //       ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
        //       [
        //         "in",
        //         ["get", "cseStatus"],
        //         ["literal", this.getCSEactiveStatusNames],
        //       ],
        //       ["in", ["get", "cseRegionId"], ["literal", activeRegions]],
        //     ]);
        //   } else {
        //     this.map.setFilter(layerName, [
        //       "all",
        //       ["in", ["get", "Modality"], ["literal", activeModalities]],
        //       ["in", ["get", "RegionID"], ["literal", activeRegions]],
        //       ["in", ["get", "FlContractStatus"], ["literal", activeStatus]],
        //       [
        //         "in",
        //         ["get", "cseStatus"],
        //         ["literal", this.getCSEactiveStatusNames],
        //       ],
        //     ]);
        //   }
        // }
        this.map.setFilter(layerName, filters);
      }
    },

    filterFLs() {
      if (this.map) {
        this.filterLayerByFlFilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "FLlayerBackend"
        );
      }
    },

    filterConnectionsLayers() {
      if (this.map) {
        this.filterConnectionLayerByFlAndCSEfilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "CSEtoFLprimaryLines"
        );
        this.filterConnectionLayerByFlAndCSEfilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "CSEtoFLsecondaryLines"
        );
        this.filterConnectionLayerByFlAndCSEfilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "CSEtoFLtertiaryLines"
        );
        this.filterConnectionLayerByFlAndCSEfilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "PMCSEtoFLLines"
        );
        this.filterLayerByFlFilters(
          this.getActiveModalitiesNames,
          this.getActiveRegionsNames,
          this.getActiveStatusNames,
          "PMCSAtoFLLines"
        );
      }
    },

    getTagsFilter(tags) {
      //no tags set
      if ((tags || []).length === 0) return ["any", false];

      //expression for each tag
      const tagFilters = tags.map((tag) => [
        "in",
        tag,
        ["get", "Modalities_Trained"],
      ]);

      return ["any"].concat(tagFilters);
    },

    // filterCSEsByModalities() {
    //   //todo combine filters add this getTagsFilter at the end of the other filters
    //   if (this.filterCSEbySelectedModalities) {
    //     let activeModalities = this.getActiveModalitiesNames;
    //     // console.log(activeModalities);
    //     if (this.map.style.getLayer("CSElayerBackend")) {
    //       // console.log(this.getTagsFilter(activeModalities));
    //       this.map.setFilter(
    //         "CSElayerBackend",
    //         this.getTagsFilter(activeModalities)
    //       );
    //     }
    //   } else {
    //     //reset filter on layer - display all cses
    //     if (this.map.style.getLayer("CSElayerBackend")) {
    //       this.map.setFilter("CSElayerBackend", null);
    //     }
    //   }
    // },

    filterCSEs() {
      //status ACTIVE SUSPENDED
      if (this.map) {
        if (this.map.style.getLayer("CSElayerBackend")) {
          if (this.filterCSEbySelectedModalities) {
            if (this.filterCSEbySelectedPlantSections) {
              this.map.setFilter("CSElayerBackend", [
                "all",
                [
                  "in",
                  ["get", "Status"],
                  ["literal", this.getCSEactiveStatusNames],
                ],
                [
                  "in",
                  ["get", "RegionID"],
                  ["literal", this.getActiveRegionsNames],
                ],
                this.getTagsFilter(this.getActiveModalitiesNames),
              ]);
            } else {
              this.map.setFilter("CSElayerBackend", [
                "all",
                [
                  "in",
                  ["get", "Status"],
                  ["literal", this.getCSEactiveStatusNames],
                ],
                this.getTagsFilter(this.getActiveModalitiesNames),
              ]);
            }
          } else {
            if (this.filterCSEbySelectedPlantSections) {
              this.map.setFilter("CSElayerBackend", [
                "all",
                [
                  "in",
                  ["get", "Status"],
                  ["literal", this.getCSEactiveStatusNames],
                ],
                [
                  "in",
                  ["get", "RegionID"],
                  ["literal", this.getActiveRegionsNames],
                ],
              ]);
            } else {
              //reset filter on layer - display all cses
              this.map.setFilter("CSElayerBackend", [
                "in",
                ["get", "Status"],
                ["literal", this.getCSEactiveStatusNames],
              ]);
            }
          }
        }
      }
    },

    filterCSETempLayer() {
      if (this.selectedCSEId) {
        let cseCoord = this.findCSEcoord(this.selectedCSEId, this.cse_static);
        this.addTempConnectionsOfSelCSE(this.selectedCSEId, cseCoord);
      }
    },

    filterCSATempLAyer() {
      if (this.selectedCSAId) {
        let csaCoord = this.findCSEcoord(this.selectedCSAId, this.csa_static);
        this.addTempConnectionsOfSelCSA(this.selectedCSAId, csaCoord);
      }
    },

    filterFlTempLayer() {
      if (this.selectedFlId) this.addTempConnectionsOfSelFL(this.selectedFlId);
    },
    searchItemByNameDrop($event) {
      // console.log(e);
      if ($event.target.label) {
        let index = this.flsCsesNames.findIndex((obj) => {
          return obj.name === $event.target.label;
        });

        if (index !== -1) {
          // console.log(allElemaArr[index]);
          this.map.flyTo({
            center: [
              this.flsCsesNames[index].RenderLongitude,
              this.flsCsesNames[index].RenderLatitude,
            ],
            zoom: 17,
          });
        }
      }
    },

    getIconId(iconName, index) {
      return iconName + index;
    },

    getIconIdCSEmenu(iconName, mapIdx, itemIdx) {
      return iconName + mapIdx + "-" + itemIdx;
    },

    getIconLabel(iconName, index) {
      // console.log(iconName, index);
      let timeDiff = this.computeDaysDiff(index);
      return (
        "Recommendation was sent to DMG " +
        timeDiff +
        " days ago. Kindly follow up with the DMG team"
      );
    },

    getIconLabelCSEmenu(mapIdx, itemIdx) {
      let timeDiff = this.computeDaysDiffCSEmenu(mapIdx, itemIdx);
      return (
        "Recommendation was sent to DMG " +
        timeDiff +
        " days ago. Kindly follow up with the DMG team"
      );
    },

    computeDaysDiff(index) {
      let filteredRec = this.filteredRecommend;
      let dateExported = new Date(filteredRec[index].time);
      let currentDate = new Date();

      let diffInTime = currentDate.getTime() - dateExported.getTime();
      let diffInDays = diffInTime / (1000 * 3600 * 24);

      // console.log(dateExported, currentDate, diffInDays);
      return Math.floor(diffInDays);
    },

    computeDaysDiffCSEmenu(mapIdx, itemIdx) {
      let filtrRec = new Map();
      switch (this.activePaneTabName) {
        case "Recommendations": {
          filtrRec = this.filteredRecommendGroupedByCSE_recommended;
          break;
        }
        case "History": {
          return 0;
        }
        case "RBD Compliance": {
          filtrRec = this.filteredRecommendGroupedByCSE_rbd;
          break;
        }
        case "Installation FLs": {
          filtrRec = this.filteredRecommendGroupedByCSE_installation;
          break;
        }
        default: {
          return 0;
        }
      }

      let key = Array.from(filtrRec.keys())[mapIdx];

      let dateExported = new Date(filtrRec.get(key)[itemIdx].time);
      let currentDate = new Date();

      let diffInTime = currentDate.getTime() - dateExported.getTime();
      let diffInDays = diffInTime / (1000 * 3600 * 24);

      return Math.floor(diffInDays);
    },

    showWarningIcon(index) {
      let filteredRec = this.filteredRecommend;
      if (filteredRec[index].status === "Exported") {
        let timeDiffInDays = this.computeDaysDiff(index);
        if (timeDiffInDays > 5) {
          return true;
        } else return false;
      } else return false;
    },
    showWarningIconCSEmenu(mapIdx, itemIdx) {
      switch (this.activePaneTabName) {
        case "Recommendations": {
          let filtrRec = this.filteredRecommendGroupedByCSE_recommended;
          let key = Array.from(filtrRec.keys())[mapIdx];
          if (filtrRec.get(key)[itemIdx].status === "Exported") {
            let timeDiffInDays = this.computeDaysDiffCSEmenu(mapIdx, itemIdx);
            if (timeDiffInDays > 5) {
              return true;
            } else return false;
          } else return false;
        }
        case "History": {
          return false;
        }
        case "RBD Compliance": {
          let filtrRec = this.filteredRecommendGroupedByCSE_rbd;
          let key = Array.from(filtrRec.keys())[mapIdx];
          if (filtrRec.get(key)[itemIdx].status === "Exported") {
            let timeDiffInDays = this.computeDaysDiffCSEmenu(mapIdx, itemIdx);
            if (timeDiffInDays > 5) {
              return true;
            } else return false;
          } else return false;
        }
        case "Installation FLs": {
          let filtrRec = this.filteredRecommendGroupedByCSE_installation;
          let key = Array.from(filtrRec.keys())[mapIdx];
          if (filtrRec.get(key)[itemIdx].status === "Exported") {
            let timeDiffInDays = this.computeDaysDiffCSEmenu(mapIdx, itemIdx);
            if (timeDiffInDays > 5) {
              return true;
            } else return false;
          } else return false;
        }
        default: {
          return false;
        }
      }
    },

    totalItemsInCategory(categoryName) {
      // Assuming you have a data property `items` which is an array of all items
      // and each item has a `category` property
      // console.log(categoryName);

      switch (categoryName) {
        case "Recommendations": {
          let totalItems = 0;
          for (let array of this.filteredRecommendGroupedByCSE_recommended.values()) {
            totalItems += array.length;
          }
          return " (" + totalItems + ")";
        }
        case "History":
          return "";
        case "RBD Compliance": {
          let totalItems = 0;
          for (let array of this.filteredRecommendGroupedByCSE_rbd.values()) {
            totalItems += array.length;
          }
          return " (" + totalItems + ")";
        }
        case "Installation FLs": {
          let totalItems = 0;
          for (let array of this.filteredRecommendGroupedByCSE_installation.values()) {
            totalItems += array.length;
          }
          return " (" + totalItems + ")";
        }
        default:
          return "";
      }

      // this.items.filter(item => item.category === categoryName).length
    },

    totalItemsInTrainingCategory(categoryName) {
      switch (categoryName) {
        case "Recommendations": {
          let totalItems = 0;
          for (let array of this.filteredTrainingRecommendGroupedByCSE.values()) {
            totalItems += array.length;
          }
          return " (" + totalItems + ")";
        }
        case "History":
          return "";
        default:
          return "";
      }
    },

    callClickCSENameWorkforce(params) {
      this.clickCSENameWorkforce(params);

      this.map.setLayoutProperty("CSEtoFLprimaryLines", "visibility", "none");
      this.map.setLayoutProperty("CSEtoFLsecondaryLines", "visibility", "none");
      this.map.setLayoutProperty("CSEtoFLtertiaryLines", "visibility", "none");
      this.map.setLayoutProperty("PMCSEtoFLLines", "visibility", "none");
      this.map.setLayoutProperty("PMCSAtoFLLines", "visibility", "none");
      this.clearLayer("singleFLTrainedConnections");
      this.clearLayer("singleFLUntrainedConnections");
      this.clearLayer("singleCSETrainedConnections");
      this.clearLayer("singleCSEUntrainedConnections");

      let cseCoord = this.findCSEcoord(params.elem.Id, this.cse_static);

      if (this.selectedCSEidWorkforceList) {
        this.selectedCSEId = params.elem.Id;
        this.selectedFlId = "";
        this.selectedCSAId = "";
        this.addTempConnectionsOfSelCSE(params.elem.Id, cseCoord);
      } else {
        this.clearLayer("singleCSETrainedConnections");
        this.clearLayer("singleCSEUntrainedConnections");
      }
    },
  },

  watch: {
    selectedRecommandationIndex: function (val) {
      if (val === undefined) {
        //clear recommendations layers
        this.clearLayer("cseAffected");
        this.clearLayer("flAffected");

        this.resource_utilization_chart_data_linechart = {
          ...this.resource_utilization_chart_data_linechart,
          forecastData: [],
        };
        this.wall_clock_chart_data_linechart = {
          ...this.wall_clock_chart_data_linechart,
          forecastData: [],
        };
        this.gated_wall_clock_chart_data_linechart = {
          ...this.gated_wall_clock_chart_data_linechart,
          forecastData: [],
        };
        this.travel_time_chart_data_linechart = {
          ...this.travel_time_chart_data_linechart,
          forecastData: [],
        };

        this.clearTemporaryFLandCSElayers();

        this.map.flyTo({
          center: [this.Longitude, this.Latitude],
          zoom: this.zoomLevel,
        });
      } else {
        let recommend_resource_utilization = [];
        if (this.filteredRecommend[val].Forecast_ResUtil_Histogram) {
          recommend_resource_utilization = this.formatDataForChart(
            this.filteredRecommend[val].Forecast_ResUtil_Histogram,
            "ResourceUtilization",
            "ResourceUtilization_min",
            "ResourceUtilization_max"
          );
        }

        let recommend_wall_clock = [];
        if (this.filteredRecommend[val].Forecast_Wallclock_Histogram) {
          recommend_wall_clock = this.formatDataForChart(
            this.filteredRecommend[val].Forecast_Wallclock_Histogram,
            "Wallclock",
            "Wallclock_min",
            "Wallclock_max"
          );
        }

        let recommend_gated_wall_clock = [];
        if (this.filteredRecommend[val].Forecast_GatedWallclock_Histogram) {
          recommend_gated_wall_clock = this.formatDataForChart(
            this.filteredRecommend[val].Forecast_GatedWallclock_Histogram,
            "Wallclock",
            "Wallclock_min",
            "Wallclock_max"
          );
        }

        let recommend_travel_time = [];
        if (this.filteredRecommend[val].Forecast_Travel_Histogram) {
          recommend_travel_time = this.formatDataForChart(
            this.filteredRecommend[val].Forecast_Travel_Histogram,
            "TravelTime",
            "TravelTime_min",
            "TravelTime_max"
          );
        }

        this.resource_utilization_chart_data_linechart = {
          ...this.resource_utilization_chart_data_linechart,
          forecastData: recommend_resource_utilization,
        };

        this.wall_clock_chart_data_linechart = {
          ...this.wall_clock_chart_data_linechart,
          forecastData: recommend_wall_clock,
        };

        this.gated_wall_clock_chart_data_linechart = {
          ...this.gated_wall_clock_chart_data_linechart,
          forecastData: recommend_gated_wall_clock,
        };

        this.travel_time_chart_data_linechart = {
          ...this.travel_time_chart_data_linechart,
          forecastData: recommend_travel_time,
        };

        let csesInAssignments = this.filteredRecommend[
          val
        ].new_assignments.reduce((assignedCSEs, assign) => {
          // let index
          let indexInCses = this.cse_static.findIndex((cse) => {
            return cse.Id === assign.CSEID;
          });
          if (indexInCses !== -1) {
            let mergedCSEwithAssignment = {
              ...this.cse_static[indexInCses],
              AssignmentType: assign.AssignmentType,
            };
            assignedCSEs.push(mergedCSEwithAssignment);
          }
          return assignedCSEs;
        }, []);

        let csasInAssignment = this.filteredRecommend[
          val
        ].new_assignments.reduce((assignedCSAs, assign) => {
          let indexInCSAs = this.csa_static.findIndex((csa) => {
            return csa.Id === assign.CSEID;
          });
          if (indexInCSAs !== -1) {
            let mergedCSAwithAssignment = {
              ...this.csa_static[indexInCSAs],
              AssignmentType: assign.AssignmentType,
            };
            assignedCSAs.push(mergedCSAwithAssignment);
          }
          return assignedCSAs;
        }, []);

        let csasAndcses = [...csesInAssignments, ...csasInAssignment];

        this.convert2geojson(
          "cseAffected",
          csasAndcses,
          "RenderLatitude",
          "RenderLongitude"
        );

        let impactedFLs = this.fl_static.filter((obj) => {
          return this.filteredRecommend[val].new_assignments.some(
            (assignm) => assignm.FLID === obj.Id
          );
        });
        this.convert2geojson(
          "flAffected",
          impactedFLs,
          "RenderLatitude",
          "RenderLongitude"
        );

        //add impacted fls connections
        this.selectedFlId = this.filteredRecommend[val].new_assignments[0].FLID;
        this.selectedCSEId = "";
        this.selectedCSAId = "";
        this.addTempConnectionsOfSelFL(
          this.filteredRecommend[val].new_assignments[0].FLID
        );

        //center map on selected recommendation new_assignments
        let coordinates = [];
        if (impactedFLs.length) {
          impactedFLs.forEach((fl) => {
            const { RenderLatitude, RenderLongitude } = fl;
            if (
              RenderLatitude !== "NA" &&
              RenderLongitude !== "NA" &&
              !isNaN(RenderLatitude) &&
              !isNaN(RenderLongitude)
            ) {
              coordinates.push([
                parseFloat(RenderLongitude),
                parseFloat(RenderLatitude),
              ]);
            }
          });
        }
        if (csesInAssignments.length) {
          csesInAssignments.forEach((cse) => {
            const { RenderLatitude, RenderLongitude } = cse;
            if (
              RenderLatitude !== "NA" &&
              RenderLongitude !== "NA" &&
              !isNaN(RenderLatitude) &&
              !isNaN(RenderLongitude)
            ) {
              coordinates.push([
                parseFloat(RenderLongitude),
                parseFloat(RenderLatitude),
              ]);
            }
          });
        }
        if (coordinates.length) {
          let bounds = coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord);
          }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
          this.map.fitBounds(bounds, {
            padding: { top: 100, bottom: 100, left: 100, right: 400 },
          });
        }
      }
    },
    selectedActionHist: function (val) {
      // console.log("selectedActionHist changed: ", val);

      if (val.summary === "") {
        //clear recommendations layers
        this.clearLayer("cseAffected");
        this.clearLayer("flAffected");

        this.resource_utilization_chart_data_linechart = {
          ...this.resource_utilization_chart_data_linechart,
          forecastData: [],
        };
        this.wall_clock_chart_data_linechart = {
          ...this.wall_clock_chart_data_linechart,
          forecastData: [],
        };
        this.gated_wall_clock_chart_data_linechart = {
          ...this.gated_wall_clock_chart_data_linechart,
          forecastData: [],
        };
        this.travel_time_chart_data_linechart = {
          ...this.travel_time_chart_data_linechart,
          forecastData: [],
        };

        this.clearTemporaryFLandCSElayers();

        this.map.flyTo({
          center: [this.Longitude, this.Latitude],
          zoom: this.zoomLevel,
        });
      } else {
        let csesInAssignments = val.new_assignments.reduce(
          (assignedCSEs, assign) => {
            // let index
            let indexInCses = this.cse_static.findIndex((cse) => {
              return cse.Id === assign.CSEID;
            });
            if (indexInCses !== -1) {
              let mergedCSEwithAssignment = {
                ...this.cse_static[indexInCses],
                AssignmentType: assign.AssignmentType,
              };
              assignedCSEs.push(mergedCSEwithAssignment);
            } else {
              let indexInCSAs = this.csa_static.findIndex((csa) => {
                return csa.Id === assign.CSEID;
              });
              if (indexInCSAs !== -1) {
                let mergedCSAwithAssignment = {
                  ...this.csa_static[indexInCSAs],
                  AssignmentType: assign.AssignmentType,
                };
                assignedCSEs.push(mergedCSAwithAssignment);
              }
            }
            return assignedCSEs;
          },
          []
        );

        // console.log("filtered impactedCSEs", impactedCSEs);
        this.convert2geojson(
          "cseAffected",
          csesInAssignments,
          "RenderLatitude",
          "RenderLongitude"
        );

        let impactedFLs = this.fl_static.filter((obj) => {
          return val.new_assignments.some((assignm) => assignm.FLID === obj.Id);
        });

        // console.log("filtered impactedFLs", impactedFLs);
        this.convert2geojson(
          "flAffected",
          impactedFLs,
          "RenderLatitude",
          "RenderLongitude"
        );

        //add impacted fls connections
        this.selectedFlId = val.new_assignments[0].FLID;
        this.selectedCSEId = "";
        this.selectedCSAId = "";
        this.addTempConnectionsOfSelFL(val.new_assignments[0].FLID);

        //center map on selected recommendation new_assignments
        let coordinates = [];
        if (impactedFLs.length) {
          impactedFLs.forEach((fl) => {
            coordinates.push([fl.RenderLongitude, fl.RenderLatitude]);
          });
        }
        if (csesInAssignments.length) {
          csesInAssignments.forEach((cse) => {
            coordinates.push([cse.RenderLongitude, cse.RenderLatitude]);
          });
        }
        if (coordinates.length) {
          let bounds = coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord);
          }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
          this.map.fitBounds(bounds, {
            padding: { top: 100, bottom: 100, left: 100, right: 400 },
          });
        }
      }
    },

    selectedTrainingRecommandationIndex: function (val) {
      if (val === undefined) {
        this.clearLayer("cseAffected");
        this.clearTemporaryFLandCSElayers();
        this.map.flyTo({
          center: [this.Longitude, this.Latitude],
          zoom: this.zoomLevel,
        });
      } else {
        console.log("selectedTrainingRecommandationIndex changed: ", val);
        let impacted_cses = this.trainingReccomendations[
          val
        ].recommended_training[0].impacted_cses.reduce(
          (assignedCSEs, assign) => {
            // let index
            let indexInCses = this.cse_static.findIndex((cse) => {
              return cse.Id === assign.cse_id;
            });
            if (indexInCses !== -1) {
              let mergedCSEwithAssignment = {
                ...this.cse_static[indexInCses],
                AssignmentType: "",
              };
              assignedCSEs.push(mergedCSEwithAssignment);
            }
            return assignedCSEs;
          },
          []
        );
        this.convert2geojson(
          "cseAffected",
          impacted_cses,
          "RenderLatitude",
          "RenderLongitude"
        );

        let coordinates = [];
        if (impacted_cses.length) {
          impacted_cses.forEach((cse) => {
            const { RenderLatitude, RenderLongitude } = cse;
            if (
              RenderLatitude !== "NA" &&
              RenderLongitude !== "NA" &&
              !isNaN(RenderLatitude) &&
              !isNaN(RenderLongitude)
            ) {
              coordinates.push([
                parseFloat(RenderLongitude),
                parseFloat(RenderLatitude),
              ]);
            }
          });
        }
        if (coordinates.length) {
          let bounds = coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord);
          }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
          this.map.fitBounds(bounds, {
            padding: { top: 100, bottom: 100, left: 100, right: 400 },
          });
        }
      }
    },

    selectedCSEidRecList: function (val) {
      if (val === "") {
        this.map.flyTo({
          center: [this.Longitude, this.Latitude],
          zoom: this.zoomLevel,
        });
      } else {
        let cseCoord = this.findCSEcoord(val, this.cse_static);
        if (cseCoord) {
          this.map.flyTo({
            center: cseCoord,
            zoom: 17,
          });
        } else {
          let csaCoord = this.findCSEcoord(val, this.csa_static);
          if (csaCoord) {
            this.map.flyTo({
              center: csaCoord,
              zoom: 17,
            });
          }
        }
      }
    },

    selectedCSEidWorkforceList: function (val) {
      if (val == "") {
        this.map.flyTo({
          center: [this.Longitude, this.Latitude],
          zoom: this.zoomLevel,
        });
      } else {
        let cseCoord = this.findCSEcoord(val, this.cse_static);
        if (cseCoord) {
          this.map.flyTo({
            center: cseCoord,
            zoom: 17,
          });
        }
      }
    },

    getModalities: {
      deep: true,
      handler() {
        // console.log("modalities changed! ", this.modalities);
        // console.log(val);
        //reset the FL desc selection
        this.setSelectedFlDesc("");

        this.filterFLs();
        this.filterConnectionsLayers();
        // this.filterCSEsByModalities();
        this.filterCSEs();
        this.filterFlTempLayer();
        this.filterCSETempLayer();
        this.filterCSATempLAyer();
        this.clearSelRecActionHistContractMenus();
      },
    },

    contractStatus: {
      deep: true,
      handler() {
        // console.log("contractStatus changed!");
        // console.log(val);

        this.filterFLs();
        this.filterConnectionsLayers();
        this.filterFlTempLayer();
        this.filterCSETempLayer();
        this.filterCSATempLAyer();
        this.clearSelRecActionHistContractMenus();
      },
    },

    cseStatus: {
      deep: true,
      handler() {
        this.filterCSEs();
        this.filterConnectionsLayers();
        this.filterFlTempLayer();
        this.filterCSETempLayer();
        this.filterCSATempLAyer();
      },
    },

    regions: {
      deep: true,
      handler() {
        // console.log("active regions changed ", val);

        this.filterFLs();
        this.filterConnectionsLayers();
        this.filterCSEs();
        this.filterFlTempLayer();
        this.filterCSETempLayer();
        this.filterCSATempLAyer();
        this.clearSelRecActionHistContractMenus();

        //todo filter reccomandations/actions hist or do it in state?
      },
    },

    selectedFlDesc: function (val) {
      console.log("selectedFlDesc changed! ", val);
      this.filterFLs();
      this.filterConnectionsLayers();
      this.filterFlTempLayer();
      this.filterCSETempLayer();
      this.filterCSATempLAyer();
      this.clearSelRecActionHistContractMenus();
    },

    selectedCSEdisplayedConnections: {
      deep: true,
      handler() {
        // console.log("selectedCSEdisplayedConnections changed!");
        // console.log(val);

        this.filterFlTempLayer();
        this.filterCSETempLayer();
        this.filterCSATempLAyer();
      },
    },

    filterCSEbySelectedModalities: function () {
      // this.filterCSEsByModalities();
      this.filterCSEs();
      this.filterConnectionsLayers();
      this.filterFlTempLayer();
      this.filterCSETempLayer();
      this.filterCSATempLAyer();
    },

    filterCSEbySelectedPlantSections: function () {
      this.filterCSEs();
      this.filterConnectionsLayers();
      this.filterFlTempLayer();
      this.filterCSETempLayer();
      this.filterCSATempLAyer();
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}
.mapboxgl-map {
  font-family: "siemens sans", sans-serif;
}
.mapboxgl-popup-content {
  text-align: center;
  font-family: "siemens sans", sans-serif;
  // color: red !important;
}

.column-list {
  display: flex;
  flex-flow: wrap column;
  max-height: 150px;
  // column-count: 4;
  list-style-type: none;
  padding-left: 0;
}

.buttonsFooter {
  display: flex;
  bottom: 8px;
  position: inherit;
  right: 16px;
}

.accordionStyling {
  opacity: 0.9;
  text-align: center;
}

.specialMenuItem {
  margin-top: -10px;
}

.recItemMenu {
  margin-left: -100%;
  width: 100%;
  border-radius: 3px;
  // outline: 0.05rem solid #d9d9d9;
  // outline-offset: 0.1rem;
  // border-bottom: 0.05rem solid #d9d9d9;
  padding-bottom: 5px;
  box-shadow: 0px 2px 10px -3px rgba(0, 0, 0, 0.2);
}
</style>
